// Mock data generator for different games

// Map topic IDs to subject types
const topicToSubjectMap = {
  // Little Explorer (3-5 years) topics
  'abc-adventures': 'abc',
  'counting-fun': 'counting',
  'colors-shapes': 'colors',
  'animal-friends': 'animals',
  'safety-first': 'safety',
  'transportation': 'transportation',
  'reading': 'reading',
  'nature-outdoors': 'nature',
  'daily-activities': 'daily',
  'food': 'food',
  // Young Scholar (6-8 years) topics
  'geography': 'geography',
  'history': 'history',
  'true-false': 'truefalse',
  'art-creativity': 'art',
  'health-wellness': 'health',
  // Smart Champion (9-12 years) topics
  'financial-literacy': 'financial',
  'social-emotional': 'sel',
  'critical-thinking': 'critical',
  // Original subjects (for backwards compatibility)
  'math': 'math',
  'language': 'language',
  'science': 'science',
  'mixed': 'mixed'
};

export const getQuizQuestions = (ageGroup, subject) => {
  // Map the topic ID to the internal subject type
  const mappedSubject = topicToSubjectMap[subject] || subject;
  
  const questionBank = {
    preschool: {
      // ABC Adventures - Letter Learning (4 Quiz Rounds)
      abc: [
        // Quiz 1: Basic Letters A-F
        [
          { question: 'What letter is this? A', options: ['A', 'B', 'C', 'D'], correctAnswer: 0 },
          { question: 'What letter comes after A?', options: ['C', 'B', 'D', 'E'], correctAnswer: 1 },
          { question: 'Which word starts with "B"?', options: ['Apple', 'Bear', 'Cat', 'Dog'], correctAnswer: 1 },
          { question: 'A is for...', options: ['Ball', 'Cat', 'Apple', 'Dog'], correctAnswer: 2 },
          { question: 'What sound does "S" make?', options: ['Buh', 'Mmm', 'Sss', 'Tuh'], correctAnswer: 2 },
          { question: 'Which letter looks like a circle?', options: ['A', 'B', 'O', 'T'], correctAnswer: 2 },
          { question: 'C is for...', options: ['Apple', 'Ball', 'Cat', 'Dog'], correctAnswer: 2 },
          { question: 'What letter does "Dog" start with?', options: ['B', 'C', 'D', 'E'], correctAnswer: 2 },
          { question: 'Which is a vowel?', options: ['B', 'E', 'D', 'F'], correctAnswer: 1 },
          { question: 'What letter makes "mmm" sound?', options: ['B', 'M', 'N', 'D'], correctAnswer: 1 }
        ],
        // Quiz 2: Letters G-L
        [
          { question: 'G is for...', options: ['Grapes', 'Apple', 'Banana', 'Orange'], correctAnswer: 0 },
          { question: 'What letter does "Hat" start with?', options: ['G', 'H', 'I', 'J'], correctAnswer: 1 },
          { question: 'Which letter looks like a stick? |', options: ['O', 'S', 'I', 'C'], correctAnswer: 2 },
          { question: 'J is for...', options: ['Jam', 'Juice', 'Jelly', 'All of these!'], correctAnswer: 3 },
          { question: 'What comes after H?', options: ['G', 'I', 'J', 'K'], correctAnswer: 1 },
          { question: 'K is for...', options: ['Kite', 'Cat', 'Dog', 'Ball'], correctAnswer: 0 },
          { question: 'What letter does "Lion" start with?', options: ['K', 'L', 'M', 'N'], correctAnswer: 1 },
          { question: 'Which word starts with "I"?', options: ['Apple', 'Ball', 'Ice Cream', 'Dog'], correctAnswer: 2 },
          { question: 'L is for...', options: ['Lemon', 'Apple', 'Orange', 'Grape'], correctAnswer: 0 },
          { question: 'What sound does "G" make?', options: ['Guh', 'Buh', 'Duh', 'Puh'], correctAnswer: 0 }
        ],
        // Quiz 3: Letters M-R
        [
          { question: 'M is for...', options: ['Sun', 'Moon', 'Star', 'Cloud'], correctAnswer: 1 },
          { question: 'What letter does "Nest" start with?', options: ['M', 'N', 'O', 'P'], correctAnswer: 1 },
          { question: 'O looks like what shape?', options: ['Square', 'Triangle', 'Circle', 'Rectangle'], correctAnswer: 2 },
          { question: 'P is for...', options: ['Dog', 'Cat', 'Pig', 'Bird'], correctAnswer: 2 },
          { question: 'What comes after O?', options: ['N', 'P', 'Q', 'R'], correctAnswer: 1 },
          { question: 'Q is for...', options: ['King', 'Queen', 'Prince', 'Princess'], correctAnswer: 1 },
          { question: 'R is for...', options: ['Rainbow', 'Sun', 'Moon', 'Star'], correctAnswer: 0 },
          { question: 'What letter does "Monkey" start with?', options: ['L', 'M', 'N', 'O'], correctAnswer: 1 },
          { question: 'N is for...', options: ['Apple', 'Nut', 'Orange', 'Grape'], correctAnswer: 1 },
          { question: 'What sound does "R" make?', options: ['Puh', 'Rrr', 'Sss', 'Tuh'], correctAnswer: 1 }
        ],
        // Quiz 4: Letters S-Z
        [
          { question: 'S is for...', options: ['Moon', 'Star', 'Sun', 'Cloud'], correctAnswer: 2 },
          { question: 'T is for...', options: ['Flower', 'Tree', 'Grass', 'Bush'], correctAnswer: 1 },
          { question: 'What letter does "Umbrella" start with?', options: ['T', 'U', 'V', 'W'], correctAnswer: 1 },
          { question: 'V is for...', options: ['Guitar', 'Piano', 'Violin', 'Drum'], correctAnswer: 2 },
          { question: 'W is for...', options: ['Fire', 'Water', 'Earth', 'Air'], correctAnswer: 1 },
          { question: 'X is in...', options: ['Cat', 'Dog', 'Box', 'Hat'], correctAnswer: 2 },
          { question: 'Y is for...', options: ['Red', 'Blue', 'Yellow', 'Green'], correctAnswer: 2 },
          { question: 'Z is for...', options: ['Lion', 'Tiger', 'Zebra', 'Giraffe'], correctAnswer: 2 },
          { question: 'What is the last letter of the alphabet?', options: ['X', 'Y', 'Z', 'W'], correctAnswer: 2 },
          { question: 'How many letters are in the alphabet?', options: ['24', '25', '26', '27'], correctAnswer: 2 }
        ]
      ],
      
      // Counting Fun - Numbers (4 Quiz Rounds)
      counting: [
        // Quiz 1: Numbers 1-5
        [
          { question: 'How many apples?', options: ['1', '2', '3', '4'], correctAnswer: 2 },
          { question: 'What comes after 2?', options: ['1', '3', '4', '5'], correctAnswer: 1 },
          { question: 'Count the stars:', options: ['2', '3', '4', '5'], correctAnswer: 2 },
          { question: '1 + 1 = ?', options: ['1', '2', '3', '4'], correctAnswer: 1 },
          { question: 'How many hearts?', options: ['1', '2', '3', '4'], correctAnswer: 1 },
          { question: 'Count:', options: ['4', '5', '6', '7'], correctAnswer: 1 },
          { question: 'What number is this: 5', options: ['Three', 'Four', 'Five', 'Six'], correctAnswer: 2 },
          { question: '2 + 1 = ?', options: ['2', '3', '4', '5'], correctAnswer: 1 },
          { question: 'How many fingers on one hand?', options: ['3', '4', '5', '6'], correctAnswer: 2 },
          { question: 'Which is bigger: 3 or 5?', options: ['3', '5'], correctAnswer: 1 }
        ],
        // Quiz 2: Numbers 6-10
        [
          { question: 'Count the fish:', options: ['4', '5', '6', '7'], correctAnswer: 2 },
          { question: 'What comes after 7?', options: ['6', '8', '9', '10'], correctAnswer: 1 },
          { question: '3 + 4 = ?', options: ['6', '7', '8', '9'], correctAnswer: 1 },
          { question: 'How many:', options: ['6', '7', '8', '9'], correctAnswer: 2 },
          { question: 'What comes before 10?', options: ['7', '8', '9', '11'], correctAnswer: 2 },
          { question: '5 + 5 = ?', options: ['8', '9', '10', '11'], correctAnswer: 2 },
          { question: 'Count:', options: ['5', '6', '7', '8'], correctAnswer: 2 },
          { question: 'Which is smaller: 6 or 9?', options: ['6', '9'], correctAnswer: 0 },
          { question: '4 + 3 = ?', options: ['5', '6', '7', '8'], correctAnswer: 2 },
          { question: 'How many toes on two feet?', options: ['8', '10', '12', '14'], correctAnswer: 1 }
        ],
        // Quiz 3: Simple Addition
        [
          { question: '2 + 2 = ?', options: ['3', '4', '5', '6'], correctAnswer: 1 },
          { question: '1 + 4 = ?', options: ['4', '5', '6', '7'], correctAnswer: 1 },
          { question: '3 + 3 = ?', options: ['5', '6', '7', '8'], correctAnswer: 1 },
          { question: '2 + 5 = ?', options: ['6', '7', '8', '9'], correctAnswer: 1 },
          { question: '4 + 4 = ?', options: ['6', '7', '8', '9'], correctAnswer: 2 },
          { question: '1 + 6 = ?', options: ['5', '6', '7', '8'], correctAnswer: 2 },
          { question: '3 + 5 = ?', options: ['7', '8', '9', '10'], correctAnswer: 1 },
          { question: '2 + 6 = ?', options: ['6', '7', '8', '9'], correctAnswer: 2 },
          { question: '4 + 5 = ?', options: ['7', '8', '9', '10'], correctAnswer: 2 },
          { question: '1 + 8 = ?', options: ['7', '8', '9', '10'], correctAnswer: 2 }
        ],
        // Quiz 4: Comparing & Ordering
        [
          { question: 'Which is bigger: 4 or 7?', options: ['4', '7'], correctAnswer: 1 },
          { question: 'Which is smaller: 8 or 3?', options: ['8', '3'], correctAnswer: 1 },
          { question: 'What comes between 5 and 7?', options: ['4', '6', '8', '9'], correctAnswer: 1 },
          { question: 'Put in order: 3, 1, 2', options: ['3,1,2', '2,1,3', '1,2,3', '1,3,2'], correctAnswer: 2 },
          { question: 'Which is biggest: 2, 5, 3?', options: ['2', '5', '3'], correctAnswer: 1 },
          { question: 'What comes after 10?', options: ['9', '10', '11', '12'], correctAnswer: 2 },
          { question: 'Which is smallest: 7, 4, 9?', options: ['7', '4', '9'], correctAnswer: 1 },
          { question: 'Count backwards: 5, 4, 3, ?, 1', options: ['0', '2', '6', '5'], correctAnswer: 1 },
          { question: 'How many days in a week?', options: ['5', '6', '7', '8'], correctAnswer: 2 },
          { question: 'Which is even: 3, 5, 6, 7?', options: ['3', '5', '6', '7'], correctAnswer: 2 }
        ]
      ],
      
      // Colors & Shapes
      colors: [
        {
          question: 'What color is the sky?',
          options: ['Red', 'Blue', 'Green', 'Yellow'],
          correctAnswer: 1
        },
        {
          question: 'What shape is this?',
          options: ['Square', 'Triangle', 'Circle', 'Rectangle'],
          correctAnswer: 2
        },
        {
          question: 'What color is grass?',
          options: ['Red', 'Blue', 'Green', 'Yellow'],
          correctAnswer: 2
        },
        {
          question: 'How many sides does a triangle have?',
          options: ['2', '3', '4', '5'],
          correctAnswer: 1
        },
        {
          question: 'What color is a banana?',
          options: ['Red', 'Blue', 'Green', 'Yellow'],
          correctAnswer: 3
        },
        {
          question: 'What shape has 4 equal sides?',
          options: ['Circle', 'Triangle', 'Square', 'Star'],
          correctAnswer: 2
        },
        {
          question: 'What color do you get mixing red and yellow?',
          options: ['Purple', 'Orange', 'Green', 'Blue'],
          correctAnswer: 1
        },
        {
          question: 'What color is a strawberry?',
          options: ['Red', 'Blue', 'Green', 'Yellow'],
          correctAnswer: 0
        },
        {
          question: 'What shape is a ball?',
          options: ['Square', 'Triangle', 'Circle', 'Rectangle'],
          correctAnswer: 2
        },
        {
          question: 'What color is the sun?',
          options: ['Red', 'Blue', 'Green', 'Yellow'],
          correctAnswer: 3
        }
      ],
      
      // Animal Friends
      animals: [
        {
          question: 'What sound does a dog make?',
          options: ['Moo', 'Woof', 'Meow', 'Oink'],
          correctAnswer: 1
        },
        {
          question: 'What sound does a cow make?',
          options: ['Moo', 'Woof', 'Meow', 'Oink'],
          correctAnswer: 0
        },
        {
          question: 'What sound does a cat make?',
          options: ['Moo', 'Woof', 'Meow', 'Oink'],
          correctAnswer: 2
        },
        {
          question: 'Which animal has a trunk?',
          options: ['Dog', 'Elephant', 'Cat', 'Bird'],
          correctAnswer: 1
        },
        {
          question: 'Which animal can fly?',
          options: ['Dog', 'Fish', 'Bird', 'Cat'],
          correctAnswer: 2
        },
        {
          question: 'What sound does a duck make?',
          options: ['Moo', 'Woof', 'Quack', 'Meow'],
          correctAnswer: 2
        },
        {
          question: 'Where do fish live?',
          options: ['Trees', 'Water', 'Sky', 'House'],
          correctAnswer: 1
        },
        {
          question: 'Which animal hops?',
          options: ['Fish', 'Rabbit', 'Snake', 'Dog'],
          correctAnswer: 1
        },
        {
          question: 'What animal says "Oink"?',
          options: ['Cow', 'Dog', 'Pig', 'Cat'],
          correctAnswer: 2
        },
        {
          question: 'How many legs does a dog have?',
          options: ['2', '4', '6', '8'],
          correctAnswer: 1
        }
      ],
      
      // Safety First
      safety: [
        {
          question: 'What should you do before crossing the street?',
          options: ['Run across', 'Look both ways', 'Close your eyes', 'Jump'],
          correctAnswer: 1
        },
        {
          question: 'Who should you ask before talking to strangers?',
          options: ['No one', 'A grown-up you trust', 'Other kids', 'Pets'],
          correctAnswer: 1
        },
        {
          question: 'What color means STOP?',
          options: ['Green', 'Yellow', 'Red', 'Blue'],
          correctAnswer: 2
        },
        {
          question: 'What should you wear when riding a bike?',
          options: ['A hat', 'A helmet', 'Sunglasses', 'Nothing'],
          correctAnswer: 1
        },
        {
          question: 'Is it safe to touch a hot stove?',
          options: ['Yes', 'No'],
          correctAnswer: 1
        },
        {
          question: 'What should you do during a fire drill?',
          options: ['Hide', 'Run around', 'Follow the teacher calmly', 'Stay in class'],
          correctAnswer: 2
        },
        {
          question: 'Should you run by the swimming pool?',
          options: ['Yes, it\'s fun!', 'No, you might slip'],
          correctAnswer: 1
        },
        {
          question: 'What number do you call for emergencies?',
          options: ['123', '911', '000', '555'],
          correctAnswer: 1
        },
        {
          question: 'Is it safe to play with matches?',
          options: ['Yes', 'No'],
          correctAnswer: 1
        },
        {
          question: 'What color light means GO?',
          options: ['Red', 'Yellow', 'Green', 'Blue'],
          correctAnswer: 2
        }
      ],
      
      // Transportation
      transportation: [
        {
          question: 'What goes "Vroom vroom"?',
          options: ['Train', 'Car', 'Boat', 'Plane'],
          correctAnswer: 1
        },
        {
          question: 'What goes "Choo choo"?',
          options: ['Train', 'Car', 'Boat', 'Plane'],
          correctAnswer: 0
        },
        {
          question: 'What flies in the sky?',
          options: ['Train', 'Car', 'Boat', 'Plane'],
          correctAnswer: 3
        },
        {
          question: 'What floats on water?',
          options: ['Train', 'Car', 'Boat', 'Plane'],
          correctAnswer: 2
        },
        {
          question: 'How many wheels does a bicycle have?',
          options: ['1', '2', '3', '4'],
          correctAnswer: 1
        },
        {
          question: 'What vehicle has a siren?',
          options: ['Bicycle', 'Ambulance', 'Skateboard', 'Wagon'],
          correctAnswer: 1
        },
        {
          question: 'What takes you to school?',
          options: ['Rocket', 'School bus', 'Submarine', 'Spaceship'],
          correctAnswer: 1
        },
        {
          question: 'What flies into space?',
          options: ['Car', 'Train', 'Rocket', 'Boat'],
          correctAnswer: 2
        },
        {
          question: 'What has two wheels and pedals?',
          options: ['Car', 'Bicycle', 'Train', 'Plane'],
          correctAnswer: 1
        },
        {
          question: 'Fire trucks are usually what color?',
          options: ['Blue', 'Green', 'Red', 'Yellow'],
          correctAnswer: 2
        }
      ],
      
      // Reading Time
      reading: [
        {
          question: 'What do we read?',
          options: ['Food', 'Books', 'Toys', 'Water'],
          correctAnswer: 1
        },
        {
          question: 'What letter does "Book" start with?',
          options: ['A', 'B', 'C', 'D'],
          correctAnswer: 1
        },
        {
          question: '"Once upon a time" starts a...',
          options: ['Song', 'Story', 'Game', 'Meal'],
          correctAnswer: 1
        },
        {
          question: 'C-A-T spells...',
          options: ['Dog', 'Cat', 'Hat', 'Bat'],
          correctAnswer: 1
        },
        {
          question: 'D-O-G spells...',
          options: ['Dog', 'Cat', 'Dig', 'Dot'],
          correctAnswer: 0
        },
        {
          question: 'What rhymes with "cat"?',
          options: ['Dog', 'Hat', 'Car', 'Sun'],
          correctAnswer: 1
        },
        {
          question: 'What do we use to write?',
          options: ['Fork', 'Pencil', 'Cup', 'Shoe'],
          correctAnswer: 1
        },
        {
          question: 'S-U-N spells...',
          options: ['Fun', 'Run', 'Sun', 'Bun'],
          correctAnswer: 2
        },
        {
          question: 'Which word is longer: "cat" or "butterfly"?',
          options: ['Cat', 'Butterfly'],
          correctAnswer: 1
        },
        {
          question: 'Stories have a beginning, middle, and...',
          options: ['Start', 'End', 'Stop', 'Go'],
          correctAnswer: 1
        }
      ],
      
      // Nature & Outdoors
      nature: [
        {
          question: 'What color are most leaves?',
          options: ['Red', 'Blue', 'Green', 'Purple'],
          correctAnswer: 2
        },
        {
          question: 'What do bees make?',
          options: ['Milk', 'Honey', 'Water', 'Juice'],
          correctAnswer: 1
        },
        {
          question: 'What falls from the sky when it rains?',
          options: ['Candy', 'Water', 'Toys', 'Snow'],
          correctAnswer: 1
        },
        {
          question: 'What do plants need to grow?',
          options: ['Toys', 'Sun and water', 'Books', 'Candy'],
          correctAnswer: 1
        },
        {
          question: 'What do butterflies start as?',
          options: ['Eggs', 'Birds', 'Fish', 'Frogs'],
          correctAnswer: 0
        },
        {
          question: 'Where do birds live?',
          options: ['In water', 'In nests', 'Under ground', 'In caves'],
          correctAnswer: 1
        },
        {
          question: 'What comes out at night in the sky?',
          options: ['Sun', 'Moon and stars', 'Clouds only', 'Rainbow'],
          correctAnswer: 1
        },
        {
          question: 'What season has snow?',
          options: ['Summer', 'Winter', 'Spring', 'Fall'],
          correctAnswer: 1
        },
        {
          question: 'What do flowers need to grow?',
          options: ['Sunlight', 'Darkness', 'Cold', 'Ice'],
          correctAnswer: 0
        },
        {
          question: 'What animal makes silk?',
          options: ['Dog', 'Spider', 'Cat', 'Bird'],
          correctAnswer: 1
        }
      ],
      
      // Daily Activities
      daily: [
        {
          question: 'What do we do when we wake up?',
          options: ['Go to bed', 'Get up', 'Eat dinner', 'Watch TV'],
          correctAnswer: 1
        },
        {
          question: 'What do we use to brush our teeth?',
          options: ['Fork', 'Spoon', 'Toothbrush', 'Comb'],
          correctAnswer: 2
        },
        {
          question: 'What meal do we eat in the morning?',
          options: ['Dinner', 'Lunch', 'Breakfast', 'Snack'],
          correctAnswer: 2
        },
        {
          question: 'What do we wear on our feet?',
          options: ['Hat', 'Shirt', 'Shoes', 'Gloves'],
          correctAnswer: 2
        },
        {
          question: 'What do we do before eating?',
          options: ['Sleep', 'Wash hands', 'Run', 'Jump'],
          correctAnswer: 1
        },
        {
          question: 'What do we sleep in?',
          options: ['Chair', 'Table', 'Bed', 'Car'],
          correctAnswer: 2
        },
        {
          question: 'What do we use to wash our hair?',
          options: ['Soap', 'Shampoo', 'Water only', 'Lotion'],
          correctAnswer: 1
        },
        {
          question: 'When is bedtime?',
          options: ['Morning', 'Afternoon', 'Night', 'Noon'],
          correctAnswer: 2
        },
        {
          question: 'What do we say when someone gives us something?',
          options: ['Goodbye', 'Hello', 'Thank you', 'Sorry'],
          correctAnswer: 2
        },
        {
          question: 'What do we wear when it rains?',
          options: ['Swimsuit', 'Raincoat', 'Pajamas', 'Shorts'],
          correctAnswer: 1
        }
      ],
      
      // Food
      food: [
        {
          question: 'What color is an apple?',
          options: ['Blue', 'Red', 'Purple', 'Pink'],
          correctAnswer: 1
        },
        {
          question: 'What fruit is yellow and curved?',
          options: ['Apple', 'Banana', 'Grape', 'Orange'],
          correctAnswer: 1
        },
        {
          question: 'Which is a vegetable?',
          options: ['Apple', 'Banana', 'Carrot', 'Grape'],
          correctAnswer: 2
        },
        {
          question: 'What do we drink that comes from cows?',
          options: ['Juice', 'Milk', 'Soda', 'Coffee'],
          correctAnswer: 1
        },
        {
          question: 'What is orange and a fruit?',
          options: ['Apple', 'Banana', 'Orange', 'Grape'],
          correctAnswer: 2
        },
        {
          question: 'Is pizza a fruit or a food?',
          options: ['Fruit', 'Food'],
          correctAnswer: 1
        },
        {
          question: 'What do chickens give us to eat?',
          options: ['Milk', 'Eggs', 'Bread', 'Juice'],
          correctAnswer: 1
        },
        {
          question: 'Which food is sweet?',
          options: ['Lemon', 'Candy', 'Pickle', 'Onion'],
          correctAnswer: 1
        },
        {
          question: 'What do we make sandwiches with?',
          options: ['Cake', 'Bread', 'Cookie', 'Pie'],
          correctAnswer: 1
        },
        {
          question: 'Grapes grow on a...',
          options: ['Tree', 'Vine', 'Bush', 'Ground'],
          correctAnswer: 1
        }
      ],
      
      // Keep original subjects for backward compatibility
      math: [
        {
          question: 'How many apples are there?',
          options: ['1', '2', '3', '4'],
          correctAnswer: 2
        },
        {
          question: 'What comes after 2?',
          options: ['1', '3', '4', '5'],
          correctAnswer: 1
        },
        {
          question: 'Which is bigger?',
          options: ['1', '5', '3', '2'],
          correctAnswer: 1
        },
        {
          question: '1 + 1 = ?',
          options: ['1', '2', '3', '4'],
          correctAnswer: 1
        },
        {
          question: 'Count the stars:',
          options: ['2', '3', '4', '5'],
          correctAnswer: 2
        }
      ],
      language: [
        {
          question: 'What letter comes first?',
          options: ['B', 'A', 'C', 'D'],
          correctAnswer: 1
        },
        {
          question: 'Which letter makes the "mmm" sound?',
          options: ['B', 'C', 'M', 'D'],
          correctAnswer: 2
        },
        {
          question: 'A is for...',
          options: ['Ball', 'Cat', 'Apple', 'Dog'],
          correctAnswer: 2
        },
        {
          question: 'What sound does "S" make?',
          options: ['Buh', 'Mmm', 'Sss', 'Tuh'],
          correctAnswer: 2
        },
        {
          question: 'Which word starts with "D"?',
          options: ['Cat', 'Ball', 'Dog', 'Sun'],
          correctAnswer: 2
        }
      ],
      science: [
        {
          question: 'What says "Moo"?',
          options: ['Dog', 'Cat', 'Cow', 'Bird'],
          correctAnswer: 2
        },
        {
          question: 'What do plants need to grow?',
          options: ['Toys', 'Water', 'Books', 'Candy'],
          correctAnswer: 1
        },
        {
          question: 'Where do fish live?',
          options: ['Trees', 'Water', 'Sky', 'House'],
          correctAnswer: 1
        },
        {
          question: 'What gives us light during the day?',
          options: ['Moon', 'Stars', 'Sun', 'Lamp'],
          correctAnswer: 2
        },
        {
          question: 'Which animal can fly?',
          options: ['Dog', 'Cat', 'Bird', 'Fish'],
          correctAnswer: 2
        }
      ]
    },
    elementary: {
      // Math (4 Quiz Rounds)
      math: [
        // Quiz 1: Addition & Subtraction
        [
          { question: '5 + 7 = ?', options: ['10', '11', '12', '13'], correctAnswer: 2 },
          { question: '15 - 8 = ?', options: ['6', '7', '8', '9'], correctAnswer: 1 },
          { question: '23 + 47 = ?', options: ['60', '65', '70', '75'], correctAnswer: 2 },
          { question: '90 - 37 = ?', options: ['53', '54', '55', '56'], correctAnswer: 0 },
          { question: '17 + 28 = ?', options: ['43', '44', '45', '46'], correctAnswer: 2 },
          { question: '64 - 29 = ?', options: ['33', '34', '35', '36'], correctAnswer: 2 },
          { question: '125 + 75 = ?', options: ['190', '195', '200', '205'], correctAnswer: 2 },
          { question: '100 - 45 = ?', options: ['45', '50', '55', '60'], correctAnswer: 2 },
          { question: '38 + 54 = ?', options: ['90', '91', '92', '93'], correctAnswer: 2 },
          { question: '81 - 36 = ?', options: ['43', '44', '45', '46'], correctAnswer: 2 }
        ],
        // Quiz 2: Multiplication
        [
          { question: '3 × 4 = ?', options: ['7', '10', '12', '15'], correctAnswer: 2 },
          { question: '8 × 7 = ?', options: ['54', '56', '58', '60'], correctAnswer: 1 },
          { question: '6 × 8 = ?', options: ['42', '46', '48', '52'], correctAnswer: 2 },
          { question: '9 × 9 = ?', options: ['72', '81', '90', '99'], correctAnswer: 1 },
          { question: '5 × 7 = ?', options: ['30', '35', '40', '45'], correctAnswer: 1 },
          { question: '4 × 9 = ?', options: ['32', '34', '36', '38'], correctAnswer: 2 },
          { question: '7 × 6 = ?', options: ['40', '42', '44', '46'], correctAnswer: 1 },
          { question: '8 × 8 = ?', options: ['56', '60', '64', '68'], correctAnswer: 2 },
          { question: '3 × 9 = ?', options: ['24', '26', '27', '29'], correctAnswer: 2 },
          { question: '6 × 6 = ?', options: ['32', '34', '36', '38'], correctAnswer: 2 }
        ],
        // Quiz 3: Division
        [
          { question: '100 ÷ 4 = ?', options: ['20', '25', '30', '35'], correctAnswer: 1 },
          { question: '56 ÷ 8 = ?', options: ['6', '7', '8', '9'], correctAnswer: 1 },
          { question: '72 ÷ 9 = ?', options: ['7', '8', '9', '10'], correctAnswer: 1 },
          { question: '45 ÷ 5 = ?', options: ['7', '8', '9', '10'], correctAnswer: 2 },
          { question: '63 ÷ 7 = ?', options: ['7', '8', '9', '10'], correctAnswer: 2 },
          { question: '48 ÷ 6 = ?', options: ['6', '7', '8', '9'], correctAnswer: 2 },
          { question: '81 ÷ 9 = ?', options: ['7', '8', '9', '10'], correctAnswer: 2 },
          { question: '36 ÷ 4 = ?', options: ['7', '8', '9', '10'], correctAnswer: 2 },
          { question: '54 ÷ 6 = ?', options: ['7', '8', '9', '10'], correctAnswer: 2 },
          { question: '42 ÷ 7 = ?', options: ['4', '5', '6', '7'], correctAnswer: 2 }
        ],
        // Quiz 4: Fractions & Geometry
        [
          { question: 'What is half of 20?', options: ['5', '10', '15', '20'], correctAnswer: 1 },
          { question: 'What is 1/4 of 100?', options: ['20', '25', '30', '40'], correctAnswer: 1 },
          { question: 'What is 50% of 80?', options: ['30', '35', '40', '45'], correctAnswer: 2 },
          { question: 'How many sides does a triangle have?', options: ['2', '3', '4', '5'], correctAnswer: 1 },
          { question: 'How many sides does a hexagon have?', options: ['5', '6', '7', '8'], correctAnswer: 1 },
          { question: 'Perimeter of square with side 5?', options: ['15', '20', '25', '30'], correctAnswer: 1 },
          { question: 'How many degrees in a right angle?', options: ['45', '90', '180', '360'], correctAnswer: 1 },
          { question: '1/2 + 1/2 = ?', options: ['1/4', '1/2', '1', '2'], correctAnswer: 2 },
          { question: 'What is 25% of 40?', options: ['5', '10', '15', '20'], correctAnswer: 1 },
          { question: 'Area of rectangle 4×5?', options: ['9', '18', '20', '25'], correctAnswer: 2 }
        ]
      ],
      // Language (4 Quiz Rounds)
      language: [
        // Quiz 1: Opposites & Synonyms
        [
          { question: 'Opposite of "hot"?', options: ['Warm', 'Cold', 'Cool', 'Freeze'], correctAnswer: 1 },
          { question: 'Synonym for "happy"?', options: ['Sad', 'Joyful', 'Angry', 'Tired'], correctAnswer: 1 },
          { question: 'Opposite of "begin"?', options: ['Start', 'End', 'Middle', 'Continue'], correctAnswer: 1 },
          { question: 'Synonym for "big"?', options: ['Tiny', 'Small', 'Large', 'Little'], correctAnswer: 2 },
          { question: 'Opposite of "brave"?', options: ['Strong', 'Cowardly', 'Bold', 'Fierce'], correctAnswer: 1 },
          { question: 'Synonym for "fast"?', options: ['Slow', 'Quick', 'Steady', 'Still'], correctAnswer: 1 },
          { question: 'Opposite of "ancient"?', options: ['Old', 'Modern', 'Historic', 'Aged'], correctAnswer: 1 },
          { question: 'Synonym for "small"?', options: ['Large', 'Huge', 'Tiny', 'Giant'], correctAnswer: 2 },
          { question: 'Opposite of "difficult"?', options: ['Hard', 'Easy', 'Tough', 'Complex'], correctAnswer: 1 },
          { question: 'Synonym for "angry"?', options: ['Happy', 'Calm', 'Furious', 'Peaceful'], correctAnswer: 2 }
        ],
        // Quiz 2: Parts of Speech
        [
          { question: 'Which word is a verb?', options: ['Blue', 'Happy', 'Run', 'Dog'], correctAnswer: 2 },
          { question: 'Which word is a noun?', options: ['Quickly', 'Beautiful', 'Library', 'Sing'], correctAnswer: 2 },
          { question: 'What is an adjective?', options: ['Doing word', 'Naming word', 'Describing word', 'Joining word'], correctAnswer: 2 },
          { question: '"She reads books" - verb?', options: ['She', 'Reads', 'Books', 'The'], correctAnswer: 1 },
          { question: 'Which is an adverb?', options: ['Happy', 'Quickly', 'Book', 'Cat'], correctAnswer: 1 },
          { question: 'Noun in "The cat sleeps"?', options: ['The', 'Cat', 'Sleeps', 'Peacefully'], correctAnswer: 1 },
          { question: 'Which is a pronoun?', options: ['Dog', 'She', 'Run', 'Blue'], correctAnswer: 1 },
          { question: 'Adjective in "The red ball"?', options: ['The', 'Red', 'Ball', 'Is'], correctAnswer: 1 },
          { question: 'Which word is a conjunction?', options: ['Dog', 'Run', 'And', 'Tall'], correctAnswer: 2 },
          { question: 'Verb in "Birds fly south"?', options: ['Birds', 'Fly', 'South', 'The'], correctAnswer: 1 }
        ],
        // Quiz 3: Spelling & Grammar
        [
          { question: 'Correct spelling?', options: ['Becuase', 'Because', 'Becouse', 'Beacuse'], correctAnswer: 1 },
          { question: 'Plural of "child"?', options: ['Childs', 'Childes', 'Children', 'Childrens'], correctAnswer: 2 },
          { question: 'Plural of "mouse"?', options: ['Mouses', 'Mice', 'Mousies', 'Mouse'], correctAnswer: 1 },
          { question: 'Correct sentence?', options: ['She go to school', 'She goes to school', 'She going to school', 'She gone to school'], correctAnswer: 1 },
          { question: 'Past tense of "run"?', options: ['Runned', 'Running', 'Ran', 'Runs'], correctAnswer: 2 },
          { question: 'Which has silent letter?', options: ['Cat', 'Knife', 'Run', 'Jump'], correctAnswer: 1 },
          { question: 'Correct spelling?', options: ['Freind', 'Friend', 'Frend', 'Freand'], correctAnswer: 1 },
          { question: 'Past tense of "eat"?', options: ['Eated', 'Ate', 'Eaten', 'Eating'], correctAnswer: 1 },
          { question: 'Plural of "tooth"?', options: ['Tooths', 'Teeth', 'Toothes', 'Teeths'], correctAnswer: 1 },
          { question: 'Correct spelling?', options: ['Beutiful', 'Beautiful', 'Beautful', 'Beuatiful'], correctAnswer: 1 }
        ],
        // Quiz 4: Punctuation & Sentences
        [
          { question: 'What ends a question?', options: ['.', '!', '?', ','], correctAnswer: 2 },
          { question: 'Vowels in "education"?', options: ['3', '4', '5', '6'], correctAnswer: 2 },
          { question: 'Which rhymes with "cat"?', options: ['Dog', 'Bat', 'Cup', 'Sun'], correctAnswer: 1 },
          { question: 'Which is compound word?', options: ['Running', 'Butterfly', 'Jumped', 'Happily'], correctAnswer: 1 },
          { question: 'Type of sentence: "Close the door!"', options: ['Statement', 'Question', 'Command', 'Exclamation'], correctAnswer: 2 },
          { question: 'What punctuation shows excitement?', options: ['.', '!', '?', ','], correctAnswer: 1 },
          { question: 'How many syllables in "banana"?', options: ['2', '3', '4', '5'], correctAnswer: 1 },
          { question: 'Sentence type that asks?', options: ['Statement', 'Question', 'Exclamation', 'Command'], correctAnswer: 1 },
          { question: 'Which needs capital letter?', options: ['dog', 'london', 'table', 'car'], correctAnswer: 1 },
          { question: 'What separates items in a list?', options: ['.', '!', '?', ','], correctAnswer: 3 }
        ]
      ],
      // Science (4 Quiz Rounds)
      science: [
        // Quiz 1: Solar System
        [
          { question: 'How many planets in our solar system?', options: ['7', '8', '9', '10'], correctAnswer: 1 },
          { question: 'Which planet is the Red Planet?', options: ['Venus', 'Mars', 'Jupiter', 'Saturn'], correctAnswer: 1 },
          { question: 'Which planet is closest to the Sun?', options: ['Venus', 'Earth', 'Mercury', 'Mars'], correctAnswer: 2 },
          { question: 'Largest planet in solar system?', options: ['Saturn', 'Neptune', 'Jupiter', 'Uranus'], correctAnswer: 2 },
          { question: 'What is the Sun?', options: ['Planet', 'Star', 'Moon', 'Asteroid'], correctAnswer: 1 },
          { question: 'Which planet has rings?', options: ['Mars', 'Jupiter', 'Saturn', 'Venus'], correctAnswer: 2 },
          { question: 'Earth is the ___ planet from Sun?', options: ['1st', '2nd', '3rd', '4th'], correctAnswer: 2 },
          { question: 'Which is NOT a planet?', options: ['Mars', 'Pluto', 'Venus', 'Jupiter'], correctAnswer: 1 },
          { question: 'How long is one Earth year?', options: ['265 days', '365 days', '465 days', '565 days'], correctAnswer: 1 },
          { question: 'What causes day and night?', options: ['Moon', 'Sun moving', 'Earth rotating', 'Clouds'], correctAnswer: 2 }
        ],
        // Quiz 2: Animals
        [
          { question: 'How many legs does a spider have?', options: ['6', '8', '10', '12'], correctAnswer: 1 },
          { question: 'What do bees make?', options: ['Milk', 'Honey', 'Juice', 'Water'], correctAnswer: 1 },
          { question: 'What type of animal is a frog?', options: ['Mammal', 'Reptile', 'Amphibian', 'Fish'], correctAnswer: 2 },
          { question: 'Animals that eat only plants?', options: ['Carnivores', 'Herbivores', 'Omnivores', 'Insectivores'], correctAnswer: 1 },
          { question: 'How many hearts does an octopus have?', options: ['1', '2', '3', '4'], correctAnswer: 2 },
          { question: 'Which animal can change color?', options: ['Lion', 'Chameleon', 'Elephant', 'Giraffe'], correctAnswer: 1 },
          { question: 'What do caterpillars become?', options: ['Bees', 'Butterflies', 'Birds', 'Beetles'], correctAnswer: 1 },
          { question: 'Largest land animal?', options: ['Hippo', 'Rhino', 'Elephant', 'Giraffe'], correctAnswer: 2 },
          { question: 'Which bird cannot fly?', options: ['Eagle', 'Penguin', 'Crow', 'Sparrow'], correctAnswer: 1 },
          { question: 'What animal is called King of Jungle?', options: ['Tiger', 'Lion', 'Elephant', 'Bear'], correctAnswer: 1 }
        ],
        // Quiz 3: Human Body
        [
          { question: 'Largest organ in human body?', options: ['Heart', 'Liver', 'Brain', 'Skin'], correctAnswer: 3 },
          { question: 'How many bones in human body?', options: ['106', '156', '206', '256'], correctAnswer: 2 },
          { question: 'What pumps blood in body?', options: ['Brain', 'Lungs', 'Heart', 'Stomach'], correctAnswer: 2 },
          { question: 'How many senses do humans have?', options: ['3', '4', '5', '6'], correctAnswer: 2 },
          { question: 'Where is food digested?', options: ['Heart', 'Lungs', 'Stomach', 'Brain'], correctAnswer: 2 },
          { question: 'What do we breathe with?', options: ['Heart', 'Lungs', 'Stomach', 'Kidneys'], correctAnswer: 1 },
          { question: 'How many teeth do adults have?', options: ['20', '28', '32', '36'], correctAnswer: 2 },
          { question: 'What protects our brain?', options: ['Hair', 'Skull', 'Skin', 'Muscle'], correctAnswer: 1 },
          { question: 'Red blood cells carry what?', options: ['Food', 'Water', 'Oxygen', 'Vitamins'], correctAnswer: 2 },
          { question: 'Strongest muscle in body?', options: ['Arm', 'Leg', 'Heart', 'Jaw'], correctAnswer: 3 }
        ],
        // Quiz 4: Nature & Elements
        [
          { question: 'What is the largest ocean?', options: ['Atlantic', 'Indian', 'Pacific', 'Arctic'], correctAnswer: 2 },
          { question: 'What do plants produce?', options: ['Carbon Dioxide', 'Oxygen', 'Nitrogen', 'Helium'], correctAnswer: 1 },
          { question: 'What is the hardest natural substance?', options: ['Gold', 'Iron', 'Diamond', 'Platinum'], correctAnswer: 2 },
          { question: 'What is water made of?', options: ['H2O', 'CO2', 'NaCl', 'O2'], correctAnswer: 0 },
          { question: 'What force keeps us on ground?', options: ['Magnetism', 'Friction', 'Gravity', 'Pressure'], correctAnswer: 2 },
          { question: 'Boiling point of water?', options: ['90°C', '100°C', '110°C', '120°C'], correctAnswer: 1 },
          { question: 'What gas do plants need?', options: ['Oxygen', 'Carbon Dioxide', 'Nitrogen', 'Helium'], correctAnswer: 1 },
          { question: 'What causes rainbow?', options: ['Rain only', 'Sun only', 'Rain and Sun', 'Wind'], correctAnswer: 2 },
          { question: 'Which is NOT a state of matter?', options: ['Solid', 'Liquid', 'Gas', 'Energy'], correctAnswer: 3 },
          { question: 'What makes plants green?', options: ['Water', 'Sunlight', 'Chlorophyll', 'Soil'], correctAnswer: 2 }
        ]
      ],
      // World Geography (4 Quiz Rounds)
      geography: [
        // Quiz 1: Continents & Oceans
        [
          { question: 'How many continents are there?', options: ['5', '6', '7', '8'], correctAnswer: 2 },
          { question: 'What is the largest continent?', options: ['Africa', 'Asia', 'Europe', 'North America'], correctAnswer: 1 },
          { question: 'What is the largest ocean?', options: ['Atlantic', 'Pacific', 'Indian', 'Arctic'], correctAnswer: 1 },
          { question: 'Which ocean is the coldest?', options: ['Pacific', 'Atlantic', 'Indian', 'Arctic'], correctAnswer: 3 },
          { question: 'Which is the smallest continent?', options: ['Europe', 'Australia', 'Antarctica', 'South America'], correctAnswer: 1 },
          { question: 'How many oceans are there?', options: ['3', '4', '5', '6'], correctAnswer: 2 },
          { question: 'Which continent has penguins?', options: ['Africa', 'Asia', 'Antarctica', 'Europe'], correctAnswer: 2 },
          { question: 'The Atlantic is between which continents?', options: ['Asia & Australia', 'Americas & Europe/Africa', 'Australia & Africa', 'Asia & Europe'], correctAnswer: 1 },
          { question: 'Which continent has the Amazon?', options: ['Africa', 'Asia', 'South America', 'Australia'], correctAnswer: 2 },
          { question: 'Which is NOT a continent?', options: ['Europe', 'Asia', 'Arctic', 'Africa'], correctAnswer: 2 }
        ],
        // Quiz 2: Countries & Capitals
        [
          { question: 'What is the capital of France?', options: ['London', 'Paris', 'Rome', 'Berlin'], correctAnswer: 1 },
          { question: 'Which country has the Great Wall?', options: ['Japan', 'India', 'China', 'Korea'], correctAnswer: 2 },
          { question: 'What is the capital of Japan?', options: ['Beijing', 'Seoul', 'Tokyo', 'Shanghai'], correctAnswer: 2 },
          { question: 'Which country has kangaroos?', options: ['Africa', 'India', 'Australia', 'Brazil'], correctAnswer: 2 },
          { question: 'What is the capital of Italy?', options: ['Venice', 'Milan', 'Rome', 'Florence'], correctAnswer: 2 },
          { question: 'Which country has the Pyramids?', options: ['India', 'Egypt', 'Greece', 'Mexico'], correctAnswer: 1 },
          { question: 'What is the capital of Germany?', options: ['Munich', 'Berlin', 'Hamburg', 'Frankfurt'], correctAnswer: 1 },
          { question: 'Which country is the Eiffel Tower in?', options: ['Italy', 'Spain', 'France', 'UK'], correctAnswer: 2 },
          { question: 'What is the capital of Spain?', options: ['Barcelona', 'Madrid', 'Seville', 'Valencia'], correctAnswer: 1 },
          { question: 'Which country has the Taj Mahal?', options: ['Pakistan', 'India', 'Nepal', 'Bangladesh'], correctAnswer: 1 }
        ],
        // Quiz 3: Rivers & Mountains
        [
          { question: 'What is the longest river in the world?', options: ['Amazon', 'Nile', 'Mississippi', 'Yangtze'], correctAnswer: 1 },
          { question: 'What is the tallest mountain?', options: ['K2', 'Kilimanjaro', 'Mount Everest', 'Alps'], correctAnswer: 2 },
          { question: 'Which river flows through Egypt?', options: ['Amazon', 'Nile', 'Ganges', 'Thames'], correctAnswer: 1 },
          { question: 'Where is Mount Everest?', options: ['Africa', 'Europe', 'Asia', 'South America'], correctAnswer: 2 },
          { question: 'What is the largest waterfall?', options: ['Victoria Falls', 'Niagara Falls', 'Angel Falls', 'Iguazu Falls'], correctAnswer: 2 },
          { question: 'Which mountain range is in South America?', options: ['Alps', 'Himalayas', 'Andes', 'Rockies'], correctAnswer: 2 },
          { question: 'The Amazon river is in which continent?', options: ['Africa', 'South America', 'Asia', 'Europe'], correctAnswer: 1 },
          { question: 'Which is the deepest lake?', options: ['Superior', 'Baikal', 'Victoria', 'Titicaca'], correctAnswer: 1 },
          { question: 'The Grand Canyon is in which country?', options: ['Mexico', 'Canada', 'USA', 'Brazil'], correctAnswer: 2 },
          { question: 'Which river flows through London?', options: ['Seine', 'Thames', 'Rhine', 'Danube'], correctAnswer: 1 }
        ],
        // Quiz 4: World Facts
        [
          { question: 'What is the largest country?', options: ['Canada', 'China', 'USA', 'Russia'], correctAnswer: 3 },
          { question: 'What is the smallest country?', options: ['Monaco', 'Vatican City', 'San Marino', 'Malta'], correctAnswer: 1 },
          { question: 'Which country has the most people?', options: ['USA', 'India', 'China', 'Brazil'], correctAnswer: 1 },
          { question: 'Which desert is the largest?', options: ['Sahara', 'Gobi', 'Kalahari', 'Arabian'], correctAnswer: 0 },
          { question: 'Where is the Great Barrier Reef?', options: ['USA', 'Brazil', 'Australia', 'Thailand'], correctAnswer: 2 },
          { question: 'Which country has 4 seasons clearly?', options: ['Brazil', 'Singapore', 'USA', 'Kenya'], correctAnswer: 2 },
          { question: 'The equator passes through which continent?', options: ['Europe', 'Africa', 'Australia', 'Antarctica'], correctAnswer: 1 },
          { question: 'Which country is known as Land of Rising Sun?', options: ['China', 'Japan', 'Korea', 'Thailand'], correctAnswer: 1 },
          { question: 'What is an island nation?', options: ['France', 'Germany', 'Japan', 'Spain'], correctAnswer: 2 },
          { question: 'Which pole is colder?', options: ['North Pole', 'South Pole', 'Both same', 'Neither'], correctAnswer: 1 }
        ]
      ],
      // History Heroes (4 Quiz Rounds)
      history: [
        // Quiz 1: Ancient Civilizations
        [
          { question: 'Who built the pyramids?', options: ['Romans', 'Greeks', 'Egyptians', 'Aztecs'], correctAnswer: 2 },
          { question: 'What animal did knights ride?', options: ['Elephants', 'Camels', 'Horses', 'Donkeys'], correctAnswer: 2 },
          { question: 'Which civilization built the Colosseum?', options: ['Greeks', 'Romans', 'Egyptians', 'Chinese'], correctAnswer: 1 },
          { question: 'What did ancient Egyptians write with?', options: ['Pencils', 'Pens', 'Hieroglyphics', 'Computers'], correctAnswer: 2 },
          { question: 'Where did the Olympics start?', options: ['Rome', 'Egypt', 'Greece', 'China'], correctAnswer: 2 },
          { question: 'What did Egyptians put in pyramids?', options: ['Gold', 'Mummies', 'Food', 'All of these'], correctAnswer: 3 },
          { question: 'Which built the Great Wall?', options: ['Japanese', 'Chinese', 'Koreans', 'Indians'], correctAnswer: 1 },
          { question: 'Gladiators fought where?', options: ['Pyramids', 'Colosseum', 'Parthenon', 'Temple'], correctAnswer: 1 },
          { question: 'Who invented democracy?', options: ['Romans', 'Egyptians', 'Greeks', 'Persians'], correctAnswer: 2 },
          { question: 'Sphinx has body of what?', options: ['Dog', 'Horse', 'Lion', 'Eagle'], correctAnswer: 2 }
        ],
        // Quiz 2: Explorers & Discoveries
        [
          { question: 'Who discovered America in 1492?', options: ['Marco Polo', 'Christopher Columbus', 'Magellan', 'Vikings'], correctAnswer: 1 },
          { question: 'Who invented the telephone?', options: ['Thomas Edison', 'Alexander Graham Bell', 'Albert Einstein', 'Isaac Newton'], correctAnswer: 1 },
          { question: 'Who discovered gravity?', options: ['Einstein', 'Newton', 'Galileo', 'Darwin'], correctAnswer: 1 },
          { question: 'First person on the Moon?', options: ['Buzz Aldrin', 'Neil Armstrong', 'Yuri Gagarin', 'John Glenn'], correctAnswer: 1 },
          { question: 'Who sailed around the world first?', options: ['Columbus', 'Magellan', 'Cook', 'Drake'], correctAnswer: 1 },
          { question: 'Who invented the light bulb?', options: ['Bell', 'Edison', 'Tesla', 'Faraday'], correctAnswer: 1 },
          { question: 'Who discovered America before Columbus?', options: ['Vikings', 'Chinese', 'Indians', 'Egyptians'], correctAnswer: 0 },
          { question: 'First to fly an airplane?', options: ['Wright Brothers', 'Lindbergh', 'Earhart', 'Santos-Dumont'], correctAnswer: 0 },
          { question: 'Who discovered penicillin?', options: ['Pasteur', 'Fleming', 'Curie', 'Koch'], correctAnswer: 1 },
          { question: 'First satellite in space?', options: ['Apollo', 'Sputnik', 'Voyager', 'Explorer'], correctAnswer: 1 }
        ],
        // Quiz 3: Historical Events
        [
          { question: 'What powered the first cars?', options: ['Electricity', 'Steam', 'Solar', 'Wind'], correctAnswer: 1 },
          { question: 'What did dinosaurs live before?', options: ['Cats', 'Dogs', 'Humans', 'Birds'], correctAnswer: 2 },
          { question: 'What did ancient people use before paper?', options: ['Computers', 'Stone tablets', 'Plastic', 'Glass'], correctAnswer: 1 },
          { question: 'When did printing press start?', options: ['1200s', '1300s', '1400s', '1500s'], correctAnswer: 2 },
          { question: 'Industrial Revolution started where?', options: ['USA', 'France', 'Britain', 'Germany'], correctAnswer: 2 },
          { question: 'What caused Ice Age?', options: ['Volcanoes', 'Climate change', 'Humans', 'Meteors'], correctAnswer: 1 },
          { question: 'Stone Age people made tools from?', options: ['Metal', 'Stone', 'Plastic', 'Wood only'], correctAnswer: 1 },
          { question: 'When were dinosaurs alive?', options: ['Thousands years ago', 'Millions years ago', 'Hundreds years ago', 'Billions years ago'], correctAnswer: 1 },
          { question: 'First wheel was made of?', options: ['Rubber', 'Metal', 'Wood', 'Stone'], correctAnswer: 2 },
          { question: 'Cave paintings were made with?', options: ['Crayons', 'Natural colors', 'Markers', 'Ink'], correctAnswer: 1 }
        ],
        // Quiz 4: Famous Leaders
        [
          { question: 'Who was the first president of the USA?', options: ['Abraham Lincoln', 'George Washington', 'Thomas Jefferson', 'John Adams'], correctAnswer: 1 },
          { question: 'Who was Queen of Egypt?', options: ['Victoria', 'Elizabeth', 'Cleopatra', 'Mary'], correctAnswer: 2 },
          { question: 'Who led India to independence?', options: ['Nehru', 'Gandhi', 'Bose', 'Patel'], correctAnswer: 1 },
          { question: 'Who ended slavery in USA?', options: ['Washington', 'Jefferson', 'Lincoln', 'Roosevelt'], correctAnswer: 2 },
          { question: 'Who was king of Mongols?', options: ['Alexander', 'Caesar', 'Genghis Khan', 'Napoleon'], correctAnswer: 2 },
          { question: 'First female Prime Minister of UK?', options: ['Victoria', 'Elizabeth', 'Thatcher', 'May'], correctAnswer: 2 },
          { question: 'Who conquered most of Europe?', options: ['Caesar', 'Napoleon', 'Hitler', 'Charlemagne'], correctAnswer: 1 },
          { question: 'Who was Martin Luther King Jr?', options: ['President', 'Civil Rights Leader', 'Inventor', 'Explorer'], correctAnswer: 1 },
          { question: 'Alexander the Great was from?', options: ['Rome', 'Greece', 'Egypt', 'Persia'], correctAnswer: 1 },
          { question: 'Who freed the slaves in ancient Rome?', options: ['Spartacus led revolt', 'Caesar', 'Augustus', 'Nero'], correctAnswer: 0 }
        ]
      ],
      // True or False
      // True or False (4 Quiz Rounds)
      truefalse: [
        // Quiz 1: Science Facts
        [
          { question: 'TRUE or FALSE: The sun is a star', options: ['TRUE', 'FALSE'], correctAnswer: 0 },
          { question: 'TRUE or FALSE: Fish can breathe air', options: ['TRUE', 'FALSE'], correctAnswer: 1 },
          { question: 'TRUE or FALSE: The Earth is round', options: ['TRUE', 'FALSE'], correctAnswer: 0 },
          { question: 'TRUE or FALSE: Penguins can fly', options: ['TRUE', 'FALSE'], correctAnswer: 1 },
          { question: 'TRUE or FALSE: Water freezes at 0°C', options: ['TRUE', 'FALSE'], correctAnswer: 0 },
          { question: 'TRUE or FALSE: Plants need sunlight to grow', options: ['TRUE', 'FALSE'], correctAnswer: 0 },
          { question: 'TRUE or FALSE: The moon makes its own light', options: ['TRUE', 'FALSE'], correctAnswer: 1 },
          { question: 'TRUE or FALSE: Dolphins are fish', options: ['TRUE', 'FALSE'], correctAnswer: 1 },
          { question: 'TRUE or FALSE: Fire needs oxygen to burn', options: ['TRUE', 'FALSE'], correctAnswer: 0 },
          { question: 'TRUE or FALSE: Sound travels faster than light', options: ['TRUE', 'FALSE'], correctAnswer: 1 }
        ],
        // Quiz 2: Animal Facts
        [
          { question: 'TRUE or FALSE: Spiders are insects', options: ['TRUE', 'FALSE'], correctAnswer: 1 },
          { question: 'TRUE or FALSE: Bats are blind', options: ['TRUE', 'FALSE'], correctAnswer: 1 },
          { question: 'TRUE or FALSE: Elephants can jump', options: ['TRUE', 'FALSE'], correctAnswer: 1 },
          { question: 'TRUE or FALSE: Snakes have no legs', options: ['TRUE', 'FALSE'], correctAnswer: 0 },
          { question: 'TRUE or FALSE: Whales are mammals', options: ['TRUE', 'FALSE'], correctAnswer: 0 },
          { question: 'TRUE or FALSE: Kangaroos live in Africa', options: ['TRUE', 'FALSE'], correctAnswer: 1 },
          { question: 'TRUE or FALSE: Octopuses have 3 hearts', options: ['TRUE', 'FALSE'], correctAnswer: 0 },
          { question: 'TRUE or FALSE: A group of lions is called a herd', options: ['TRUE', 'FALSE'], correctAnswer: 1 },
          { question: 'TRUE or FALSE: Butterflies taste with their feet', options: ['TRUE', 'FALSE'], correctAnswer: 0 },
          { question: 'TRUE or FALSE: Sharks are mammals', options: ['TRUE', 'FALSE'], correctAnswer: 1 }
        ],
        // Quiz 3: Human Body Facts
        [
          { question: 'TRUE or FALSE: Humans have 206 bones', options: ['TRUE', 'FALSE'], correctAnswer: 0 },
          { question: 'TRUE or FALSE: Your heart is in your head', options: ['TRUE', 'FALSE'], correctAnswer: 1 },
          { question: 'TRUE or FALSE: Blood is always red', options: ['TRUE', 'FALSE'], correctAnswer: 0 },
          { question: 'TRUE or FALSE: Adults have more bones than babies', options: ['TRUE', 'FALSE'], correctAnswer: 1 },
          { question: 'TRUE or FALSE: Your brain feels no pain', options: ['TRUE', 'FALSE'], correctAnswer: 0 },
          { question: 'TRUE or FALSE: Nails grow faster in summer', options: ['TRUE', 'FALSE'], correctAnswer: 0 },
          { question: 'TRUE or FALSE: You use all parts of your brain', options: ['TRUE', 'FALSE'], correctAnswer: 0 },
          { question: 'TRUE or FALSE: Humans can survive without water for a month', options: ['TRUE', 'FALSE'], correctAnswer: 1 },
          { question: 'TRUE or FALSE: Your nose keeps growing your whole life', options: ['TRUE', 'FALSE'], correctAnswer: 0 },
          { question: 'TRUE or FALSE: Teeth are bones', options: ['TRUE', 'FALSE'], correctAnswer: 1 }
        ],
        // Quiz 4: World Facts
        [
          { question: 'TRUE or FALSE: There are 7 days in a week', options: ['TRUE', 'FALSE'], correctAnswer: 0 },
          { question: 'TRUE or FALSE: The Great Wall can be seen from space', options: ['TRUE', 'FALSE'], correctAnswer: 1 },
          { question: 'TRUE or FALSE: Mount Everest is the tallest mountain', options: ['TRUE', 'FALSE'], correctAnswer: 0 },
          { question: 'TRUE or FALSE: Greenland is covered in grass', options: ['TRUE', 'FALSE'], correctAnswer: 1 },
          { question: 'TRUE or FALSE: There are 12 months in a year', options: ['TRUE', 'FALSE'], correctAnswer: 0 },
          { question: 'TRUE or FALSE: Australia is both a country and continent', options: ['TRUE', 'FALSE'], correctAnswer: 0 },
          { question: 'TRUE or FALSE: The Pacific Ocean is the smallest', options: ['TRUE', 'FALSE'], correctAnswer: 1 },
          { question: 'TRUE or FALSE: Africa has 54 countries', options: ['TRUE', 'FALSE'], correctAnswer: 0 },
          { question: 'TRUE or FALSE: Lightning never strikes the same place twice', options: ['TRUE', 'FALSE'], correctAnswer: 1 },
          { question: 'TRUE or FALSE: A year on Earth is 365 days', options: ['TRUE', 'FALSE'], correctAnswer: 0 }
        ]
      ],
      // Art & Creativity
      art: [
        {
          question: 'What are the three primary colors?',
          options: ['Red, Blue, Yellow', 'Red, Green, Blue', 'Orange, Purple, Green', 'Pink, Black, White'],
          correctAnswer: 0
        },
        {
          question: 'Who painted the Mona Lisa?',
          options: ['Picasso', 'Leonardo da Vinci', 'Van Gogh', 'Michelangelo'],
          correctAnswer: 1
        },
        {
          question: 'What color do you get mixing blue and yellow?',
          options: ['Orange', 'Purple', 'Green', 'Brown'],
          correctAnswer: 2
        },
        {
          question: 'What tool do artists use to mix paint?',
          options: ['Brush', 'Palette', 'Canvas', 'Easel'],
          correctAnswer: 1
        },
        {
          question: 'What is a sculpture made of?',
          options: ['Paper only', 'Stone, clay, or metal', 'Just wood', 'Only glass'],
          correctAnswer: 1
        },
        {
          question: 'What do we call art made with colored paper pieces?',
          options: ['Painting', 'Drawing', 'Collage', 'Sculpture'],
          correctAnswer: 2
        },
        {
          question: 'Which color is NOT a warm color?',
          options: ['Red', 'Orange', 'Blue', 'Yellow'],
          correctAnswer: 2
        },
        {
          question: 'What famous artist cut off his ear?',
          options: ['Picasso', 'Da Vinci', 'Van Gogh', 'Monet'],
          correctAnswer: 2
        },
        {
          question: 'What do you call a picture of yourself?',
          options: ['Landscape', 'Portrait', 'Still life', 'Abstract'],
          correctAnswer: 1
        },
        {
          question: 'What shapes are used in Cubism art?',
          options: ['Circles only', 'Geometric shapes', 'Just triangles', 'No shapes'],
          correctAnswer: 1
        }
      ],
      // Health & Wellness
      health: [
        {
          question: 'How many hours of sleep do kids need?',
          options: ['5-6 hours', '7-8 hours', '9-11 hours', '12-14 hours'],
          correctAnswer: 2
        },
        {
          question: 'Which food group gives us energy?',
          options: ['Proteins', 'Carbohydrates', 'Fats', 'Vitamins'],
          correctAnswer: 1
        },
        {
          question: 'How many glasses of water should you drink daily?',
          options: ['1-2', '3-4', '6-8', '10-12'],
          correctAnswer: 2
        },
        {
          question: 'What should you do before eating?',
          options: ['Watch TV', 'Wash your hands', 'Run around', 'Take a nap'],
          correctAnswer: 1
        },
        {
          question: 'Which is a healthy snack?',
          options: ['Candy bar', 'Soda', 'Apple slices', 'Chips'],
          correctAnswer: 2
        },
        {
          question: 'Exercise makes your _____ stronger',
          options: ['Hair', 'Muscles', 'Nails', 'Ears'],
          correctAnswer: 1
        },
        {
          question: 'What vitamin comes from sunlight?',
          options: ['Vitamin A', 'Vitamin B', 'Vitamin C', 'Vitamin D'],
          correctAnswer: 3
        },
        {
          question: 'How often should you brush your teeth?',
          options: ['Once a week', 'Once a day', 'Twice a day', 'Never'],
          correctAnswer: 2
        },
        {
          question: 'Which drink is healthiest?',
          options: ['Soda', 'Energy drink', 'Water', 'Milkshake'],
          correctAnswer: 2
        },
        {
          question: 'What helps build strong bones?',
          options: ['Sugar', 'Calcium', 'Salt', 'Pepper'],
          correctAnswer: 1
        }
      ]
    },
    advanced: {
      math: [
        {
          question: 'What is 15% of 200?',
          options: ['20', '25', '30', '35'],
          correctAnswer: 2
        },
        {
          question: 'Solve: 3x = 21',
          options: ['5', '6', '7', '8'],
          correctAnswer: 2
        },
        {
          question: 'What is the square root of 144?',
          options: ['10', '11', '12', '13'],
          correctAnswer: 2
        },
        {
          question: 'What is 7²?',
          options: ['14', '42', '49', '56'],
          correctAnswer: 2
        },
        {
          question: 'What is the perimeter of a square with side 5cm?',
          options: ['15cm', '20cm', '25cm', '30cm'],
          correctAnswer: 1
        },
        {
          question: 'What is 2/3 + 1/6?',
          options: ['3/9', '5/6', '3/6', '1/2'],
          correctAnswer: 1
        },
        {
          question: 'Solve: x + 15 = 42',
          options: ['25', '27', '29', '31'],
          correctAnswer: 1
        },
        {
          question: 'What is the area of a rectangle 8m × 6m?',
          options: ['28m²', '42m²', '48m²', '56m²'],
          correctAnswer: 2
        },
        {
          question: 'What is 3³?',
          options: ['9', '18', '27', '36'],
          correctAnswer: 2
        },
        {
          question: 'Convert 0.75 to a fraction',
          options: ['1/2', '2/3', '3/4', '4/5'],
          correctAnswer: 2
        },
        {
          question: 'What is the volume of a cube with side 4cm?',
          options: ['16cm³', '48cm³', '64cm³', '80cm³'],
          correctAnswer: 2
        },
        {
          question: 'Solve: 2x - 8 = 12',
          options: ['8', '10', '12', '14'],
          correctAnswer: 1
        },
        {
          question: 'What is 25% of 360?',
          options: ['72', '80', '90', '100'],
          correctAnswer: 2
        },
        {
          question: 'What is the square root of 225?',
          options: ['13', '14', '15', '16'],
          correctAnswer: 2
        },
        {
          question: 'What angle is in a straight line?',
          options: ['90°', '120°', '180°', '360°'],
          correctAnswer: 2
        },
        {
          question: 'Simplify: 24/36',
          options: ['1/2', '2/3', '3/4', '4/5'],
          correctAnswer: 1
        },
        {
          question: 'What is π (pi) approximately?',
          options: ['2.14', '3.14', '4.14', '5.14'],
          correctAnswer: 1
        },
        {
          question: 'Solve: 5(x + 2) = 35',
          options: ['3', '5', '7', '9'],
          correctAnswer: 1
        },
        {
          question: 'What is -8 + (-5)?',
          options: ['-13', '-3', '3', '13'],
          correctAnswer: 0
        },
        {
          question: 'How many degrees in a circle?',
          options: ['90°', '180°', '270°', '360°'],
          correctAnswer: 3
        }
      ],
      language: [
        {
          question: 'What is an antonym of "abundant"?',
          options: ['Plentiful', 'Scarce', 'Many', 'Rich'],
          correctAnswer: 1
        },
        {
          question: 'Which is a metaphor?',
          options: ['He runs like the wind', 'Time is money', 'The cat meowed', 'She is tall'],
          correctAnswer: 1
        },
        {
          question: 'What is the past participle of "swim"?',
          options: ['Swam', 'Swimming', 'Swum', 'Swims'],
          correctAnswer: 2
        },
        {
          question: 'Identify the adverb: "She quickly ran home"',
          options: ['She', 'quickly', 'ran', 'home'],
          correctAnswer: 1
        },
        {
          question: 'What literary device is "The wind whispered"?',
          options: ['Simile', 'Metaphor', 'Personification', 'Alliteration'],
          correctAnswer: 2
        },
        {
          question: 'Which sentence uses a simile?',
          options: ['The sun smiled down', 'She is a star', 'Fast as lightning', 'Time flies'],
          correctAnswer: 2
        },
        {
          question: 'What is the root word in "uncomfortable"?',
          options: ['Un', 'Comfort', 'Able', 'Table'],
          correctAnswer: 1
        },
        {
          question: '"Peter Piper picked" uses what device?',
          options: ['Metaphor', 'Simile', 'Alliteration', 'Hyperbole'],
          correctAnswer: 2
        },
        {
          question: 'What is the plural of "thesis"?',
          options: ['Thesises', 'Thesis', 'Theses', 'Thesii'],
          correctAnswer: 2
        },
        {
          question: 'Identify the conjunction: "I ate cake and ice cream"',
          options: ['I', 'ate', 'and', 'cake'],
          correctAnswer: 2
        },
        {
          question: 'What type of sentence is "Close the door!"?',
          options: ['Declarative', 'Interrogative', 'Imperative', 'Exclamatory'],
          correctAnswer: 2
        },
        {
          question: 'What is an oxymoron?',
          options: ['A type of poem', 'Contradictory terms together', 'An exaggeration', 'Comparing with "like"'],
          correctAnswer: 1
        },
        {
          question: '"I could eat a horse" is an example of?',
          options: ['Simile', 'Metaphor', 'Hyperbole', 'Personification'],
          correctAnswer: 2
        },
        {
          question: 'What is the prefix in "rewrite"?',
          options: ['Re', 'Write', 'Ite', 'Writ'],
          correctAnswer: 0
        },
        {
          question: 'Which word means "to hint at"?',
          options: ['Allude', 'Elude', 'Illude', 'Delude'],
          correctAnswer: 0
        },
        {
          question: 'What is a protagonist?',
          options: ['The villain', 'The main character', 'The narrator', 'A minor character'],
          correctAnswer: 1
        },
        {
          question: 'Identify the preposition: "The book is on the table"',
          options: ['book', 'is', 'on', 'table'],
          correctAnswer: 2
        },
        {
          question: 'What is the suffix in "happiness"?',
          options: ['Hap', 'Happy', 'Ness', 'Iness'],
          correctAnswer: 2
        },
        {
          question: 'What does "affect" mean vs "effect"?',
          options: ['Both mean the same', 'Affect is a verb, effect is a noun', 'Effect is a verb, affect is a noun', 'They are antonyms'],
          correctAnswer: 1
        },
        {
          question: 'What is a homophone?',
          options: ['Same spelling, different meaning', 'Same sound, different spelling', 'Same meaning, different words', 'Opposite meanings'],
          correctAnswer: 1
        }
      ],
      science: [
        {
          question: 'What is the chemical symbol for gold?',
          options: ['Go', 'Gd', 'Au', 'Ag'],
          correctAnswer: 2
        },
        {
          question: 'What is the powerhouse of the cell?',
          options: ['Nucleus', 'Mitochondria', 'Ribosome', 'Vacuole'],
          correctAnswer: 1
        },
        {
          question: 'What is the speed of light?',
          options: ['300,000 km/s', '150,000 km/s', '450,000 km/s', '600,000 km/s'],
          correctAnswer: 0
        },
        {
          question: 'What type of rock is formed from cooled lava?',
          options: ['Sedimentary', 'Metamorphic', 'Igneous', 'Limestone'],
          correctAnswer: 2
        },
        {
          question: 'What is photosynthesis?',
          options: ['Plants making food using sunlight', 'Animals breathing', 'Water evaporating', 'Rocks breaking down'],
          correctAnswer: 0
        },
        {
          question: 'What gas makes up most of Earth\'s atmosphere?',
          options: ['Oxygen', 'Carbon Dioxide', 'Nitrogen', 'Hydrogen'],
          correctAnswer: 2
        },
        {
          question: 'What is the chemical formula for table salt?',
          options: ['H2O', 'NaCl', 'CO2', 'O2'],
          correctAnswer: 1
        },
        {
          question: 'How many chromosomes do humans have?',
          options: ['23', '46', '48', '64'],
          correctAnswer: 1
        },
        {
          question: 'What is the unit of electrical resistance?',
          options: ['Ampere', 'Volt', 'Ohm', 'Watt'],
          correctAnswer: 2
        },
        {
          question: 'What layer of Earth do we live on?',
          options: ['Core', 'Mantle', 'Crust', 'Lithosphere'],
          correctAnswer: 2
        },
        {
          question: 'What is Newton\'s First Law called?',
          options: ['Law of Gravity', 'Law of Inertia', 'Law of Motion', 'Law of Energy'],
          correctAnswer: 1
        },
        {
          question: 'What element does "Fe" represent?',
          options: ['Fluorine', 'Iron', 'Francium', 'Fermium'],
          correctAnswer: 1
        },
        {
          question: 'What is the smallest unit of life?',
          options: ['Atom', 'Molecule', 'Cell', 'Tissue'],
          correctAnswer: 2
        },
        {
          question: 'What type of energy is stored in food?',
          options: ['Kinetic', 'Thermal', 'Chemical', 'Electrical'],
          correctAnswer: 2
        },
        {
          question: 'What is the pH of pure water?',
          options: ['0', '5', '7', '14'],
          correctAnswer: 2
        },
        {
          question: 'What planet has the most moons?',
          options: ['Jupiter', 'Saturn', 'Uranus', 'Neptune'],
          correctAnswer: 1
        },
        {
          question: 'What is DNA\'s shape called?',
          options: ['Single helix', 'Double helix', 'Triple helix', 'Spiral'],
          correctAnswer: 1
        },
        {
          question: 'What causes tides on Earth?',
          options: ['Wind', 'Earth\'s rotation', 'Moon\'s gravity', 'Sun\'s heat'],
          correctAnswer: 2
        },
        {
          question: 'What is absolute zero in Celsius?',
          options: ['-273°C', '-100°C', '0°C', '-373°C'],
          correctAnswer: 0
        },
        {
          question: 'What is the study of earthquakes called?',
          options: ['Geology', 'Seismology', 'Meteorology', 'Volcanology'],
          correctAnswer: 1
        }
      ],
      // Financial Literacy
      financial: [
        {
          question: 'What is a budget?',
          options: ['A type of bank', 'A plan for spending money', 'A credit card', 'A piggy bank'],
          correctAnswer: 1
        },
        {
          question: 'Which is a NEED, not a want?',
          options: ['Video games', 'New sneakers', 'Food and shelter', 'Toys'],
          correctAnswer: 2
        },
        {
          question: 'What does "saving" mean?',
          options: ['Spending all your money', 'Keeping money for later', 'Giving money away', 'Losing money'],
          correctAnswer: 1
        },
        {
          question: 'What is interest on savings?',
          options: ['A fee you pay', 'Extra money the bank gives you', 'A type of loan', 'A credit card'],
          correctAnswer: 1
        },
        {
          question: 'If you earn $10 and spend $7, how much do you save?',
          options: ['$17', '$7', '$3', '$10'],
          correctAnswer: 2
        },
        {
          question: 'What is an entrepreneur?',
          options: ['A teacher', 'Someone who starts a business', 'A banker', 'A scientist'],
          correctAnswer: 1
        },
        {
          question: 'Which is a WANT, not a need?',
          options: ['Water', 'Medicine', 'Video games', 'Clothing'],
          correctAnswer: 2
        },
        {
          question: 'What is income?',
          options: ['Money you spend', 'Money you earn', 'Money you borrow', 'Money you lose'],
          correctAnswer: 1
        },
        {
          question: 'Why is saving important?',
          options: ['To buy everything now', 'For future needs and emergencies', 'To show off', 'It\'s not important'],
          correctAnswer: 1
        },
        {
          question: 'What is the best way to track spending?',
          options: ['Guess', 'Keep a record', 'Don\'t worry about it', 'Spend freely'],
          correctAnswer: 1
        }
      ],
      // Social-Emotional Learning
      sel: [
        {
          question: 'What is empathy?',
          options: ['Being angry', 'Understanding others\' feelings', 'Ignoring people', 'Being selfish'],
          correctAnswer: 1
        },
        {
          question: 'A good team member...',
          options: ['Does all the work alone', 'Listens and cooperates', 'Ignores others', 'Takes all the credit'],
          correctAnswer: 1
        },
        {
          question: 'What is a SMART goal?',
          options: ['A goal that\'s impossible', 'Specific, Measurable, Achievable, Relevant, Time-bound', 'A goal with no deadline', 'A secret goal'],
          correctAnswer: 1
        },
        {
          question: 'How should you handle disagreements?',
          options: ['Yell louder', 'Listen and find compromise', 'Walk away forever', 'Ignore the problem'],
          correctAnswer: 1
        },
        {
          question: 'A good leader...',
          options: ['Bosses everyone around', 'Inspires and supports others', 'Does nothing', 'Takes all the credit'],
          correctAnswer: 1
        },
        {
          question: 'What does it mean to be resilient?',
          options: ['Giving up easily', 'Bouncing back from challenges', 'Never trying', 'Being perfect'],
          correctAnswer: 1
        },
        {
          question: 'How can you show kindness?',
          options: ['Ignore others', 'Help someone in need', 'Be mean', 'Only think of yourself'],
          correctAnswer: 1
        },
        {
          question: 'What is self-awareness?',
          options: ['Not knowing yourself', 'Understanding your emotions and actions', 'Ignoring feelings', 'Being selfish'],
          correctAnswer: 1
        },
        {
          question: 'When working in a team, you should...',
          options: ['Only do your favorite parts', 'Communicate and share responsibilities', 'Let others do everything', 'Work alone'],
          correctAnswer: 1
        },
        {
          question: 'What makes a good friend?',
          options: ['Someone who lies', 'Someone trustworthy and supportive', 'Someone who ignores you', 'Someone who takes things'],
          correctAnswer: 1
        }
      ],
      // Critical Thinking
      critical: [
        {
          question: 'What is critical thinking?',
          options: ['Criticizing others', 'Analyzing and evaluating information', 'Memorizing facts', 'Guessing'],
          correctAnswer: 1
        },
        {
          question: 'If A > B and B > C, then...',
          options: ['A < C', 'A > C', 'A = C', 'Cannot determine'],
          correctAnswer: 1
        },
        {
          question: 'What should you do before believing news?',
          options: ['Share it immediately', 'Check multiple sources', 'Ignore it', 'Believe everything'],
          correctAnswer: 1
        },
        {
          question: 'Which is a fact, not an opinion?',
          options: ['Pizza is delicious', 'Blue is the best color', 'Water freezes at 0°C', 'Summer is the best season'],
          correctAnswer: 2
        },
        {
          question: 'Problem solving starts with...',
          options: ['The solution', 'Understanding the problem', 'Giving up', 'Random guessing'],
          correctAnswer: 1
        }
      ],
      // Geography Advanced (4 Quiz Rounds)
      geography: [
        // Quiz 1: Countries & Populations
        [
          { question: 'What is the largest country by land area?', options: ['China', 'USA', 'Russia', 'Canada'], correctAnswer: 2 },
          { question: 'Which country has the largest population?', options: ['USA', 'India', 'China', 'Indonesia'], correctAnswer: 1 },
          { question: 'What is the capital of Australia?', options: ['Sydney', 'Melbourne', 'Canberra', 'Perth'], correctAnswer: 2 },
          { question: 'Which continent has the most countries?', options: ['Asia', 'Africa', 'Europe', 'South America'], correctAnswer: 1 },
          { question: 'What is the smallest country by area?', options: ['Monaco', 'Vatican City', 'San Marino', 'Liechtenstein'], correctAnswer: 1 },
          { question: 'Which country has the longest coastline?', options: ['Australia', 'Russia', 'Canada', 'Indonesia'], correctAnswer: 2 },
          { question: 'Capital of Brazil?', options: ['Rio de Janeiro', 'São Paulo', 'Brasília', 'Salvador'], correctAnswer: 2 },
          { question: 'Which country is both in Europe and Asia?', options: ['Russia', 'Turkey', 'Both', 'Neither'], correctAnswer: 2 },
          { question: 'Most densely populated country?', options: ['Bangladesh', 'Monaco', 'Singapore', 'India'], correctAnswer: 1 },
          { question: 'Largest island nation?', options: ['Japan', 'Philippines', 'Indonesia', 'Madagascar'], correctAnswer: 2 }
        ],
        // Quiz 2: Physical Geography
        [
          { question: 'What is the longest river in the world?', options: ['Amazon', 'Nile', 'Mississippi', 'Yangtze'], correctAnswer: 1 },
          { question: 'Which ocean is the deepest?', options: ['Atlantic', 'Indian', 'Pacific', 'Arctic'], correctAnswer: 2 },
          { question: 'What is the smallest continent?', options: ['Europe', 'Australia', 'Antarctica', 'South America'], correctAnswer: 1 },
          { question: 'Which mountain range separates Europe and Asia?', options: ['Alps', 'Himalayas', 'Ural Mountains', 'Andes'], correctAnswer: 2 },
          { question: 'What is the driest desert on Earth?', options: ['Sahara', 'Gobi', 'Atacama', 'Arabian'], correctAnswer: 2 },
          { question: 'Deepest point in the ocean?', options: ['Challenger Deep', 'Puerto Rico Trench', 'Java Trench', 'Philippine Trench'], correctAnswer: 0 },
          { question: 'Highest waterfall?', options: ['Victoria', 'Niagara', 'Angel Falls', 'Iguazu'], correctAnswer: 2 },
          { question: 'Largest lake by surface area?', options: ['Lake Superior', 'Caspian Sea', 'Lake Victoria', 'Lake Michigan'], correctAnswer: 1 },
          { question: 'Which river flows through most countries?', options: ['Nile', 'Amazon', 'Danube', 'Mekong'], correctAnswer: 2 },
          { question: 'Oldest desert in the world?', options: ['Sahara', 'Namib', 'Atacama', 'Gobi'], correctAnswer: 1 }
        ],
        // Quiz 3: Climate & Regions
        [
          { question: 'How many time zones does Russia span? ⏰', options: ['5', '8', '11', '15'], correctAnswer: 2 },
          { question: 'Which region has the most biodiversity?', options: ['Amazon', 'Congo', 'Southeast Asia', 'All similar'], correctAnswer: 0 },
          { question: 'What causes seasons on Earth?', options: ['Distance from Sun', 'Earth\'s tilt', 'Moon\'s gravity', 'Solar wind'], correctAnswer: 1 },
          { question: 'Where is the Sahel region?', options: ['South America', 'Africa', 'Asia', 'Australia'], correctAnswer: 1 },
          { question: 'Ring of Fire is in which ocean?', options: ['Atlantic', 'Indian', 'Pacific', 'Arctic'], correctAnswer: 2 },
          { question: 'Which country has most time zones?', options: ['Russia', 'USA', 'France', 'China'], correctAnswer: 2 },
          { question: 'Coldest inhabited place?', options: ['Alaska', 'Siberia', 'Greenland', 'Antarctica'], correctAnswer: 1 },
          { question: 'What is a peninsula?', options: ['Island chain', 'Land surrounded by water on 3 sides', 'Mountain range', 'River delta'], correctAnswer: 1 },
          { question: 'Which current affects Western Europe\'s climate?', options: ['Labrador', 'Gulf Stream', 'California', 'Kuroshio'], correctAnswer: 1 },
          { question: 'Largest rainforest?', options: ['Amazon', 'Congo', 'Daintree', 'Tongass'], correctAnswer: 0 }
        ],
        // Quiz 4: World Landmarks
        [
          { question: 'Where is the Burj Khalifa?', options: ['Qatar', 'Dubai', 'Saudi Arabia', 'Kuwait'], correctAnswer: 1 },
          { question: 'Christ the Redeemer is in?', options: ['Mexico', 'Argentina', 'Brazil', 'Chile'], correctAnswer: 2 },
          { question: 'The Colosseum is in which city?', options: ['Athens', 'Rome', 'Paris', 'Madrid'], correctAnswer: 1 },
          { question: 'Machu Picchu is in which country?', options: ['Mexico', 'Colombia', 'Peru', 'Ecuador'], correctAnswer: 2 },
          { question: 'The Parthenon is in?', options: ['Rome', 'Athens', 'Istanbul', 'Cairo'], correctAnswer: 1 },
          { question: 'Where is the Sydney Opera House?', options: ['New Zealand', 'Australia', 'UK', 'Canada'], correctAnswer: 1 },
          { question: 'Petra is in which country?', options: ['Egypt', 'Iraq', 'Jordan', 'Syria'], correctAnswer: 2 },
          { question: 'Angkor Wat is where?', options: ['Thailand', 'Vietnam', 'Cambodia', 'Myanmar'], correctAnswer: 2 },
          { question: 'The Louvre Museum is in?', options: ['London', 'Paris', 'Madrid', 'Rome'], correctAnswer: 1 },
          { question: 'Mount Fuji is in?', options: ['China', 'Korea', 'Japan', 'Taiwan'], correctAnswer: 2 }
        ]
      ],
      // History Advanced (4 Quiz Rounds)
      history: [
        // Quiz 1: World Wars & Modern History
        [
          { question: 'When did World War II end?', options: ['1943', '1944', '1945', '1946'], correctAnswer: 2 },
          { question: 'What year did the Berlin Wall fall?', options: ['1985', '1987', '1989', '1991'], correctAnswer: 2 },
          { question: 'When did World War I begin?', options: ['1912', '1914', '1916', '1918'], correctAnswer: 1 },
          { question: 'Who was leader of Nazi Germany?', options: ['Mussolini', 'Hitler', 'Stalin', 'Churchill'], correctAnswer: 1 },
          { question: 'D-Day invasion was in?', options: ['1942', '1943', '1944', '1945'], correctAnswer: 2 },
          { question: 'Pearl Harbor attack year?', options: ['1939', '1940', '1941', '1942'], correctAnswer: 2 },
          { question: 'First atomic bomb used in war was at?', options: ['Nagasaki', 'Hiroshima', 'Tokyo', 'Berlin'], correctAnswer: 1 },
          { question: 'Soviet Union collapsed in?', options: ['1989', '1990', '1991', '1992'], correctAnswer: 2 },
          { question: 'Cold War was between?', options: ['US & China', 'US & USSR', 'UK & Germany', 'France & Italy'], correctAnswer: 1 },
          { question: 'UN was founded in?', options: ['1943', '1944', '1945', '1946'], correctAnswer: 2 }
        ],
        // Quiz 2: Ancient Civilizations
        [
          { question: 'Which ancient wonder still exists today?', options: ['Hanging Gardens', 'Colossus of Rhodes', 'Great Pyramid of Giza', 'Lighthouse of Alexandria'], correctAnswer: 2 },
          { question: 'Which civilization built Machu Picchu?', options: ['Aztec', 'Maya', 'Inca', 'Olmec'], correctAnswer: 2 },
          { question: 'Which empire built the Colosseum?', options: ['Greek', 'Roman', 'Persian', 'Byzantine'], correctAnswer: 1 },
          { question: 'Cleopatra was queen of?', options: ['Rome', 'Greece', 'Egypt', 'Persia'], correctAnswer: 2 },
          { question: 'The Parthenon was built for?', options: ['Zeus', 'Athena', 'Apollo', 'Poseidon'], correctAnswer: 1 },
          { question: 'Mesopotamia is known as?', options: ['Cradle of Civilization', 'Land of Pharaohs', 'Middle Kingdom', 'Eternal City'], correctAnswer: 0 },
          { question: 'Which civilization invented paper?', options: ['Greeks', 'Romans', 'Chinese', 'Egyptians'], correctAnswer: 2 },
          { question: 'Sparta was known for?', options: ['Philosophy', 'Art', 'Military', 'Trade'], correctAnswer: 2 },
          { question: 'Julius Caesar ruled?', options: ['Greece', 'Egypt', 'Rome', 'Persia'], correctAnswer: 2 },
          { question: 'Who built the Terracotta Army?', options: ['Han Dynasty', 'Tang Dynasty', 'Qin Shi Huang', 'Ming Dynasty'], correctAnswer: 2 }
        ],
        // Quiz 3: American History
        [
          { question: 'Who was the first President of the United States?', options: ['Thomas Jefferson', 'George Washington', 'Abraham Lincoln', 'John Adams'], correctAnswer: 1 },
          { question: 'Who wrote the Declaration of Independence?', options: ['Benjamin Franklin', 'Thomas Jefferson', 'John Adams', 'George Washington'], correctAnswer: 1 },
          { question: 'American Civil War ended in?', options: ['1863', '1864', '1865', '1866'], correctAnswer: 2 },
          { question: 'Who abolished slavery?', options: ['Washington', 'Jefferson', 'Lincoln', 'Roosevelt'], correctAnswer: 2 },
          { question: 'Boston Tea Party was in?', options: ['1770', '1773', '1775', '1776'], correctAnswer: 1 },
          { question: 'Declaration of Independence signed in?', options: ['1774', '1775', '1776', '1777'], correctAnswer: 2 },
          { question: 'Louisiana Purchase was from?', options: ['Britain', 'Spain', 'France', 'Mexico'], correctAnswer: 2 },
          { question: 'Which war was 1812?', options: ['French-Indian', 'War of 1812', 'Civil War', 'Mexican-American'], correctAnswer: 1 },
          { question: 'First permanent English settlement?', options: ['Plymouth', 'Jamestown', 'Boston', 'Philadelphia'], correctAnswer: 1 },
          { question: 'Emancipation Proclamation year?', options: ['1861', '1862', '1863', '1864'], correctAnswer: 2 }
        ],
        // Quiz 4: Science & Innovation History
        [
          { question: 'In what year did humans first land on the Moon?', options: ['1965', '1967', '1969', '1971'], correctAnswer: 2 },
          { question: 'Who invented the telephone?', options: ['Thomas Edison', 'Nikola Tesla', 'Alexander Graham Bell', 'Guglielmo Marconi'], correctAnswer: 2 },
          { question: 'When was the printing press invented?', options: ['1250s', '1350s', '1450s', '1550s'], correctAnswer: 2 },
          { question: 'First computer programmer was?', options: ['Charles Babbage', 'Ada Lovelace', 'Alan Turing', 'John von Neumann'], correctAnswer: 1 },
          { question: 'Who discovered penicillin?', options: ['Pasteur', 'Fleming', 'Curie', 'Koch'], correctAnswer: 1 },
          { question: 'Theory of Relativity was by?', options: ['Newton', 'Einstein', 'Hawking', 'Feynman'], correctAnswer: 1 },
          { question: 'First successful airplane flight was?', options: ['1899', '1901', '1903', '1905'], correctAnswer: 2 },
          { question: 'DNA structure discovered in?', options: ['1943', '1953', '1963', '1973'], correctAnswer: 1 },
          { question: 'Internet was invented in which decade?', options: ['1960s', '1970s', '1980s', '1990s'], correctAnswer: 0 },
          { question: 'First electric light was by?', options: ['Tesla', 'Edison', 'Bell', 'Morse'], correctAnswer: 1 }
        ]
      ]
    }
  };

  const mixedQuestions = (age) => {
    const subjects = ['math', 'language', 'science'];
    const mixed = [];
    subjects.forEach(subj => {
      const questions = questionBank[age][subj];
      if (questions) {
        mixed.push(...questions.slice(0, 2));
      }
    });
    return mixed.sort(() => Math.random() - 0.5);
  };

  if (mappedSubject === 'mixed') {
    return mixedQuestions(ageGroup);
  }

  // Try to get questions for the mapped subject, fallback to math if not found
  return questionBank[ageGroup]?.[mappedSubject] || questionBank[ageGroup]?.math || questionBank.preschool.math;
};

export const getMemoryCards = (ageGroup, subject) => {
  // Map the topic ID to the internal subject type
  const mappedSubject = topicToSubjectMap[subject] || subject;
  
  const cardSets = {
    preschool: {
      // ABC Adventures - Letters (3 rounds)
      abc: [
        [
          { value: 'A', display: 'A' },
          { value: 'B', display: 'B' },
          { value: 'C', display: 'C' },
          { value: 'D', display: 'D' },
          { value: 'E', display: 'E' },
          { value: 'F', display: 'F' }
        ],
        [
          { value: 'G', display: 'G' },
          { value: 'H', display: 'H' },
          { value: 'I', display: 'I' },
          { value: 'J', display: 'J' },
          { value: 'K', display: 'K' },
          { value: 'L', display: 'L' }
        ],
        [
          { value: 'M', display: 'M' },
          { value: 'N', display: 'N' },
          { value: 'O', display: 'O' },
          { value: 'P', display: 'P' },
          { value: 'Q', display: 'Q' },
          { value: 'R', display: 'R' }
        ]
      ],
      // Counting Fun - Numbers (3 rounds)
      counting: [
        [
          { value: 1, display: '1️⃣' },
          { value: 2, display: '2️⃣' },
          { value: 3, display: '3️⃣' },
          { value: 4, display: '4️⃣' },
          { value: 5, display: '5️⃣' },
          { value: 6, display: '6️⃣' }
        ],
        [
          { value: 7, display: '7️⃣' },
          { value: 8, display: '8️⃣' },
          { value: 9, display: '9️⃣' },
          { value: 10, display: '🔟' },
          { value: 'zero', display: '0️⃣' },
          { value: 'hundred', display: '💯' }
        ],
        [
          { value: 'one-apple', display: '🍎' },
          { value: 'two-stars', display: '⭐⭐' },
          { value: 'three-hearts', display: '❤️❤️❤️' },
          { value: 'four-balls', display: '⚽⚽⚽⚽' },
          { value: 'five-flowers', display: '🌸🌸🌸🌸🌸' },
          { value: 'six-fish', display: '🐟🐟🐟🐟🐟🐟' }
        ]
      ],
      // Colors & Shapes (3 rounds)
      colors: [
        [
          { value: 'red', display: '🔴' },
          { value: 'blue', display: '🔵' },
          { value: 'yellow', display: '🟡' },
          { value: 'green', display: '🟢' },
          { value: 'purple', display: '🟣' },
          { value: 'orange', display: '🟠' }
        ],
        [
          { value: 'square', display: '🟥' },
          { value: 'circle', display: '⭕' },
          { value: 'triangle', display: '🔺' },
          { value: 'star', display: '⭐' },
          { value: 'heart', display: '❤️' },
          { value: 'diamond', display: '💎' }
        ],
        [
          { value: 'rainbow', display: '🌈' },
          { value: 'white', display: '⬜' },
          { value: 'black', display: '⬛' },
          { value: 'brown', display: '🟫' },
          { value: 'pink', display: '💗' },
          { value: 'gold', display: '🏆' }
        ]
      ],
      // Animal Friends (3 rounds)
      animals: [
        [
          { value: 'cat', display: '🐱' },
          { value: 'dog', display: '🐶' },
          { value: 'bird', display: '🐦' },
          { value: 'fish', display: '🐟' },
          { value: 'rabbit', display: '🐰' },
          { value: 'bear', display: '🐻' }
        ],
        [
          { value: 'lion', display: '🦁' },
          { value: 'elephant', display: '🐘' },
          { value: 'monkey', display: '🐵' },
          { value: 'giraffe', display: '🦒' },
          { value: 'zebra', display: '🦓' },
          { value: 'hippo', display: '🦛' }
        ],
        [
          { value: 'butterfly', display: '🦋' },
          { value: 'ladybug', display: '🐞' },
          { value: 'bee', display: '🐝' },
          { value: 'snail', display: '🐌' },
          { value: 'frog', display: '🐸' },
          { value: 'turtle', display: '🐢' }
        ]
      ],
      // Safety First (3 rounds)
      safety: [
        [
          { value: 'stop', display: '🛑' },
          { value: 'go', display: '🟢' },
          { value: 'helmet', display: '⛑️' },
          { value: 'cross', display: '🚸' },
          { value: 'phone', display: '📞' },
          { value: 'fire', display: '🚒' }
        ],
        [
          { value: 'police', display: '👮' },
          { value: 'ambulance', display: '🚑' },
          { value: 'seatbelt', display: '🪢' },
          { value: 'traffic', display: '🚦' },
          { value: 'warning', display: '⚠️' },
          { value: 'exit', display: '🚪' }
        ],
        [
          { value: 'medicine', display: '💊' },
          { value: 'bandage', display: '🩹' },
          { value: 'soap', display: '🧼' },
          { value: 'shield', display: '🛡️' },
          { value: 'guard', display: '💂' },
          { value: 'lock', display: '🔒' }
        ]
      ],
      // Transportation (3 rounds)
      transportation: [
        [
          { value: 'car', display: '🚗' },
          { value: 'bus', display: '🚌' },
          { value: 'train', display: '🚂' },
          { value: 'plane', display: '✈️' },
          { value: 'boat', display: '⛵' },
          { value: 'bike', display: '🚲' }
        ],
        [
          { value: 'helicopter', display: '🚁' },
          { value: 'rocket', display: '🚀' },
          { value: 'truck', display: '🚚' },
          { value: 'taxi', display: '🚕' },
          { value: 'motorcycle', display: '🏍️' },
          { value: 'scooter', display: '🛴' }
        ],
        [
          { value: 'ship', display: '🚢' },
          { value: 'canoe', display: '🛶' },
          { value: 'tractor', display: '🚜' },
          { value: 'ambulance', display: '🚑' },
          { value: 'firetruck', display: '🚒' },
          { value: 'police-car', display: '🚓' }
        ]
      ],
      // Food (3 rounds)
      food: [
        [
          { value: 'apple', display: '🍎' },
          { value: 'banana', display: '🍌' },
          { value: 'carrot', display: '🥕' },
          { value: 'milk', display: '🥛' },
          { value: 'bread', display: '🍞' },
          { value: 'egg', display: '🥚' }
        ],
        [
          { value: 'pizza', display: '🍕' },
          { value: 'burger', display: '🍔' },
          { value: 'hotdog', display: '🌭' },
          { value: 'icecream', display: '🍦' },
          { value: 'cake', display: '🎂' },
          { value: 'cookie', display: '🍪' }
        ],
        [
          { value: 'watermelon', display: '🍉' },
          { value: 'grapes', display: '🍇' },
          { value: 'orange', display: '🍊' },
          { value: 'strawberry', display: '🍓' },
          { value: 'cherry', display: '🍒' },
          { value: 'peach', display: '🍑' }
        ]
      ],
      // Nature (3 rounds)
      nature: [
        [
          { value: 'tree', display: '🌳' },
          { value: 'flower', display: '🌸' },
          { value: 'sun', display: '☀️' },
          { value: 'rain', display: '🌧️' },
          { value: 'butterfly', display: '🦋' },
          { value: 'bee', display: '🐝' }
        ],
        [
          { value: 'mountain', display: '🏔️' },
          { value: 'ocean', display: '🌊' },
          { value: 'cloud', display: '☁️' },
          { value: 'rainbow', display: '🌈' },
          { value: 'moon', display: '🌙' },
          { value: 'star', display: '⭐' }
        ],
        [
          { value: 'leaf', display: '🍃' },
          { value: 'mushroom', display: '🍄' },
          { value: 'cactus', display: '🌵' },
          { value: 'palm', display: '🌴' },
          { value: 'snowflake', display: '❄️' },
          { value: 'fire', display: '🔥' }
        ]
      ],
      // Math (3 rounds)
      math: [
        [
          { value: 1, display: '1' },
          { value: 2, display: '2' },
          { value: 3, display: '3' },
          { value: 4, display: '4' },
          { value: 5, display: '5' },
          { value: 6, display: '6' }
        ],
        [
          { value: 'circle', display: '⭕' },
          { value: 'square', display: '🟥' },
          { value: 'triangle', display: '🔺' },
          { value: 'star', display: '⭐' },
          { value: 'heart', display: '❤️' },
          { value: 'diamond', display: '💎' }
        ],
        [
          { value: 'plus', display: '➕' },
          { value: 'minus', display: '➖' },
          { value: 'equals', display: '🟰' },
          { value: 'bigger', display: '>' },
          { value: 'smaller', display: '<' },
          { value: 'question', display: '❓' }
        ]
      ],
      // Language (3 rounds)
      language: [
        [
          { value: 'A', display: 'A' },
          { value: 'B', display: 'B' },
          { value: 'C', display: 'C' },
          { value: 'D', display: 'D' },
          { value: 'E', display: 'E' },
          { value: 'F', display: 'F' }
        ],
        [
          { value: 'book', display: '📚' },
          { value: 'pencil', display: '✏️' },
          { value: 'paper', display: '📄' },
          { value: 'crayon', display: '🖍️' },
          { value: 'school', display: '🏫' },
          { value: 'teacher', display: '👩‍🏫' }
        ],
        [
          { value: 'cat-word', display: 'CAT' },
          { value: 'dog-word', display: 'DOG' },
          { value: 'hat-word', display: 'HAT' },
          { value: 'sun-word', display: 'SUN' },
          { value: 'run-word', display: 'RUN' },
          { value: 'fun-word', display: 'FUN' }
        ]
      ],
      // Science (3 rounds)
      science: [
        [
          { value: 'cat', display: '🐱' },
          { value: 'dog', display: '🐶' },
          { value: 'bird', display: '🐦' },
          { value: 'fish', display: '🐟' },
          { value: 'tree', display: '🌳' },
          { value: 'flower', display: '🌸' }
        ],
        [
          { value: 'sun', display: '☀️' },
          { value: 'moon', display: '🌙' },
          { value: 'star', display: '⭐' },
          { value: 'cloud', display: '☁️' },
          { value: 'rain', display: '🌧️' },
          { value: 'snow', display: '❄️' }
        ],
        [
          { value: 'hot', display: '🔥' },
          { value: 'cold', display: '🧊' },
          { value: 'water', display: '💧' },
          { value: 'rock', display: '🪨' },
          { value: 'sand', display: '🏖️' },
          { value: 'grass', display: '🌱' }
        ]
      ]
    },
    elementary: {
      // Math (3 rounds)
      math: [
        [
          { value: '2+2', display: '2+2=4' },
          { value: '3+3', display: '3+3=6' },
          { value: '5+5', display: '5+5=10' },
          { value: '4×2', display: '4×2=8' },
          { value: '3×3', display: '3×3=9' },
          { value: '6÷2', display: '6÷2=3' }
        ],
        [
          { value: '7+3', display: '7+3=10' },
          { value: '8-4', display: '8-4=4' },
          { value: '2×5', display: '2×5=10' },
          { value: '9÷3', display: '9÷3=3' },
          { value: '4+6', display: '4+6=10' },
          { value: '5×2', display: '5×2=10' }
        ],
        [
          { value: 'even', display: '2,4,6' },
          { value: 'odd', display: '1,3,5' },
          { value: 'dozen', display: '12' },
          { value: 'half', display: '½' },
          { value: 'quarter', display: '¼' },
          { value: 'double', display: '×2' }
        ]
      ],
      // Language (3 rounds)
      language: [
        [
          { value: 'happy', display: 'Happy 😊' },
          { value: 'sad', display: 'Sad 😢' },
          { value: 'run', display: 'Run 🏃' },
          { value: 'jump', display: 'Jump 🦘' },
          { value: 'read', display: 'Read 📖' },
          { value: 'write', display: 'Write ✍️' }
        ],
        [
          { value: 'noun', display: 'Noun' },
          { value: 'verb', display: 'Verb' },
          { value: 'adjective', display: 'Adjective' },
          { value: 'sentence', display: 'Sentence' },
          { value: 'paragraph', display: 'Paragraph' },
          { value: 'story', display: 'Story' }
        ],
        [
          { value: 'capital', display: 'ABC' },
          { value: 'lowercase', display: 'abc' },
          { value: 'period', display: '.' },
          { value: 'question', display: '?' },
          { value: 'exclaim', display: '!' },
          { value: 'comma', display: ',' }
        ]
      ],
      // Science (3 rounds)
      science: [
        [
          { value: 'sun', display: '☀️' },
          { value: 'moon', display: '🌙' },
          { value: 'earth', display: '🌍' },
          { value: 'water', display: '💧' },
          { value: 'fire', display: '🔥' },
          { value: 'leaf', display: '🍃' }
        ],
        [
          { value: 'solid', display: '🧊' },
          { value: 'liquid', display: '💧' },
          { value: 'gas', display: '💨' },
          { value: 'magnet', display: '🧲' },
          { value: 'battery', display: '🔋' },
          { value: 'light', display: '💡' }
        ],
        [
          { value: 'plant', display: '🌱' },
          { value: 'animal', display: '🐾' },
          { value: 'insect', display: '🐛' },
          { value: 'bird', display: '🐦' },
          { value: 'fish', display: '🐟' },
          { value: 'mammal', display: '🐘' }
        ]
      ],
      // Geography (3 rounds)
      geography: [
        [
          { value: 'globe', display: '🌍' },
          { value: 'map', display: '🗺️' },
          { value: 'mountain', display: '🏔️' },
          { value: 'ocean', display: '🌊' },
          { value: 'desert', display: '🏜️' },
          { value: 'forest', display: '🌲' }
        ],
        [
          { value: 'continent', display: '🌎' },
          { value: 'country', display: '🏴' },
          { value: 'city', display: '🏙️' },
          { value: 'river', display: '🏞️' },
          { value: 'lake', display: '💧' },
          { value: 'island', display: '🏝️' }
        ],
        [
          { value: 'north', display: '⬆️' },
          { value: 'south', display: '⬇️' },
          { value: 'east', display: '➡️' },
          { value: 'west', display: '⬅️' },
          { value: 'compass', display: '🧭' },
          { value: 'equator', display: '🌐' }
        ]
      ],
      // History (3 rounds)
      history: [
        [
          { value: 'castle', display: '🏰' },
          { value: 'crown', display: '👑' },
          { value: 'scroll', display: '📜' },
          { value: 'knight', display: '⚔️' },
          { value: 'pyramid', display: '🔺' },
          { value: 'flag', display: '🏴' }
        ],
        [
          { value: 'dinosaur', display: '🦖' },
          { value: 'mammoth', display: '🦣' },
          { value: 'cave', display: '🕳️' },
          { value: 'stone', display: '🪨' },
          { value: 'fossil', display: '🦴' },
          { value: 'ancient', display: '🏛️' }
        ],
        [
          { value: 'ship', display: '⛵' },
          { value: 'explorer', display: '🧭' },
          { value: 'treasure', display: '💎' },
          { value: 'map', display: '🗺️' },
          { value: 'king', display: '👑' },
          { value: 'queen', display: '👸' }
        ]
      ],
      // True or False (3 rounds)
      truefalse: [
        [
          { value: 'true', display: '✅' },
          { value: 'false', display: '❌' },
          { value: 'check', display: '☑️' },
          { value: 'question', display: '❓' },
          { value: 'think', display: '🤔' },
          { value: 'brain', display: '🧠' }
        ],
        [
          { value: 'yes', display: '👍' },
          { value: 'no', display: '👎' },
          { value: 'maybe', display: '🤷' },
          { value: 'correct', display: '💯' },
          { value: 'wrong', display: '⛔' },
          { value: 'hint', display: '💡' }
        ],
        [
          { value: 'fact', display: '📊' },
          { value: 'opinion', display: '💭' },
          { value: 'prove', display: '🔬' },
          { value: 'guess', display: '🎯' },
          { value: 'research', display: '📚' },
          { value: 'evidence', display: '🔍' }
        ]
      ],
      // Art & Creativity (3 rounds)
      art: [
        [
          { value: 'palette', display: '🎨' },
          { value: 'brush', display: '🖌️' },
          { value: 'canvas', display: '🖼️' },
          { value: 'pencil', display: '✏️' },
          { value: 'rainbow', display: '🌈' },
          { value: 'star', display: '⭐' }
        ],
        [
          { value: 'music', display: '🎵' },
          { value: 'dance', display: '💃' },
          { value: 'drama', display: '🎭' },
          { value: 'sing', display: '🎤' },
          { value: 'piano', display: '🎹' },
          { value: 'guitar', display: '🎸' }
        ],
        [
          { value: 'sculpt', display: '🗿' },
          { value: 'draw', display: '✏️' },
          { value: 'paint', display: '🖌️' },
          { value: 'craft', display: '✂️' },
          { value: 'photo', display: '📷' },
          { value: 'film', display: '🎬' }
        ]
      ],
      // Health & Wellness (3 rounds)
      health: [
        [
          { value: 'apple', display: '🍎' },
          { value: 'heart', display: '❤️' },
          { value: 'muscle', display: '💪' },
          { value: 'water', display: '💧' },
          { value: 'sleep', display: '😴' },
          { value: 'carrot', display: '🥕' }
        ],
        [
          { value: 'exercise', display: '🏃' },
          { value: 'yoga', display: '🧘' },
          { value: 'swim', display: '🏊' },
          { value: 'bike', display: '🚴' },
          { value: 'stretch', display: '🤸' },
          { value: 'meditate', display: '🧘‍♂️' }
        ],
        [
          { value: 'fruit', display: '🍇' },
          { value: 'veggie', display: '🥦' },
          { value: 'protein', display: '🥩' },
          { value: 'grain', display: '🌾' },
          { value: 'dairy', display: '🥛' },
          { value: 'vitamin', display: '💊' }
        ]
      ]
    },
    advanced: {
      // Math (3 rounds)
      math: [
        [
          { value: 'pi', display: 'π≈3.14' },
          { value: 'sqrt', display: '√16=4' },
          { value: 'square', display: '5²=25' },
          { value: 'percent', display: '50%=½' },
          { value: 'fraction', display: '¾=0.75' },
          { value: 'negative', display: '-5+5=0' }
        ],
        [
          { value: 'algebra', display: 'x+2=5' },
          { value: 'geometry', display: '📐' },
          { value: 'angle', display: '∠90°' },
          { value: 'area', display: 'A=l×w' },
          { value: 'perimeter', display: 'P=2l+2w' },
          { value: 'volume', display: 'V=l×w×h' }
        ],
        [
          { value: 'prime', display: '2,3,5,7' },
          { value: 'composite', display: '4,6,8,9' },
          { value: 'factor', display: '12=3×4' },
          { value: 'multiple', display: '5,10,15' },
          { value: 'ratio', display: '2:3' },
          { value: 'decimal', display: '0.5' }
        ]
      ],
      // Language (3 rounds)
      language: [
        [
          { value: 'metaphor', display: 'Metaphor' },
          { value: 'simile', display: 'Simile' },
          { value: 'verb', display: 'Verb' },
          { value: 'noun', display: 'Noun' },
          { value: 'adjective', display: 'Adjective' },
          { value: 'adverb', display: 'Adverb' }
        ],
        [
          { value: 'synonym', display: 'Synonym' },
          { value: 'antonym', display: 'Antonym' },
          { value: 'prefix', display: 'Prefix' },
          { value: 'suffix', display: 'Suffix' },
          { value: 'root', display: 'Root Word' },
          { value: 'compound', display: 'Compound' }
        ],
        [
          { value: 'thesis', display: 'Thesis' },
          { value: 'evidence', display: 'Evidence' },
          { value: 'conclusion', display: 'Conclusion' },
          { value: 'intro', display: 'Introduction' },
          { value: 'body', display: 'Body' },
          { value: 'summary', display: 'Summary' }
        ]
      ],
      // Science (3 rounds)
      science: [
        [
          { value: 'atom', display: '⚛️' },
          { value: 'dna', display: '🧬' },
          { value: 'magnet', display: '🧲' },
          { value: 'microscope', display: '🔬' },
          { value: 'telescope', display: '🔭' },
          { value: 'battery', display: '🔋' }
        ],
        [
          { value: 'element', display: 'H₂O' },
          { value: 'molecule', display: '⚗️' },
          { value: 'cell', display: '🔬' },
          { value: 'energy', display: '⚡' },
          { value: 'force', display: '💪' },
          { value: 'gravity', display: '🍎⬇️' }
        ],
        [
          { value: 'planet', display: '🪐' },
          { value: 'star', display: '⭐' },
          { value: 'galaxy', display: '🌌' },
          { value: 'comet', display: '☄️' },
          { value: 'asteroid', display: '🪨' },
          { value: 'blackhole', display: '🕳️' }
        ]
      ],
      // Financial Literacy (3 rounds)
      financial: [
        [
          { value: 'money', display: '💰' },
          { value: 'bank', display: '🏦' },
          { value: 'save', display: '🐷' },
          { value: 'budget', display: '📊' },
          { value: 'card', display: '💳' },
          { value: 'coins', display: '🪙' }
        ],
        [
          { value: 'income', display: '💵' },
          { value: 'expense', display: '🧾' },
          { value: 'profit', display: '📈' },
          { value: 'loss', display: '📉' },
          { value: 'invest', display: '💎' },
          { value: 'interest', display: '%' }
        ],
        [
          { value: 'need', display: '🏠' },
          { value: 'want', display: '🎮' },
          { value: 'goal', display: '🎯' },
          { value: 'plan', display: '📝' },
          { value: 'earn', display: '💼' },
          { value: 'spend', display: '🛒' }
        ]
      ],
      // Social-Emotional Learning (3 rounds)
      sel: [
        [
          { value: 'heart', display: '❤️' },
          { value: 'team', display: '👥' },
          { value: 'handshake', display: '🤝' },
          { value: 'star', display: '⭐' },
          { value: 'target', display: '🎯' },
          { value: 'smile', display: '😊' }
        ],
        [
          { value: 'empathy', display: '🫂' },
          { value: 'respect', display: '🙏' },
          { value: 'kindness', display: '💝' },
          { value: 'patience', display: '⏳' },
          { value: 'courage', display: '🦁' },
          { value: 'honest', display: '✋' }
        ],
        [
          { value: 'calm', display: '😌' },
          { value: 'angry', display: '😠' },
          { value: 'happy', display: '😊' },
          { value: 'sad', display: '😢' },
          { value: 'scared', display: '😰' },
          { value: 'excited', display: '🤩' }
        ]
      ],
      // Critical Thinking (3 rounds)
      critical: [
        [
          { value: 'brain', display: '🧠' },
          { value: 'think', display: '🤔' },
          { value: 'light', display: '💡' },
          { value: 'search', display: '🔍' },
          { value: 'puzzle', display: '🧩' },
          { value: 'chart', display: '📈' }
        ],
        [
          { value: 'analyze', display: '🔬' },
          { value: 'compare', display: '⚖️' },
          { value: 'evaluate', display: '📊' },
          { value: 'create', display: '🎨' },
          { value: 'apply', display: '🔧' },
          { value: 'understand', display: '💭' }
        ],
        [
          { value: 'question', display: '❓' },
          { value: 'answer', display: '✅' },
          { value: 'hypothesis', display: '🔮' },
          { value: 'experiment', display: '🧪' },
          { value: 'conclude', display: '📝' },
          { value: 'reflect', display: '🪞' }
        ]
      ],
      // Geography (3 rounds)
      geography: [
        [
          { value: 'globe', display: '🌍' },
          { value: 'map', display: '🗺️' },
          { value: 'mountain', display: '🏔️' },
          { value: 'ocean', display: '🌊' },
          { value: 'compass', display: '🧭' },
          { value: 'flag', display: '🏳️' }
        ],
        [
          { value: 'latitude', display: '━━' },
          { value: 'longitude', display: '┃┃' },
          { value: 'climate', display: '🌡️' },
          { value: 'terrain', display: '🗻' },
          { value: 'border', display: '🚧' },
          { value: 'capital', display: '🏛️' }
        ],
        [
          { value: 'population', display: '👥' },
          { value: 'culture', display: '🎭' },
          { value: 'trade', display: '🚢' },
          { value: 'resource', display: '⛏️' },
          { value: 'ecosystem', display: '🌿' },
          { value: 'weather', display: '🌤️' }
        ]
      ],
      // History (3 rounds)
      history: [
        [
          { value: 'castle', display: '🏰' },
          { value: 'scroll', display: '📜' },
          { value: 'crown', display: '👑' },
          { value: 'pyramid', display: '🔺' },
          { value: 'statue', display: '🗽' },
          { value: 'hourglass', display: '⏳' }
        ],
        [
          { value: 'revolution', display: '✊' },
          { value: 'invention', display: '💡' },
          { value: 'discovery', display: '🔍' },
          { value: 'empire', display: '👑' },
          { value: 'democracy', display: '🗳️' },
          { value: 'treaty', display: '📜' }
        ],
        [
          { value: 'ancient', display: '🏛️' },
          { value: 'medieval', display: '⚔️' },
          { value: 'modern', display: '🏙️' },
          { value: 'future', display: '🚀' },
          { value: 'era', display: '📅' },
          { value: 'timeline', display: '➡️' }
        ]
      ]
    }
  };

  const mixed = (age) => {
    const all = [];
    ['math', 'language', 'science'].forEach(subj => {
      if (cardSets[age]?.[subj]) {
        // Get first round of each subject for mixed
        const rounds = cardSets[age][subj];
        const firstRound = Array.isArray(rounds[0]) ? rounds[0] : rounds;
        all.push(...firstRound.slice(0, 2));
      }
    });
    return [all]; // Return as single round for mixed
  };

  if (mappedSubject === 'mixed') {
    return mixed(ageGroup);
  }

  const result = cardSets[ageGroup]?.[mappedSubject] || cardSets[ageGroup]?.math || cardSets.preschool.math;
  
  // Ensure result is always an array of arrays (rounds)
  if (result && !Array.isArray(result[0])) {
    return [result]; // Single round - wrap in array
  }
  
  return result;
};

export const getPuzzles = (ageGroup, subject) => {
  // Map the topic ID to the internal subject type
  const mappedSubject = topicToSubjectMap[subject] || subject;
  
  const puzzles = {
    preschool: {
      // ABC Adventures Puzzles
      abc: [
        {
          question: 'What letter does "Apple" start with?',
          options: ['A', 'B', 'C', 'D'],
          correctAnswer: 0,
          hint: 'Listen: Aaa-pple'
        },
        {
          question: 'Complete the alphabet: A, B, C, __',
          options: ['E', 'D', 'F', 'G'],
          correctAnswer: 1,
          hint: 'Sing the ABC song!'
        },
        {
          question: 'Which letter makes the "Sss" sound?',
          options: ['T', 'R', 'S', 'Z'],
          correctAnswer: 2,
          hint: 'Like a snake!'
        },
        {
          question: 'What letter does "Ball" start with?',
          options: ['D', 'B', 'P', 'G'],
          correctAnswer: 1,
          hint: 'Buh-all'
        },
        {
          question: 'Which letter comes after M?',
          options: ['L', 'O', 'N', 'P'],
          correctAnswer: 2,
          hint: 'L, M, N...'
        }
      ],
      // Counting Fun Puzzles
      counting: [
        {
          question: 'If you have 2 cookies and get 1 more, how many?',
          options: ['2', '3', '4', '1'],
          correctAnswer: 1,
          hint: 'Count on your fingers!'
        },
        {
          question: 'How many wheels does a car have?',
          options: ['2', '3', '4', '6'],
          correctAnswer: 2,
          hint: 'Count all four corners!'
        },
        {
          question: 'What number comes between 1 and 3?',
          options: ['4', '2', '5', '0'],
          correctAnswer: 1,
          hint: 'Count: 1, ?, 3'
        },
        {
          question: '5 take away 2 equals?',
          options: ['2', '4', '3', '5'],
          correctAnswer: 2,
          hint: 'Hold up 5 fingers, put 2 down'
        },
        {
          question: 'How many eyes do you have?',
          options: ['1', '2', '3', '4'],
          correctAnswer: 1,
          hint: 'Look in the mirror!'
        }
      ],
      // Colors & Shapes Puzzles
      colors: [
        {
          question: 'What color is the sun?',
          options: ['Blue', 'Green', 'Yellow', 'Red'],
          correctAnswer: 2,
          hint: 'Bright and warm!'
        },
        {
          question: 'What shape has 3 sides?',
          options: ['Circle', 'Square', 'Triangle', 'Rectangle'],
          correctAnswer: 2,
          hint: 'Count the sides: 1, 2, 3'
        },
        {
          question: 'Mix red and blue to get...',
          options: ['Green', 'Orange', 'Purple', 'Yellow'],
          correctAnswer: 2,
          hint: 'Think of grapes!'
        },
        {
          question: 'What shape is a wheel?',
          options: ['Square', 'Circle', 'Triangle', 'Star'],
          correctAnswer: 1,
          hint: 'It rolls around!'
        },
        {
          question: 'What color is grass?',
          options: ['Red', 'Blue', 'Yellow', 'Green'],
          correctAnswer: 3,
          hint: 'Look in the garden!'
        }
      ],
      // Animal Friends Puzzles
      animals: [
        {
          question: 'What animal says "Woof"?',
          options: ['Cat', 'Dog', 'Cow', 'Pig'],
          correctAnswer: 1,
          hint: 'Man\'s best friend!'
        },
        {
          question: 'Which animal has a long trunk?',
          options: ['Tiger', 'Lion', 'Elephant', 'Bear'],
          correctAnswer: 2,
          hint: 'The biggest land animal!'
        },
        {
          question: 'What animal gives us eggs?',
          options: ['Cow', 'Pig', 'Chicken', 'Dog'],
          correctAnswer: 2,
          hint: 'It says cluck cluck!'
        },
        {
          question: 'Which animal can fly?',
          options: ['Fish', 'Dog', 'Bird', 'Cat'],
          correctAnswer: 2,
          hint: 'It has wings!'
        },
        {
          question: 'What animal says "Meow"?',
          options: ['Dog', 'Cat', 'Mouse', 'Bird'],
          correctAnswer: 1,
          hint: 'A fluffy pet!'
        }
      ],
      // Safety First Puzzles
      safety: [
        {
          question: 'What color means STOP?',
          options: ['Green', 'Yellow', 'Red', 'Blue'],
          correctAnswer: 2,
          hint: 'Like a stop sign!'
        },
        {
          question: 'Before crossing, you should...',
          options: ['Run fast', 'Look both ways', 'Close eyes', 'Jump'],
          correctAnswer: 1,
          hint: 'Left then right!'
        },
        {
          question: 'What do you wear when riding a bike?',
          options: ['Hat', 'Helmet', 'Crown', 'Nothing'],
          correctAnswer: 1,
          hint: 'Protects your head!'
        },
        {
          question: 'Who do you call in an emergency?',
          options: ['Friends', 'Teacher', '911', 'Nobody'],
          correctAnswer: 2,
          hint: 'A special number!'
        },
        {
          question: 'Should you play with matches?',
          options: ['Yes', 'No', 'Sometimes', 'Maybe'],
          correctAnswer: 1,
          hint: 'Fire is dangerous!'
        }
      ],
      // Transportation Puzzles
      transportation: [
        {
          question: 'What goes "Choo Choo"?',
          options: ['Car', 'Train', 'Plane', 'Boat'],
          correctAnswer: 1,
          hint: 'It runs on tracks!'
        },
        {
          question: 'What vehicle flies in the sky?',
          options: ['Car', 'Boat', 'Train', 'Airplane'],
          correctAnswer: 3,
          hint: 'It has wings!'
        },
        {
          question: 'How many wheels does a bicycle have?',
          options: ['1', '2', '3', '4'],
          correctAnswer: 1,
          hint: 'Bi means two!'
        },
        {
          question: 'What vehicle floats on water?',
          options: ['Car', 'Plane', 'Boat', 'Train'],
          correctAnswer: 2,
          hint: 'It has sails!'
        },
        {
          question: 'What takes kids to school?',
          options: ['Rocket', 'School Bus', 'Spaceship', 'Helicopter'],
          correctAnswer: 1,
          hint: 'It\'s yellow!'
        }
      ],
      // Reading Time Puzzles
      reading: [
        {
          question: 'C-A-T spells...',
          options: ['Dog', 'Cat', 'Bat', 'Hat'],
          correctAnswer: 1,
          hint: 'A furry pet!'
        },
        {
          question: 'What rhymes with "hat"?',
          options: ['Dog', 'Sun', 'Cat', 'Tree'],
          correctAnswer: 2,
          hint: 'Ends with "at"'
        },
        {
          question: 'D-O-G spells...',
          options: ['Cat', 'Dog', 'Pig', 'Fog'],
          correctAnswer: 1,
          hint: 'Woof woof!'
        },
        {
          question: '"Once upon a time" starts a...',
          options: ['Song', 'Story', 'Game', 'Movie'],
          correctAnswer: 1,
          hint: 'Like a fairy tale!'
        },
        {
          question: 'S-U-N spells...',
          options: ['Fun', 'Sun', 'Run', 'Bun'],
          correctAnswer: 1,
          hint: 'It\'s bright in the sky!'
        }
      ],
      // Nature Puzzles
      nature: [
        {
          question: 'What do bees make?',
          options: ['Milk', 'Honey', 'Juice', 'Water'],
          correctAnswer: 1,
          hint: 'Sweet and golden!'
        },
        {
          question: 'What falls from clouds?',
          options: ['Snow only', 'Rain', 'Candy', 'Toys'],
          correctAnswer: 1,
          hint: 'It makes puddles!'
        },
        {
          question: 'What color are most leaves?',
          options: ['Red', 'Blue', 'Green', 'Purple'],
          correctAnswer: 2,
          hint: 'Like grass!'
        },
        {
          question: 'Where do birds build their homes?',
          options: ['Underground', 'In nests', 'In water', 'In caves'],
          correctAnswer: 1,
          hint: 'Up in the trees!'
        },
        {
          question: 'What season has snow?',
          options: ['Summer', 'Winter', 'Spring', 'Fall'],
          correctAnswer: 1,
          hint: 'It\'s cold!'
        }
      ],
      // Daily Activities Puzzles
      daily: [
        {
          question: 'What do we use to brush teeth?',
          options: ['Comb', 'Fork', 'Toothbrush', 'Spoon'],
          correctAnswer: 2,
          hint: 'Has bristles!'
        },
        {
          question: 'What meal is in the morning?',
          options: ['Lunch', 'Dinner', 'Breakfast', 'Snack'],
          correctAnswer: 2,
          hint: 'First meal of the day!'
        },
        {
          question: 'Where do we sleep?',
          options: ['Chair', 'Table', 'Bed', 'Floor'],
          correctAnswer: 2,
          hint: 'Soft and cozy!'
        },
        {
          question: 'What do we wash hands with?',
          options: ['Juice', 'Soap', 'Milk', 'Honey'],
          correctAnswer: 1,
          hint: 'Makes bubbles!'
        },
        {
          question: 'When is bedtime?',
          options: ['Morning', 'Afternoon', 'Night', 'Noon'],
          correctAnswer: 2,
          hint: 'When stars come out!'
        }
      ],
      // Food Puzzles
      food: [
        {
          question: 'What fruit is yellow and curved?',
          options: ['Apple', 'Banana', 'Grape', 'Orange'],
          correctAnswer: 1,
          hint: 'Monkeys love it!'
        },
        {
          question: 'What do cows give us?',
          options: ['Eggs', 'Honey', 'Milk', 'Bread'],
          correctAnswer: 2,
          hint: 'White drink!'
        },
        {
          question: 'Which is a vegetable?',
          options: ['Apple', 'Banana', 'Carrot', 'Orange'],
          correctAnswer: 2,
          hint: 'Orange and crunchy!'
        },
        {
          question: 'What is red and grows on trees?',
          options: ['Carrot', 'Apple', 'Lettuce', 'Potato'],
          correctAnswer: 1,
          hint: 'Keeps the doctor away!'
        },
        {
          question: 'What do we make sandwiches with?',
          options: ['Cake', 'Bread', 'Cookie', 'Pie'],
          correctAnswer: 1,
          hint: 'Sliced and soft!'
        }
      ],
      // Original math/language/science for backward compatibility
      math: [
        {
          question: 'If you have 2 cookies and get 1 more, how many?',
          options: ['2', '3', '4', '1'],
          correctAnswer: 1,
          hint: 'Count on your fingers!'
        },
        {
          question: 'How many wheels does a car have?',
          options: ['2', '3', '4', '6'],
          correctAnswer: 2,
          hint: 'Count all four corners!'
        },
        {
          question: 'What number comes between 1 and 3?',
          options: ['4', '2', '5', '0'],
          correctAnswer: 1,
          hint: 'Count: 1, ?, 3'
        }
      ],
      language: [
        {
          question: 'What letter does "Dog" start with?',
          options: ['B', 'C', 'D', 'E'],
          correctAnswer: 2,
          hint: 'Listen: Duh-og'
        },
        {
          question: 'Complete: A, B, C, __',
          options: ['E', 'D', 'F', 'G'],
          correctAnswer: 1,
          hint: 'Sing the ABC song!'
        },
        {
          question: 'What comes at the end of "Cat"?',
          options: ['C', 'A', 'T', 'S'],
          correctAnswer: 2,
          hint: 'Listen to the last sound'
        }
      ],
      science: [
        {
          question: 'What color is grass?',
          options: ['Red', 'Blue', 'Yellow', 'Green'],
          correctAnswer: 3,
          hint: 'Look outside!'
        },
        {
          question: 'What animal says "Woof"?',
          options: ['Cat', 'Dog', 'Cow', 'Pig'],
          correctAnswer: 1,
          hint: 'Man\'s best friend!'
        },
        {
          question: 'What do we see at night in the sky?',
          options: ['Sun', 'Rainbow', 'Stars', 'Clouds'],
          correctAnswer: 2,
          hint: 'They twinkle!'
        }
      ]
    },
    elementary: {
      math: [
        {
          question: 'If a box has 12 eggs and you use 5, how many left?',
          options: ['5', '6', '7', '8'],
          correctAnswer: 2,
          hint: 'Subtract: 12 - 5'
        },
        {
          question: 'What is 6 × 3?',
          options: ['15', '18', '21', '24'],
          correctAnswer: 1,
          hint: 'Think 6 + 6 + 6'
        },
        {
          question: '3 rectangles have how many sides total?',
          options: ['8', '10', '12', '14'],
          correctAnswer: 2,
          hint: 'Each rectangle has 4 sides'
        },
        {
          question: 'What is half of 24?',
          options: ['10', '11', '12', '13'],
          correctAnswer: 2,
          hint: 'Divide by 2'
        },
        {
          question: '25 + 37 = ?',
          options: ['52', '62', '72', '82'],
          correctAnswer: 1,
          hint: 'Add the ones, then tens'
        }
      ],
      language: [
        {
          question: 'What is the opposite of "day"?',
          options: ['Morning', 'Night', 'Evening', 'Afternoon'],
          correctAnswer: 1,
          hint: 'When the sun goes down'
        },
        {
          question: 'Rearrange TAC to spell...',
          options: ['Act', 'Cat', 'Tac', 'Atc'],
          correctAnswer: 1,
          hint: 'A furry pet!'
        },
        {
          question: 'What word means "very big"?',
          options: ['Tiny', 'Small', 'Huge', 'Little'],
          correctAnswer: 2,
          hint: 'Like an elephant!'
        },
        {
          question: 'Which is a noun?',
          options: ['Run', 'Happy', 'Dog', 'Quickly'],
          correctAnswer: 2,
          hint: 'Person, place, or thing'
        },
        {
          question: 'Complete: She ____ to school every day',
          options: ['go', 'goes', 'going', 'gone'],
          correctAnswer: 1,
          hint: 'Present tense for "she"'
        }
      ],
      science: [
        {
          question: 'What do plants need from the sun?',
          options: ['Water', 'Light', 'Soil', 'Wind'],
          correctAnswer: 1,
          hint: 'For photosynthesis!'
        },
        {
          question: 'What is the largest land animal?',
          options: ['Giraffe', 'Elephant', 'Hippo', 'Rhino'],
          correctAnswer: 1,
          hint: 'It has a trunk!'
        },
        {
          question: 'What is H2O?',
          options: ['Air', 'Fire', 'Water', 'Earth'],
          correctAnswer: 2,
          hint: 'You drink it!'
        },
        {
          question: 'How many planets in our solar system?',
          options: ['7', '8', '9', '10'],
          correctAnswer: 1,
          hint: 'Mercury to Neptune'
        },
        {
          question: 'What do bees make?',
          options: ['Milk', 'Honey', 'Silk', 'Wax only'],
          correctAnswer: 1,
          hint: 'Sweet and golden!'
        }
      ],
      // Geography Puzzles
      geography: [
        {
          question: 'How many continents are there?',
          options: ['5', '6', '7', '8'],
          correctAnswer: 2,
          hint: 'Including Antarctica!'
        },
        {
          question: 'What is the largest ocean?',
          options: ['Atlantic', 'Pacific', 'Indian', 'Arctic'],
          correctAnswer: 1,
          hint: 'Between Asia and Americas'
        },
        {
          question: 'Which country has the Great Wall?',
          options: ['Japan', 'India', 'China', 'Korea'],
          correctAnswer: 2,
          hint: 'Visible from space!'
        },
        {
          question: 'What is the capital of France?',
          options: ['London', 'Paris', 'Rome', 'Berlin'],
          correctAnswer: 1,
          hint: 'Has the Eiffel Tower!'
        },
        {
          question: 'Which continent has kangaroos?',
          options: ['Africa', 'Asia', 'Australia', 'Europe'],
          correctAnswer: 2,
          hint: 'Down under!'
        }
      ],
      // History Puzzles
      history: [
        {
          question: 'Who built the pyramids?',
          options: ['Romans', 'Greeks', 'Egyptians', 'Vikings'],
          correctAnswer: 2,
          hint: 'Along the Nile River!'
        },
        {
          question: 'Who discovered America in 1492?',
          options: ['Marco Polo', 'Columbus', 'Magellan', 'Vikings'],
          correctAnswer: 1,
          hint: 'Sailed from Spain!'
        },
        {
          question: 'What did knights ride?',
          options: ['Elephants', 'Horses', 'Camels', 'Dragons'],
          correctAnswer: 1,
          hint: 'In shining armor!'
        },
        {
          question: 'Which civilization built the Colosseum?',
          options: ['Greeks', 'Romans', 'Egyptians', 'Persians'],
          correctAnswer: 1,
          hint: 'In Italy!'
        },
        {
          question: 'Who invented the telephone?',
          options: ['Edison', 'Bell', 'Einstein', 'Newton'],
          correctAnswer: 1,
          hint: 'Alexander Graham...'
        }
      ],
      // True or False Puzzles
      truefalse: [
        {
          question: 'The Sun is a star - True or False?',
          options: ['True', 'False', 'Maybe', 'Unknown'],
          correctAnswer: 0,
          hint: 'Our closest star!'
        },
        {
          question: 'Penguins can fly - True or False?',
          options: ['True', 'False', 'Sometimes', 'Only baby ones'],
          correctAnswer: 1,
          hint: 'They swim instead!'
        },
        {
          question: 'The Earth is flat - True or False?',
          options: ['True', 'False', 'Partially', 'Unknown'],
          correctAnswer: 1,
          hint: 'It\'s actually round!'
        },
        {
          question: 'Water freezes at 0°C - True or False?',
          options: ['True', 'False', 'Only sometimes', 'Depends'],
          correctAnswer: 0,
          hint: 'That\'s when ice forms!'
        },
        {
          question: 'Spiders are insects - True or False?',
          options: ['True', 'False', 'Some are', 'All are'],
          correctAnswer: 1,
          hint: 'They have 8 legs, not 6!'
        }
      ],
      // Art & Creativity Puzzles
      art: [
        {
          question: 'What do you get mixing red and blue?',
          options: ['Green', 'Orange', 'Purple', 'Brown'],
          correctAnswer: 2,
          hint: 'Think of grapes!'
        },
        {
          question: 'Which famous artist painted Starry Night?',
          options: ['Picasso', 'Da Vinci', 'Van Gogh', 'Monet'],
          correctAnswer: 2,
          hint: 'He was Dutch!'
        },
        {
          question: 'What is the name for art on walls?',
          options: ['Sculpture', 'Mural', 'Portrait', 'Sketch'],
          correctAnswer: 1,
          hint: 'Think of big wall paintings!'
        },
        {
          question: 'Primary colors are red, blue, and...',
          options: ['Green', 'Orange', 'Purple', 'Yellow'],
          correctAnswer: 3,
          hint: 'The color of the sun!'
        },
        {
          question: 'What tool holds a painting while you work?',
          options: ['Brush', 'Palette', 'Easel', 'Canvas'],
          correctAnswer: 2,
          hint: 'It has legs like a tripod!'
        }
      ],
      // Health & Wellness Puzzles
      health: [
        {
          question: 'Which food group includes bread and pasta?',
          options: ['Proteins', 'Carbohydrates', 'Fats', 'Dairy'],
          correctAnswer: 1,
          hint: 'They give us energy!'
        },
        {
          question: 'What organ pumps blood through your body?',
          options: ['Brain', 'Lungs', 'Heart', 'Stomach'],
          correctAnswer: 2,
          hint: 'It beats!'
        },
        {
          question: 'How many minutes of exercise per day is recommended?',
          options: ['10 minutes', '30 minutes', '60 minutes', '120 minutes'],
          correctAnswer: 2,
          hint: 'About an hour!'
        },
        {
          question: 'Which vitamin is found in oranges?',
          options: ['Vitamin A', 'Vitamin B', 'Vitamin C', 'Vitamin D'],
          correctAnswer: 2,
          hint: 'Helps fight colds!'
        },
        {
          question: 'What should you eat more of for fiber?',
          options: ['Candy', 'Vegetables', 'Ice cream', 'Chips'],
          correctAnswer: 1,
          hint: 'Green is good!'
        }
      ]
    },
    advanced: {
      math: [
        {
          question: 'If x + 7 = 15, what is x?',
          options: ['6', '7', '8', '9'],
          correctAnswer: 2,
          hint: 'Subtract 7 from both sides'
        },
        {
          question: 'What is 25% of 80?',
          options: ['15', '20', '25', '30'],
          correctAnswer: 1,
          hint: '25% = 1/4'
        },
        {
          question: 'Area of rectangle: length 8, width 5?',
          options: ['35', '40', '45', '50'],
          correctAnswer: 1,
          hint: 'Area = length × width'
        },
        {
          question: 'What is √144?',
          options: ['10', '11', '12', '13'],
          correctAnswer: 2,
          hint: '12 × 12 = ?'
        },
        {
          question: 'Solve: 3x = 21',
          options: ['5', '6', '7', '8'],
          correctAnswer: 2,
          hint: 'Divide both sides by 3'
        }
      ],
      language: [
        {
          question: 'What is the plural of "child"?',
          options: ['Childs', 'Childes', 'Children', 'Childrens'],
          correctAnswer: 2,
          hint: 'Irregular plural!'
        },
        {
          question: '"Quickly" is what part of speech?',
          options: ['Noun', 'Verb', 'Adjective', 'Adverb'],
          correctAnswer: 3,
          hint: 'Describes HOW something is done'
        },
        {
          question: 'Synonym for "difficult"?',
          options: ['Easy', 'Simple', 'Hard', 'Light'],
          correctAnswer: 2,
          hint: 'Not easy!'
        },
        {
          question: '"Time is money" is a...',
          options: ['Simile', 'Metaphor', 'Alliteration', 'Hyperbole'],
          correctAnswer: 1,
          hint: 'Direct comparison!'
        },
        {
          question: 'Past tense of "swim"?',
          options: ['Swimmed', 'Swam', 'Swum', 'Swimming'],
          correctAnswer: 1,
          hint: 'Irregular verb!'
        }
      ],
      science: [
        {
          question: 'What gas do humans breathe in?',
          options: ['Carbon Dioxide', 'Nitrogen', 'Oxygen', 'Helium'],
          correctAnswer: 2,
          hint: 'Symbol: O2'
        },
        {
          question: 'What is the center of an atom called?',
          options: ['Electron', 'Proton', 'Nucleus', 'Neutron'],
          correctAnswer: 2,
          hint: 'Contains protons and neutrons'
        },
        {
          question: 'What force pulls objects down?',
          options: ['Magnetism', 'Friction', 'Gravity', 'Pressure'],
          correctAnswer: 2,
          hint: 'Newton\'s apple!'
        },
        {
          question: 'What is the powerhouse of the cell?',
          options: ['Nucleus', 'Mitochondria', 'Ribosome', 'Membrane'],
          correctAnswer: 1,
          hint: 'Makes energy (ATP)!'
        },
        {
          question: 'Chemical symbol for gold?',
          options: ['Go', 'Gd', 'Au', 'Ag'],
          correctAnswer: 2,
          hint: 'From Latin "Aurum"'
        }
      ],
      // Financial Literacy Puzzles
      financial: [
        {
          question: 'You earn $20 and want to save 25%. How much do you save?',
          options: ['$3', '$4', '$5', '$6'],
          correctAnswer: 2,
          hint: '25% = 1/4 of $20'
        },
        {
          question: 'Which is a NEED?',
          options: ['Designer shoes', 'Latest phone', 'Food', 'Video games'],
          correctAnswer: 2,
          hint: 'You need it to survive!'
        },
        {
          question: 'What does "budget" mean?',
          options: ['Spend everything', 'Plan for income and expenses', 'Borrow money', 'Save nothing'],
          correctAnswer: 1,
          hint: 'It\'s a money plan!'
        },
        {
          question: 'An entrepreneur is someone who...',
          options: ['Works for others only', 'Starts their own business', 'Avoids work', 'Never takes risks'],
          correctAnswer: 1,
          hint: 'Business creator!'
        },
        {
          question: 'What is compound interest?',
          options: ['Simple interest', 'Interest on interest', 'No interest', 'Fixed rate'],
          correctAnswer: 1,
          hint: 'Your money grows faster!'
        }
      ],
      // Social-Emotional Learning Puzzles
      sel: [
        {
          question: 'Your friend is sad. You should...',
          options: ['Ignore them', 'Listen and support them', 'Laugh at them', 'Walk away'],
          correctAnswer: 1,
          hint: 'Show empathy!'
        },
        {
          question: 'A SMART goal is...',
          options: ['Vague and unclear', 'Specific and time-bound', 'Impossible', 'Secret'],
          correctAnswer: 1,
          hint: 'Clear and measurable!'
        },
        {
          question: 'Good teamwork includes...',
          options: ['Doing everything alone', 'Communication and cooperation', 'Ignoring others', 'Being bossy'],
          correctAnswer: 1,
          hint: 'Work together!'
        },
        {
          question: 'A good leader...',
          options: ['Takes all credit', 'Inspires and empowers others', 'Never listens', 'Avoids responsibility'],
          correctAnswer: 1,
          hint: 'They help others succeed!'
        },
        {
          question: 'Self-regulation means...',
          options: ['Losing control', 'Managing your emotions', 'Ignoring feelings', 'Being angry'],
          correctAnswer: 1,
          hint: 'Control your reactions!'
        }
      ],
      // Critical Thinking Puzzles
      critical: [
        {
          question: 'Which is a reliable source?',
          options: ['Random social media', 'Verified research papers', 'Anonymous blogs', 'Chain messages'],
          correctAnswer: 1,
          hint: 'Check the source!'
        },
        {
          question: 'If all A are B, and all B are C, then...',
          options: ['A are not C', 'All A are C', 'C are A', 'Nothing'],
          correctAnswer: 1,
          hint: 'Follow the logic!'
        },
        {
          question: 'Before making a decision, you should...',
          options: ['Act immediately', 'Consider options and consequences', 'Flip a coin', 'Ask everyone'],
          correctAnswer: 1,
          hint: 'Think it through!'
        },
        {
          question: 'An opinion is different from a fact because...',
          options: ['It\'s always true', 'It can\'t be proven', 'It\'s written down', 'It\'s popular'],
          correctAnswer: 1,
          hint: 'Facts can be verified!'
        },
        {
          question: 'Problem-solving requires...',
          options: ['Giving up quickly', 'Analyzing and testing solutions', 'Random guessing', 'Copying others'],
          correctAnswer: 1,
          hint: 'Think systematically!'
        }
      ],
      // Geography Puzzles (Advanced)
      geography: [
        {
          question: 'What is the capital of Japan?',
          options: ['Osaka', 'Tokyo', 'Kyoto', 'Nagoya'],
          correctAnswer: 1,
          hint: 'The largest city in Japan!'
        },
        {
          question: 'Which river flows through Egypt?',
          options: ['Amazon', 'Nile', 'Ganges', 'Mississippi'],
          correctAnswer: 1,
          hint: 'Ancient civilizations built along it!'
        },
        {
          question: 'What is the smallest country in the world?',
          options: ['Monaco', 'Vatican City', 'San Marino', 'Liechtenstein'],
          correctAnswer: 1,
          hint: 'It\'s inside Rome!'
        },
        {
          question: 'Which continent is the Amazon Rainforest in?',
          options: ['Africa', 'Asia', 'South America', 'Australia'],
          correctAnswer: 2,
          hint: 'Brazil is the largest country there!'
        },
        {
          question: 'What mountain range includes Mount Everest?',
          options: ['Alps', 'Andes', 'Rockies', 'Himalayas'],
          correctAnswer: 3,
          hint: 'Between India and China!'
        }
      ],
      // History Puzzles (Advanced)
      history: [
        {
          question: 'Who was the first woman to fly solo across the Atlantic?',
          options: ['Amelia Earhart', 'Sally Ride', 'Marie Curie', 'Rosa Parks'],
          correctAnswer: 0,
          hint: 'She disappeared over the Pacific!'
        },
        {
          question: 'What ancient wonder was in Alexandria?',
          options: ['Colossus', 'Lighthouse', 'Hanging Gardens', 'Temple of Artemis'],
          correctAnswer: 1,
          hint: 'It guided ships to the harbor!'
        },
        {
          question: 'Which war was fought between 1914-1918?',
          options: ['World War II', 'Civil War', 'World War I', 'Revolutionary War'],
          correctAnswer: 2,
          hint: 'The "Great War"!'
        },
        {
          question: 'Who wrote the "I Have a Dream" speech?',
          options: ['Abraham Lincoln', 'John F. Kennedy', 'Martin Luther King Jr.', 'Barack Obama'],
          correctAnswer: 2,
          hint: 'Civil rights leader!'
        },
        {
          question: 'What empire built roads across Europe?',
          options: ['Greek', 'Egyptian', 'Roman', 'Persian'],
          correctAnswer: 2,
          hint: 'All roads lead to...!'
        }
      ]
    }
  };

  const mixed = (age) => {
    const all = [];
    ['math', 'language', 'science'].forEach(subj => {
      if (puzzles[age]?.[subj]?.[0]) {
        all.push(puzzles[age][subj][0]);
      }
    });
    return all;
  };

  if (mappedSubject === 'mixed') {
    return mixed(ageGroup);
  }

  // Return topic-specific puzzles if available, otherwise use mapping
  if (puzzles[ageGroup]?.[mappedSubject]) {
    return puzzles[ageGroup][mappedSubject];
  }
  
  // Fallback mapping for topics without specific puzzles
  const puzzleMapping = {
    abc: 'abc',
    counting: 'counting',
    colors: 'colors',
    animals: 'animals',
    safety: 'safety',
    transportation: 'transportation',
    reading: 'reading',
    nature: 'nature',
    daily: 'daily',
    food: 'food',
    geography: 'geography',
    history: 'history',
    truefalse: 'truefalse'
  };
  
  const puzzleSubject = puzzleMapping[mappedSubject] || mappedSubject;
  return puzzles[ageGroup]?.[puzzleSubject] || puzzles[ageGroup]?.math || puzzles.preschool.math;
};

// Picture puzzle images for the new puzzle game
export const getPuzzleImages = (ageGroup, subject) => {
  const mappedSubject = topicToSubjectMap[subject] || subject;
  
  const puzzleImages = {
    preschool: {
      abc: [
        { name: 'Apple', emoji: '🍎' },
        { name: 'Ball', emoji: '⚽' },
        { name: 'Cat', emoji: '🐱' },
      ],
      counting: [
        { name: 'Cupcake', emoji: '🧁' },
        { name: 'Balloons', emoji: '🎈' },
        { name: 'Stars', emoji: '⭐' },
      ],
      colors: [
        { name: 'Rainbow', emoji: '🌈' },
        { name: 'Flowers', emoji: '🌹' },
        { name: 'Sky', emoji: '🌤️' },
      ],
      animals: [
        { name: 'Puppy', emoji: '🐕' },
        { name: 'Kitten', emoji: '🐱' },
        { name: 'Bunny', emoji: '🐰' },
      ],
      safety: [
        { name: 'Traffic Light', emoji: '🚦' },
        { name: 'Fire Truck', emoji: '🚒' },
        { name: 'Stop Sign', emoji: '🛑' },
      ],
      transportation: [
        { name: 'Train', emoji: '🚂' },
        { name: 'Airplane', emoji: '✈️' },
        { name: 'Boat', emoji: '⛵' },
      ],
      reading: [
        { name: 'Books', emoji: '📚' },
        { name: 'Library', emoji: '📖' },
        { name: 'Reading', emoji: '📕' },
      ],
      nature: [
        { name: 'Butterfly', emoji: '🦋' },
        { name: 'Sunflower', emoji: '🌻' },
        { name: 'Tree', emoji: '🌳' },
      ],
      daily: [
        { name: 'Breakfast', emoji: '🥣' },
        { name: 'Toothbrush', emoji: '🪥' },
        { name: 'Bed', emoji: '🛏️' },
      ],
      food: [
        { name: 'Banana', emoji: '🍌' },
        { name: 'Apple', emoji: '🍎' },
        { name: 'Orange', emoji: '🍊' },
      ],
      math: [
        { name: 'Numbers', emoji: '🔢' },
        { name: 'Blocks', emoji: '🧱' },
        { name: 'Clock', emoji: '🕐' },
      ],
      language: [
        { name: 'ABC', emoji: '🔤' },
        { name: 'Books', emoji: '📚' },
        { name: 'Pencils', emoji: '✏️' },
      ],
      science: [
        { name: 'Plant', emoji: '🌱' },
        { name: 'Ladybug', emoji: '🐞' },
        { name: 'Sun', emoji: '☀️' },
      ]
    },
    elementary: {
      math: [
        { name: 'Calculator', emoji: '🧮' },
        { name: 'Geometry', emoji: '📐' },
        { name: 'Numbers', emoji: '🔢' },
      ],
      language: [
        { name: 'Dictionary', emoji: '📖' },
        { name: 'Writing', emoji: '✍️' },
        { name: 'Library', emoji: '📚' },
      ],
      science: [
        { name: 'Planet', emoji: '🪐' },
        { name: 'Lab', emoji: '🔬' },
        { name: 'Nature', emoji: '🌿' },
      ],
      geography: [
        { name: 'Globe', emoji: '🌍' },
        { name: 'Map', emoji: '🗺️' },
        { name: 'Mountains', emoji: '🏔️' },
      ],
      history: [
        { name: 'Castle', emoji: '🏰' },
        { name: 'Pyramid', emoji: '🔺' },
        { name: 'Colosseum', emoji: '🏛️' },
      ],
      truefalse: [
        { name: 'Brain', emoji: '🧠' },
        { name: 'Light Bulb', emoji: '💡' },
        { name: 'Question', emoji: '❓' },
      ],
      art: [
        { name: 'Paint', emoji: '🎨' },
        { name: 'Canvas', emoji: '🖼️' },
        { name: 'Brushes', emoji: '🖌️' },
      ],
      health: [
        { name: 'Fruits', emoji: '🍎' },
        { name: 'Exercise', emoji: '🏃' },
        { name: 'Water', emoji: '💧' },
      ]
    },
    advanced: {
      math: [
        { name: 'Equations', emoji: '📊' },
        { name: 'Calculator', emoji: '🧮' },
        { name: 'Geometry', emoji: '📐' },
      ],
      language: [
        { name: 'Literature', emoji: '📚' },
        { name: 'Writing', emoji: '✍️' },
        { name: 'Poetry', emoji: '📜' },
      ],
      science: [
        { name: 'Chemistry', emoji: '⚗️' },
        { name: 'Space', emoji: '🚀' },
        { name: 'Biology', emoji: '🧬' },
      ],
      geography: [
        { name: 'World Map', emoji: '🗺️' },
        { name: 'Ocean', emoji: '🌊' },
        { name: 'Earth', emoji: '🌍' },
      ],
      history: [
        { name: 'Colosseum', emoji: '🏛️' },
        { name: 'Castle', emoji: '🏰' },
        { name: 'Pyramid', emoji: '🔺' },
      ],
      financial: [
        { name: 'Money', emoji: '💰' },
        { name: 'Piggy Bank', emoji: '🐷' },
        { name: 'Coins', emoji: '🪙' },
      ],
      sel: [
        { name: 'Teamwork', emoji: '🤝' },
        { name: 'Heart', emoji: '❤️' },
        { name: 'Friends', emoji: '👫' },
      ],
      critical: [
        { name: 'Thinking', emoji: '🧠' },
        { name: 'Ideas', emoji: '💡' },
        { name: 'Puzzle', emoji: '🧩' },
      ]
    }
  };

  return puzzleImages[ageGroup]?.[mappedSubject] || puzzleImages[ageGroup]?.math || puzzleImages.preschool.math;
};

// Sorting game data - Sort items into categories
export const getSortingData = (ageGroup, subject) => {
  const mappedSubject = topicToSubjectMap[subject] || subject;
  
  const sortingData = {
    preschool: {
      food: [
        {
          instruction: "Sort the food into Fruits and Vegetables! 🍎🥕",
          category1: { name: "Fruits", emoji: "🍎", color: "#ef4444" },
          category2: { name: "Vegetables", emoji: "🥕", color: "#22c55e" },
          items: [
            { id: 1, name: "Apple", emoji: "🍎", category: "Fruits" },
            { id: 2, name: "Carrot", emoji: "🥕", category: "Vegetables" },
            { id: 3, name: "Banana", emoji: "🍌", category: "Fruits" },
            { id: 4, name: "Broccoli", emoji: "🥦", category: "Vegetables" },
            { id: 5, name: "Orange", emoji: "🍊", category: "Fruits" },
            { id: 6, name: "Cucumber", emoji: "🥒", category: "Vegetables" },
          ]
        },
        {
          instruction: "Sort into Healthy Foods and Treats! 🥗🍬",
          category1: { name: "Healthy", emoji: "🥗", color: "#22c55e" },
          category2: { name: "Treats", emoji: "🍬", color: "#f59e0b" },
          items: [
            { id: 1, name: "Salad", emoji: "🥗", category: "Healthy" },
            { id: 2, name: "Candy", emoji: "🍬", category: "Treats" },
            { id: 3, name: "Milk", emoji: "🥛", category: "Healthy" },
            { id: 4, name: "Cookie", emoji: "🍪", category: "Treats" },
            { id: 5, name: "Apple", emoji: "🍎", category: "Healthy" },
            { id: 6, name: "Ice Cream", emoji: "🍦", category: "Treats" },
          ]
        }
      ],
      animals: [
        {
          instruction: "Sort the animals into Farm and Wild! 🐄🦁",
          category1: { name: "Farm Animals", emoji: "🐄", color: "#8b5cf6" },
          category2: { name: "Wild Animals", emoji: "🦁", color: "#f59e0b" },
          items: [
            { id: 1, name: "Cow", emoji: "🐄", category: "Farm Animals" },
            { id: 2, name: "Lion", emoji: "🦁", category: "Wild Animals" },
            { id: 3, name: "Chicken", emoji: "🐔", category: "Farm Animals" },
            { id: 4, name: "Elephant", emoji: "🐘", category: "Wild Animals" },
            { id: 5, name: "Pig", emoji: "🐷", category: "Farm Animals" },
            { id: 6, name: "Tiger", emoji: "🐯", category: "Wild Animals" },
          ]
        },
        {
          instruction: "Sort into Pets and Zoo Animals! 🐕🦒",
          category1: { name: "Pets", emoji: "🐕", color: "#3b82f6" },
          category2: { name: "Zoo Animals", emoji: "🦒", color: "#22c55e" },
          items: [
            { id: 1, name: "Dog", emoji: "🐕", category: "Pets" },
            { id: 2, name: "Giraffe", emoji: "🦒", category: "Zoo Animals" },
            { id: 3, name: "Cat", emoji: "🐱", category: "Pets" },
            { id: 4, name: "Monkey", emoji: "🐒", category: "Zoo Animals" },
            { id: 5, name: "Fish", emoji: "🐟", category: "Pets" },
            { id: 6, name: "Zebra", emoji: "🦓", category: "Zoo Animals" },
          ]
        }
      ],
      colors: [
        {
          instruction: "Sort the items by color! 🔴🔵",
          category1: { name: "Red Things", emoji: "🔴", color: "#ef4444" },
          category2: { name: "Blue Things", emoji: "🔵", color: "#3b82f6" },
          items: [
            { id: 1, name: "Apple", emoji: "🍎", category: "Red Things" },
            { id: 2, name: "Ocean", emoji: "🌊", category: "Blue Things" },
            { id: 3, name: "Strawberry", emoji: "🍓", category: "Red Things" },
            { id: 4, name: "Sky", emoji: "🌤️", category: "Blue Things" },
            { id: 5, name: "Heart", emoji: "❤️", category: "Red Things" },
            { id: 6, name: "Blueberry", emoji: "🫐", category: "Blue Things" },
          ]
        },
        {
          instruction: "Sort into Warm and Cool Colors! 🟡🟢",
          category1: { name: "Warm Colors", emoji: "🟡", color: "#f59e0b" },
          category2: { name: "Cool Colors", emoji: "🟢", color: "#22c55e" },
          items: [
            { id: 1, name: "Sun", emoji: "☀️", category: "Warm Colors" },
            { id: 2, name: "Grass", emoji: "🌿", category: "Cool Colors" },
            { id: 3, name: "Fire", emoji: "🔥", category: "Warm Colors" },
            { id: 4, name: "Water", emoji: "💧", category: "Cool Colors" },
            { id: 5, name: "Orange", emoji: "🍊", category: "Warm Colors" },
            { id: 6, name: "Leaf", emoji: "🍃", category: "Cool Colors" },
          ]
        }
      ],
      transportation: [
        {
          instruction: "Sort vehicles by where they go! 🚗✈️",
          category1: { name: "On Land", emoji: "🚗", color: "#8b5cf6" },
          category2: { name: "In the Sky", emoji: "✈️", color: "#3b82f6" },
          items: [
            { id: 1, name: "Car", emoji: "🚗", category: "On Land" },
            { id: 2, name: "Airplane", emoji: "✈️", category: "In the Sky" },
            { id: 3, name: "Bus", emoji: "🚌", category: "On Land" },
            { id: 4, name: "Helicopter", emoji: "🚁", category: "In the Sky" },
            { id: 5, name: "Train", emoji: "🚂", category: "On Land" },
            { id: 6, name: "Rocket", emoji: "🚀", category: "In the Sky" },
          ]
        },
        {
          instruction: "Sort into Land and Water vehicles! 🚗🚢",
          category1: { name: "Land", emoji: "🚗", color: "#22c55e" },
          category2: { name: "Water", emoji: "🚢", color: "#3b82f6" },
          items: [
            { id: 1, name: "Bicycle", emoji: "🚲", category: "Land" },
            { id: 2, name: "Boat", emoji: "⛵", category: "Water" },
            { id: 3, name: "Motorcycle", emoji: "🏍️", category: "Land" },
            { id: 4, name: "Ship", emoji: "🚢", category: "Water" },
            { id: 5, name: "Truck", emoji: "🚚", category: "Land" },
            { id: 6, name: "Canoe", emoji: "🛶", category: "Water" },
          ]
        }
      ],
      safety: [
        {
          instruction: "Sort into Safe and Dangerous! ✅⚠️",
          category1: { name: "Safe", emoji: "✅", color: "#22c55e" },
          category2: { name: "Dangerous", emoji: "⚠️", color: "#ef4444" },
          items: [
            { id: 1, name: "Helmet", emoji: "⛑️", category: "Safe" },
            { id: 2, name: "Fire", emoji: "🔥", category: "Dangerous" },
            { id: 3, name: "Seatbelt", emoji: "🪢", category: "Safe" },
            { id: 4, name: "Sharp Knife", emoji: "🔪", category: "Dangerous" },
            { id: 5, name: "Crosswalk", emoji: "🚶", category: "Safe" },
            { id: 6, name: "Stranger", emoji: "👤", category: "Dangerous" },
          ]
        }
      ],
      nature: [
        {
          instruction: "Sort into Living and Non-Living things! 🌱🪨",
          category1: { name: "Living", emoji: "🌱", color: "#22c55e" },
          category2: { name: "Non-Living", emoji: "🪨", color: "#6b7280" },
          items: [
            { id: 1, name: "Flower", emoji: "🌸", category: "Living" },
            { id: 2, name: "Rock", emoji: "🪨", category: "Non-Living" },
            { id: 3, name: "Bird", emoji: "🐦", category: "Living" },
            { id: 4, name: "Water", emoji: "💧", category: "Non-Living" },
            { id: 5, name: "Tree", emoji: "🌳", category: "Living" },
            { id: 6, name: "Cloud", emoji: "☁️", category: "Non-Living" },
          ]
        }
      ],
      daily: [
        {
          instruction: "Sort into Morning and Night activities! 🌅🌙",
          category1: { name: "Morning", emoji: "🌅", color: "#f59e0b" },
          category2: { name: "Night", emoji: "🌙", color: "#6366f1" },
          items: [
            { id: 1, name: "Wake Up", emoji: "⏰", category: "Morning" },
            { id: 2, name: "Sleep", emoji: "😴", category: "Night" },
            { id: 3, name: "Breakfast", emoji: "🥣", category: "Morning" },
            { id: 4, name: "Brush Teeth", emoji: "🪥", category: "Night" },
            { id: 5, name: "Get Dressed", emoji: "👕", category: "Morning" },
            { id: 6, name: "Story Time", emoji: "📖", category: "Night" },
          ]
        }
      ],
      reading: [
        {
          instruction: "Sort letters into Vowels and Consonants! 🅰️🅱️",
          category1: { name: "Vowels", emoji: "🅰️", color: "#ef4444" },
          category2: { name: "Consonants", emoji: "🅱️", color: "#3b82f6" },
          items: [
            { id: 1, name: "A", emoji: "🅰️", category: "Vowels" },
            { id: 2, name: "B", emoji: "🅱️", category: "Consonants" },
            { id: 3, name: "E", emoji: "📧", category: "Vowels" },
            { id: 4, name: "C", emoji: "©️", category: "Consonants" },
            { id: 5, name: "I", emoji: "ℹ️", category: "Vowels" },
            { id: 6, name: "D", emoji: "🇩", category: "Consonants" },
          ]
        }
      ],
      abc: [
        {
          instruction: "Sort into Things that start with A and B! 🍎🏀",
          category1: { name: "Starts with A", emoji: "🍎", color: "#ef4444" },
          category2: { name: "Starts with B", emoji: "🏀", color: "#f59e0b" },
          items: [
            { id: 1, name: "Apple", emoji: "🍎", category: "Starts with A" },
            { id: 2, name: "Ball", emoji: "🏀", category: "Starts with B" },
            { id: 3, name: "Ant", emoji: "🐜", category: "Starts with A" },
            { id: 4, name: "Banana", emoji: "🍌", category: "Starts with B" },
            { id: 5, name: "Airplane", emoji: "✈️", category: "Starts with A" },
            { id: 6, name: "Bird", emoji: "🐦", category: "Starts with B" },
          ]
        },
        {
          instruction: "Sort into Things that start with C and D! 🐱🐕",
          category1: { name: "Starts with C", emoji: "🐱", color: "#22c55e" },
          category2: { name: "Starts with D", emoji: "🐕", color: "#3b82f6" },
          items: [
            { id: 1, name: "Cat", emoji: "🐱", category: "Starts with C" },
            { id: 2, name: "Dog", emoji: "🐕", category: "Starts with D" },
            { id: 3, name: "Car", emoji: "🚗", category: "Starts with C" },
            { id: 4, name: "Duck", emoji: "🦆", category: "Starts with D" },
            { id: 5, name: "Cake", emoji: "🎂", category: "Starts with C" },
            { id: 6, name: "Door", emoji: "🚪", category: "Starts with D" },
          ]
        },
        {
          instruction: "Sort letters into Vowels and Consonants! 🅰️🅱️",
          category1: { name: "Vowels", emoji: "🅰️", color: "#8b5cf6" },
          category2: { name: "Consonants", emoji: "🅱️", color: "#f59e0b" },
          items: [
            { id: 1, name: "A", emoji: "🅰️", category: "Vowels" },
            { id: 2, name: "B", emoji: "🅱️", category: "Consonants" },
            { id: 3, name: "E", emoji: "🔤", category: "Vowels" },
            { id: 4, name: "C", emoji: "🔤", category: "Consonants" },
            { id: 5, name: "I", emoji: "🔤", category: "Vowels" },
            { id: 6, name: "D", emoji: "🔤", category: "Consonants" },
          ]
        }
      ],
      counting: [
        {
          instruction: "Sort numbers into Small and Big! 🔢",
          category1: { name: "Small (1-5)", emoji: "1️⃣", color: "#3b82f6" },
          category2: { name: "Big (6-10)", emoji: "🔟", color: "#8b5cf6" },
          items: [
            { id: 1, name: "One", emoji: "1️⃣", category: "Small (1-5)" },
            { id: 2, name: "Seven", emoji: "7️⃣", category: "Big (6-10)" },
            { id: 3, name: "Three", emoji: "3️⃣", category: "Small (1-5)" },
            { id: 4, name: "Nine", emoji: "9️⃣", category: "Big (6-10)" },
            { id: 5, name: "Five", emoji: "5️⃣", category: "Small (1-5)" },
            { id: 6, name: "Ten", emoji: "🔟", category: "Big (6-10)" },
          ]
        },
        {
          instruction: "Count and sort! How many? 🔢",
          category1: { name: "Less than 3", emoji: "2️⃣", color: "#22c55e" },
          category2: { name: "More than 3", emoji: "5️⃣", color: "#ef4444" },
          items: [
            { id: 1, name: "One Apple", emoji: "🍎", category: "Less than 3" },
            { id: 2, name: "Five Stars", emoji: "⭐⭐⭐⭐⭐", category: "More than 3" },
            { id: 3, name: "Two Balls", emoji: "⚽⚽", category: "Less than 3" },
            { id: 4, name: "Four Fish", emoji: "🐟🐟🐟🐟", category: "More than 3" },
            { id: 5, name: "One Sun", emoji: "☀️", category: "Less than 3" },
            { id: 6, name: "Six Hearts", emoji: "❤️❤️❤️❤️❤️❤️", category: "More than 3" },
          ]
        },
        {
          instruction: "Sort into groups of items! 👫👨‍👩‍👧‍👦",
          category1: { name: "Pairs (2)", emoji: "👫", color: "#f59e0b" },
          category2: { name: "Groups (4+)", emoji: "👨‍👩‍👧‍👦", color: "#3b82f6" },
          items: [
            { id: 1, name: "Two Eyes", emoji: "👀", category: "Pairs (2)" },
            { id: 2, name: "Five Fingers", emoji: "🖐️", category: "Groups (4+)" },
            { id: 3, name: "Two Ears", emoji: "👂👂", category: "Pairs (2)" },
            { id: 4, name: "Four Seasons", emoji: "🌸☀️🍂❄️", category: "Groups (4+)" },
            { id: 5, name: "Two Hands", emoji: "🤲", category: "Pairs (2)" },
            { id: 6, name: "Seven Days", emoji: "📅", category: "Groups (4+)" },
          ]
        }
      ],
      math: [
        {
          instruction: "Sort shapes into Circles and Squares! ⭕⬜",
          category1: { name: "Round", emoji: "⭕", color: "#ef4444" },
          category2: { name: "Square", emoji: "⬜", color: "#3b82f6" },
          items: [
            { id: 1, name: "Ball", emoji: "⚽", category: "Round" },
            { id: 2, name: "Box", emoji: "📦", category: "Square" },
            { id: 3, name: "Sun", emoji: "☀️", category: "Round" },
            { id: 4, name: "Window", emoji: "🪟", category: "Square" },
            { id: 5, name: "Cookie", emoji: "🍪", category: "Round" },
            { id: 6, name: "Book", emoji: "📕", category: "Square" },
          ]
        },
        {
          instruction: "Sort into Big and Small! 🐘🐜",
          category1: { name: "Big Things", emoji: "🐘", color: "#8b5cf6" },
          category2: { name: "Small Things", emoji: "🐜", color: "#f59e0b" },
          items: [
            { id: 1, name: "Elephant", emoji: "🐘", category: "Big Things" },
            { id: 2, name: "Ant", emoji: "🐜", category: "Small Things" },
            { id: 3, name: "House", emoji: "🏠", category: "Big Things" },
            { id: 4, name: "Button", emoji: "🔘", category: "Small Things" },
            { id: 5, name: "Tree", emoji: "🌳", category: "Big Things" },
            { id: 6, name: "Coin", emoji: "🪙", category: "Small Things" },
          ]
        },
        {
          instruction: "Sort by how many! 1️⃣👫",
          category1: { name: "One", emoji: "1️⃣", color: "#22c55e" },
          category2: { name: "Many", emoji: "👫", color: "#3b82f6" },
          items: [
            { id: 1, name: "One Apple", emoji: "🍎", category: "One" },
            { id: 2, name: "Many Stars", emoji: "✨", category: "Many" },
            { id: 3, name: "One Moon", emoji: "🌙", category: "One" },
            { id: 4, name: "Many Flowers", emoji: "💐", category: "Many" },
            { id: 5, name: "One Sun", emoji: "☀️", category: "One" },
            { id: 6, name: "Many Fish", emoji: "🐟🐟", category: "Many" },
          ]
        }
      ],
      language: [
        {
          instruction: "Sort into Things and Actions! 🎁🏃",
          category1: { name: "Things (Nouns)", emoji: "🎁", color: "#8b5cf6" },
          category2: { name: "Actions (Verbs)", emoji: "🏃", color: "#22c55e" },
          items: [
            { id: 1, name: "Dog", emoji: "🐕", category: "Things (Nouns)" },
            { id: 2, name: "Run", emoji: "🏃", category: "Actions (Verbs)" },
            { id: 3, name: "House", emoji: "🏠", category: "Things (Nouns)" },
            { id: 4, name: "Jump", emoji: "🦘", category: "Actions (Verbs)" },
            { id: 5, name: "Tree", emoji: "🌳", category: "Things (Nouns)" },
            { id: 6, name: "Eat", emoji: "🍽️", category: "Actions (Verbs)" },
          ]
        },
        {
          instruction: "Sort words that rhyme! 🎵",
          category1: { name: "Rhymes with Cat", emoji: "🐱", color: "#ef4444" },
          category2: { name: "Rhymes with Dog", emoji: "🐕", color: "#3b82f6" },
          items: [
            { id: 1, name: "Hat", emoji: "🎩", category: "Rhymes with Cat" },
            { id: 2, name: "Log", emoji: "🪵", category: "Rhymes with Dog" },
            { id: 3, name: "Bat", emoji: "🦇", category: "Rhymes with Cat" },
            { id: 4, name: "Frog", emoji: "🐸", category: "Rhymes with Dog" },
            { id: 5, name: "Mat", emoji: "🟫", category: "Rhymes with Cat" },
            { id: 6, name: "Fog", emoji: "🌫️", category: "Rhymes with Dog" },
          ]
        },
        {
          instruction: "Sort by first letter! A or B? 🔤",
          category1: { name: "Starts with A", emoji: "🅰️", color: "#22c55e" },
          category2: { name: "Starts with B", emoji: "🅱️", color: "#8b5cf6" },
          items: [
            { id: 1, name: "Apple", emoji: "🍎", category: "Starts with A" },
            { id: 2, name: "Ball", emoji: "⚽", category: "Starts with B" },
            { id: 3, name: "Ant", emoji: "🐜", category: "Starts with A" },
            { id: 4, name: "Bear", emoji: "🐻", category: "Starts with B" },
            { id: 5, name: "Airplane", emoji: "✈️", category: "Starts with A" },
            { id: 6, name: "Banana", emoji: "🍌", category: "Starts with B" },
          ]
        }
      ],
      science: [
        {
          instruction: "Sort into Day and Night! ☀️🌙",
          category1: { name: "Day Sky", emoji: "☀️", color: "#f59e0b" },
          category2: { name: "Night Sky", emoji: "🌙", color: "#6366f1" },
          items: [
            { id: 1, name: "Sun", emoji: "☀️", category: "Day Sky" },
            { id: 2, name: "Moon", emoji: "🌙", category: "Night Sky" },
            { id: 3, name: "Rainbow", emoji: "🌈", category: "Day Sky" },
            { id: 4, name: "Stars", emoji: "⭐", category: "Night Sky" },
            { id: 5, name: "Clouds", emoji: "☁️", category: "Day Sky" },
            { id: 6, name: "Owl", emoji: "🦉", category: "Night Sky" },
          ]
        },
        {
          instruction: "Sort into Hot and Cold! 🔥❄️",
          category1: { name: "Hot Things", emoji: "🔥", color: "#ef4444" },
          category2: { name: "Cold Things", emoji: "❄️", color: "#3b82f6" },
          items: [
            { id: 1, name: "Fire", emoji: "🔥", category: "Hot Things" },
            { id: 2, name: "Ice", emoji: "🧊", category: "Cold Things" },
            { id: 3, name: "Sun", emoji: "☀️", category: "Hot Things" },
            { id: 4, name: "Snow", emoji: "❄️", category: "Cold Things" },
            { id: 5, name: "Soup", emoji: "🍲", category: "Hot Things" },
            { id: 6, name: "Ice Cream", emoji: "🍦", category: "Cold Things" },
          ]
        },
        {
          instruction: "Sort by where they live! 🌊🌳",
          category1: { name: "In Water", emoji: "🌊", color: "#3b82f6" },
          category2: { name: "On Land", emoji: "🌳", color: "#22c55e" },
          items: [
            { id: 1, name: "Fish", emoji: "🐟", category: "In Water" },
            { id: 2, name: "Dog", emoji: "🐕", category: "On Land" },
            { id: 3, name: "Whale", emoji: "🐋", category: "In Water" },
            { id: 4, name: "Cat", emoji: "🐱", category: "On Land" },
            { id: 5, name: "Dolphin", emoji: "🐬", category: "In Water" },
            { id: 6, name: "Bird", emoji: "🐦", category: "On Land" },
          ]
        }
      ]
    },
    elementary: {
      math: [
        {
          instruction: "Sort numbers into Even and Odd! 🔢",
          category1: { name: "Even Numbers", emoji: "2️⃣", color: "#3b82f6" },
          category2: { name: "Odd Numbers", emoji: "3️⃣", color: "#ef4444" },
          items: [
            { id: 1, name: "Two", emoji: "2️⃣", category: "Even Numbers" },
            { id: 2, name: "Three", emoji: "3️⃣", category: "Odd Numbers" },
            { id: 3, name: "Four", emoji: "4️⃣", category: "Even Numbers" },
            { id: 4, name: "Seven", emoji: "7️⃣", category: "Odd Numbers" },
            { id: 5, name: "Eight", emoji: "8️⃣", category: "Even Numbers" },
            { id: 6, name: "Nine", emoji: "9️⃣", category: "Odd Numbers" },
          ]
        },
        {
          instruction: "Sort into Greater than 10 and Less than 10! 🔢",
          category1: { name: "Greater than 10", emoji: "⬆️", color: "#22c55e" },
          category2: { name: "Less than 10", emoji: "⬇️", color: "#f59e0b" },
          items: [
            { id: 1, name: "Fifteen", emoji: "1️⃣5️⃣", category: "Greater than 10" },
            { id: 2, name: "Five", emoji: "5️⃣", category: "Less than 10" },
            { id: 3, name: "Twenty", emoji: "2️⃣0️⃣", category: "Greater than 10" },
            { id: 4, name: "Six", emoji: "6️⃣", category: "Less than 10" },
            { id: 5, name: "Twelve", emoji: "1️⃣2️⃣", category: "Greater than 10" },
            { id: 6, name: "Three", emoji: "3️⃣", category: "Less than 10" },
          ]
        },
        {
          instruction: "Sort shapes by number of sides! 📐",
          category1: { name: "3 Sides", emoji: "🔺", color: "#8b5cf6" },
          category2: { name: "4 Sides", emoji: "⬜", color: "#3b82f6" },
          items: [
            { id: 1, name: "Triangle", emoji: "🔺", category: "3 Sides" },
            { id: 2, name: "Square", emoji: "⬜", category: "4 Sides" },
            { id: 3, name: "Yield Sign", emoji: "⚠️", category: "3 Sides" },
            { id: 4, name: "Rectangle", emoji: "▬", category: "4 Sides" },
            { id: 5, name: "Pizza Slice", emoji: "🍕", category: "3 Sides" },
            { id: 6, name: "Window", emoji: "🪟", category: "4 Sides" },
          ]
        },
        {
          instruction: "Sort into Addition and Subtraction results! ➕➖",
          category1: { name: "Equals 10", emoji: "🔟", color: "#22c55e" },
          category2: { name: "Equals 5", emoji: "5️⃣", color: "#ef4444" },
          items: [
            { id: 1, name: "5 + 5", emoji: "➕", category: "Equals 10" },
            { id: 2, name: "3 + 2", emoji: "➕", category: "Equals 5" },
            { id: 3, name: "7 + 3", emoji: "➕", category: "Equals 10" },
            { id: 4, name: "10 - 5", emoji: "➖", category: "Equals 5" },
            { id: 5, name: "6 + 4", emoji: "➕", category: "Equals 10" },
            { id: 6, name: "8 - 3", emoji: "➖", category: "Equals 5" },
          ]
        }
      ],
      science: [
        {
          instruction: "Sort into Solids and Liquids! 🧊💧",
          category1: { name: "Solids", emoji: "🧊", color: "#6366f1" },
          category2: { name: "Liquids", emoji: "💧", color: "#3b82f6" },
          items: [
            { id: 1, name: "Ice", emoji: "🧊", category: "Solids" },
            { id: 2, name: "Water", emoji: "💧", category: "Liquids" },
            { id: 3, name: "Rock", emoji: "🪨", category: "Solids" },
            { id: 4, name: "Juice", emoji: "🧃", category: "Liquids" },
            { id: 5, name: "Wood", emoji: "🪵", category: "Solids" },
            { id: 6, name: "Milk", emoji: "🥛", category: "Liquids" },
          ]
        },
        {
          instruction: "Sort into Living and Non-Living things! 🌱🪨",
          category1: { name: "Living", emoji: "🌱", color: "#22c55e" },
          category2: { name: "Non-Living", emoji: "🪨", color: "#6b7280" },
          items: [
            { id: 1, name: "Tree", emoji: "🌳", category: "Living" },
            { id: 2, name: "Rock", emoji: "🪨", category: "Non-Living" },
            { id: 3, name: "Bird", emoji: "🐦", category: "Living" },
            { id: 4, name: "Chair", emoji: "🪑", category: "Non-Living" },
            { id: 5, name: "Flower", emoji: "🌸", category: "Living" },
            { id: 6, name: "Ball", emoji: "⚽", category: "Non-Living" },
          ]
        },
        {
          instruction: "Sort animals by what they eat! 🥬🍖",
          category1: { name: "Herbivores", emoji: "🥬", color: "#22c55e" },
          category2: { name: "Carnivores", emoji: "🍖", color: "#ef4444" },
          items: [
            { id: 1, name: "Cow", emoji: "🐄", category: "Herbivores" },
            { id: 2, name: "Lion", emoji: "🦁", category: "Carnivores" },
            { id: 3, name: "Rabbit", emoji: "🐰", category: "Herbivores" },
            { id: 4, name: "Shark", emoji: "🦈", category: "Carnivores" },
            { id: 5, name: "Deer", emoji: "🦌", category: "Herbivores" },
            { id: 6, name: "Wolf", emoji: "🐺", category: "Carnivores" },
          ]
        },
        {
          instruction: "Sort by weather type! ☀️🌧️",
          category1: { name: "Sunny Weather", emoji: "☀️", color: "#f59e0b" },
          category2: { name: "Rainy Weather", emoji: "🌧️", color: "#3b82f6" },
          items: [
            { id: 1, name: "Sunglasses", emoji: "🕶️", category: "Sunny Weather" },
            { id: 2, name: "Umbrella", emoji: "☂️", category: "Rainy Weather" },
            { id: 3, name: "Sunscreen", emoji: "🧴", category: "Sunny Weather" },
            { id: 4, name: "Raincoat", emoji: "🧥", category: "Rainy Weather" },
            { id: 5, name: "Beach Ball", emoji: "🏖️", category: "Sunny Weather" },
            { id: 6, name: "Boots", emoji: "👢", category: "Rainy Weather" },
          ]
        }
      ],
      geography: [
        {
          instruction: "Sort into Continents and Oceans! 🗺️🌊",
          category1: { name: "Continents", emoji: "🗺️", color: "#22c55e" },
          category2: { name: "Oceans", emoji: "🌊", color: "#3b82f6" },
          items: [
            { id: 1, name: "Africa", emoji: "🌍", category: "Continents" },
            { id: 2, name: "Pacific", emoji: "🌊", category: "Oceans" },
            { id: 3, name: "Asia", emoji: "🌏", category: "Continents" },
            { id: 4, name: "Atlantic", emoji: "🌊", category: "Oceans" },
            { id: 5, name: "Europe", emoji: "🌍", category: "Continents" },
            { id: 6, name: "Indian", emoji: "🌊", category: "Oceans" },
          ]
        },
        {
          instruction: "Sort by land type! 🏔️🏜️",
          category1: { name: "Mountains", emoji: "🏔️", color: "#6b7280" },
          category2: { name: "Deserts", emoji: "🏜️", color: "#f59e0b" },
          items: [
            { id: 1, name: "Everest", emoji: "🏔️", category: "Mountains" },
            { id: 2, name: "Sahara", emoji: "🏜️", category: "Deserts" },
            { id: 3, name: "Alps", emoji: "⛰️", category: "Mountains" },
            { id: 4, name: "Gobi", emoji: "🏜️", category: "Deserts" },
            { id: 5, name: "Rockies", emoji: "🏔️", category: "Mountains" },
            { id: 6, name: "Mojave", emoji: "🌵", category: "Deserts" },
          ]
        },
        {
          instruction: "Sort countries by size! 🗺️",
          category1: { name: "Big Countries", emoji: "🌍", color: "#22c55e" },
          category2: { name: "Small Countries", emoji: "🏝️", color: "#8b5cf6" },
          items: [
            { id: 1, name: "Russia", emoji: "🇷🇺", category: "Big Countries" },
            { id: 2, name: "Monaco", emoji: "🇲🇨", category: "Small Countries" },
            { id: 3, name: "Canada", emoji: "🇨🇦", category: "Big Countries" },
            { id: 4, name: "Vatican", emoji: "🇻🇦", category: "Small Countries" },
            { id: 5, name: "China", emoji: "🇨🇳", category: "Big Countries" },
            { id: 6, name: "Malta", emoji: "🇲🇹", category: "Small Countries" },
          ]
        }
      ],
      history: [
        {
          instruction: "Sort into Ancient and Modern! 🏛️🏙️",
          category1: { name: "Ancient", emoji: "🏛️", color: "#f59e0b" },
          category2: { name: "Modern", emoji: "🏙️", color: "#6366f1" },
          items: [
            { id: 1, name: "Pyramids", emoji: "🔺", category: "Ancient" },
            { id: 2, name: "Computer", emoji: "💻", category: "Modern" },
            { id: 3, name: "Sword", emoji: "⚔️", category: "Ancient" },
            { id: 4, name: "Smartphone", emoji: "📱", category: "Modern" },
            { id: 5, name: "Castle", emoji: "🏰", category: "Ancient" },
            { id: 6, name: "Airplane", emoji: "✈️", category: "Modern" },
          ]
        },
        {
          instruction: "Sort famous people by era! 👑🎩",
          category1: { name: "Kings & Queens", emoji: "👑", color: "#f59e0b" },
          category2: { name: "Presidents", emoji: "🎩", color: "#3b82f6" },
          items: [
            { id: 1, name: "Cleopatra", emoji: "👑", category: "Kings & Queens" },
            { id: 2, name: "Lincoln", emoji: "🎩", category: "Presidents" },
            { id: 3, name: "King Henry", emoji: "👑", category: "Kings & Queens" },
            { id: 4, name: "Washington", emoji: "🎩", category: "Presidents" },
            { id: 5, name: "Queen Victoria", emoji: "👑", category: "Kings & Queens" },
            { id: 6, name: "Roosevelt", emoji: "🎩", category: "Presidents" },
          ]
        },
        {
          instruction: "Sort inventions by century! 🔧💡",
          category1: { name: "Before 1900", emoji: "🔧", color: "#8b5cf6" },
          category2: { name: "After 1900", emoji: "💡", color: "#22c55e" },
          items: [
            { id: 1, name: "Wheel", emoji: "☸️", category: "Before 1900" },
            { id: 2, name: "Internet", emoji: "🌐", category: "After 1900" },
            { id: 3, name: "Printing Press", emoji: "📰", category: "Before 1900" },
            { id: 4, name: "Television", emoji: "📺", category: "After 1900" },
            { id: 5, name: "Steam Engine", emoji: "🚂", category: "Before 1900" },
            { id: 6, name: "Rocket", emoji: "🚀", category: "After 1900" },
          ]
        }
      ],
      language: [
        {
          instruction: "Sort words into Nouns and Adjectives! 📝",
          category1: { name: "Nouns", emoji: "📦", color: "#8b5cf6" },
          category2: { name: "Adjectives", emoji: "🌈", color: "#22c55e" },
          items: [
            { id: 1, name: "Cat", emoji: "🐱", category: "Nouns" },
            { id: 2, name: "Happy", emoji: "😊", category: "Adjectives" },
            { id: 3, name: "Book", emoji: "📕", category: "Nouns" },
            { id: 4, name: "Big", emoji: "🦣", category: "Adjectives" },
            { id: 5, name: "Teacher", emoji: "👩‍🏫", category: "Nouns" },
            { id: 6, name: "Fast", emoji: "⚡", category: "Adjectives" },
          ]
        },
        {
          instruction: "Sort words into Verbs and Nouns! 🏃📦",
          category1: { name: "Verbs (Actions)", emoji: "🏃", color: "#ef4444" },
          category2: { name: "Nouns (Things)", emoji: "📦", color: "#3b82f6" },
          items: [
            { id: 1, name: "Run", emoji: "🏃", category: "Verbs (Actions)" },
            { id: 2, name: "House", emoji: "🏠", category: "Nouns (Things)" },
            { id: 3, name: "Jump", emoji: "🦘", category: "Verbs (Actions)" },
            { id: 4, name: "Apple", emoji: "🍎", category: "Nouns (Things)" },
            { id: 5, name: "Sing", emoji: "🎤", category: "Verbs (Actions)" },
            { id: 6, name: "Car", emoji: "🚗", category: "Nouns (Things)" },
          ]
        },
        {
          instruction: "Sort into Singular and Plural! 1️⃣🔢",
          category1: { name: "Singular (One)", emoji: "1️⃣", color: "#f59e0b" },
          category2: { name: "Plural (Many)", emoji: "🔢", color: "#8b5cf6" },
          items: [
            { id: 1, name: "Dog", emoji: "🐕", category: "Singular (One)" },
            { id: 2, name: "Dogs", emoji: "🐕🐕", category: "Plural (Many)" },
            { id: 3, name: "Cat", emoji: "🐱", category: "Singular (One)" },
            { id: 4, name: "Cats", emoji: "🐱🐱", category: "Plural (Many)" },
            { id: 5, name: "Bird", emoji: "🐦", category: "Singular (One)" },
            { id: 6, name: "Birds", emoji: "🐦🐦", category: "Plural (Many)" },
          ]
        }
      ],
      truefalse: [
        {
          instruction: "Sort facts into True and False! ✅❌",
          category1: { name: "True Facts", emoji: "✅", color: "#22c55e" },
          category2: { name: "False Facts", emoji: "❌", color: "#ef4444" },
          items: [
            { id: 1, name: "Sun is hot", emoji: "☀️", category: "True Facts" },
            { id: 2, name: "Fish can fly", emoji: "🐟", category: "False Facts" },
            { id: 3, name: "Water is wet", emoji: "💧", category: "True Facts" },
            { id: 4, name: "Ice is warm", emoji: "🧊", category: "False Facts" },
            { id: 5, name: "Dogs bark", emoji: "🐕", category: "True Facts" },
            { id: 6, name: "Trees walk", emoji: "🌳", category: "False Facts" },
          ]
        },
        {
          instruction: "More True or False! ✅❌",
          category1: { name: "True Facts", emoji: "✅", color: "#22c55e" },
          category2: { name: "False Facts", emoji: "❌", color: "#ef4444" },
          items: [
            { id: 1, name: "Birds have wings", emoji: "🐦", category: "True Facts" },
            { id: 2, name: "Cats say moo", emoji: "🐱", category: "False Facts" },
            { id: 3, name: "Earth is round", emoji: "🌍", category: "True Facts" },
            { id: 4, name: "Fire is cold", emoji: "🔥", category: "False Facts" },
            { id: 5, name: "Moon shines at night", emoji: "🌙", category: "True Facts" },
            { id: 6, name: "Rocks can talk", emoji: "🪨", category: "False Facts" },
          ]
        },
        {
          instruction: "Science True or False! 🔬",
          category1: { name: "True Facts", emoji: "✅", color: "#22c55e" },
          category2: { name: "False Facts", emoji: "❌", color: "#ef4444" },
          items: [
            { id: 1, name: "Plants need water", emoji: "🌱", category: "True Facts" },
            { id: 2, name: "Snow is hot", emoji: "❄️", category: "False Facts" },
            { id: 3, name: "Humans breathe air", emoji: "🫁", category: "True Facts" },
            { id: 4, name: "Stars are close", emoji: "⭐", category: "False Facts" },
            { id: 5, name: "Rain comes from clouds", emoji: "🌧️", category: "True Facts" },
            { id: 6, name: "Elephants are tiny", emoji: "🐘", category: "False Facts" },
          ]
        }
      ],
      art: [
        {
          instruction: "Sort into Primary and Secondary Colors! 🎨",
          category1: { name: "Primary", emoji: "🔴", color: "#ef4444" },
          category2: { name: "Secondary", emoji: "🟢", color: "#22c55e" },
          items: [
            { id: 1, name: "Red", emoji: "🔴", category: "Primary" },
            { id: 2, name: "Green", emoji: "🟢", category: "Secondary" },
            { id: 3, name: "Blue", emoji: "🔵", category: "Primary" },
            { id: 4, name: "Orange", emoji: "🟠", category: "Secondary" },
            { id: 5, name: "Yellow", emoji: "🟡", category: "Primary" },
            { id: 6, name: "Purple", emoji: "🟣", category: "Secondary" },
          ]
        },
        {
          instruction: "Sort by art type! 🖼️🎭",
          category1: { name: "Visual Art", emoji: "🖼️", color: "#8b5cf6" },
          category2: { name: "Performing Art", emoji: "🎭", color: "#f59e0b" },
          items: [
            { id: 1, name: "Painting", emoji: "🖼️", category: "Visual Art" },
            { id: 2, name: "Dancing", emoji: "💃", category: "Performing Art" },
            { id: 3, name: "Sculpture", emoji: "🗿", category: "Visual Art" },
            { id: 4, name: "Singing", emoji: "🎤", category: "Performing Art" },
            { id: 5, name: "Drawing", emoji: "✏️", category: "Visual Art" },
            { id: 6, name: "Acting", emoji: "🎭", category: "Performing Art" },
          ]
        },
        {
          instruction: "Sort into Warm and Cool Colors! 🔥❄️",
          category1: { name: "Warm Colors", emoji: "🔥", color: "#ef4444" },
          category2: { name: "Cool Colors", emoji: "❄️", color: "#3b82f6" },
          items: [
            { id: 1, name: "Red", emoji: "🔴", category: "Warm Colors" },
            { id: 2, name: "Blue", emoji: "🔵", category: "Cool Colors" },
            { id: 3, name: "Orange", emoji: "🟠", category: "Warm Colors" },
            { id: 4, name: "Green", emoji: "🟢", category: "Cool Colors" },
            { id: 5, name: "Yellow", emoji: "🟡", category: "Warm Colors" },
            { id: 6, name: "Purple", emoji: "🟣", category: "Cool Colors" },
          ]
        }
      ],
      health: [
        {
          instruction: "Sort into Healthy Habits and Unhealthy Habits! 💪",
          category1: { name: "Healthy", emoji: "💪", color: "#22c55e" },
          category2: { name: "Unhealthy", emoji: "🚫", color: "#ef4444" },
          items: [
            { id: 1, name: "Exercise", emoji: "🏃", category: "Healthy" },
            { id: 2, name: "Too Much TV", emoji: "📺", category: "Unhealthy" },
            { id: 3, name: "Eat Veggies", emoji: "🥦", category: "Healthy" },
            { id: 4, name: "Skip Sleep", emoji: "😫", category: "Unhealthy" },
            { id: 5, name: "Drink Water", emoji: "💧", category: "Healthy" },
            { id: 6, name: "Too Much Sugar", emoji: "🍭", category: "Unhealthy" },
          ]
        },
        {
          instruction: "Sort foods into Healthy and Junk Food! 🥗🍟",
          category1: { name: "Healthy Food", emoji: "🥗", color: "#22c55e" },
          category2: { name: "Junk Food", emoji: "🍟", color: "#f59e0b" },
          items: [
            { id: 1, name: "Salad", emoji: "🥗", category: "Healthy Food" },
            { id: 2, name: "French Fries", emoji: "🍟", category: "Junk Food" },
            { id: 3, name: "Apple", emoji: "🍎", category: "Healthy Food" },
            { id: 4, name: "Candy", emoji: "🍬", category: "Junk Food" },
            { id: 5, name: "Carrots", emoji: "🥕", category: "Healthy Food" },
            { id: 6, name: "Soda", emoji: "🥤", category: "Junk Food" },
          ]
        },
        {
          instruction: "Sort activities by energy level! 🏃😴",
          category1: { name: "Active", emoji: "🏃", color: "#ef4444" },
          category2: { name: "Restful", emoji: "😴", color: "#3b82f6" },
          items: [
            { id: 1, name: "Running", emoji: "🏃", category: "Active" },
            { id: 2, name: "Sleeping", emoji: "😴", category: "Restful" },
            { id: 3, name: "Swimming", emoji: "🏊", category: "Active" },
            { id: 4, name: "Reading", emoji: "📖", category: "Restful" },
            { id: 5, name: "Soccer", emoji: "⚽", category: "Active" },
            { id: 6, name: "Meditation", emoji: "🧘", category: "Restful" },
          ]
        }
      ]
    },
    advanced: {
      math: [
        {
          instruction: "Sort into Prime and Composite Numbers! 🔢",
          category1: { name: "Prime", emoji: "⭐", color: "#f59e0b" },
          category2: { name: "Composite", emoji: "🔢", color: "#6366f1" },
          items: [
            { id: 1, name: "Two", emoji: "2️⃣", category: "Prime" },
            { id: 2, name: "Four", emoji: "4️⃣", category: "Composite" },
            { id: 3, name: "Seven", emoji: "7️⃣", category: "Prime" },
            { id: 4, name: "Nine", emoji: "9️⃣", category: "Composite" },
            { id: 5, name: "Eleven", emoji: "🔢", category: "Prime" },
            { id: 6, name: "Twelve", emoji: "🔢", category: "Composite" },
          ]
        },
        {
          instruction: "Sort into Positive and Negative Numbers! ➕➖",
          category1: { name: "Positive", emoji: "➕", color: "#22c55e" },
          category2: { name: "Negative", emoji: "➖", color: "#ef4444" },
          items: [
            { id: 1, name: "+5", emoji: "5️⃣", category: "Positive" },
            { id: 2, name: "-3", emoji: "3️⃣", category: "Negative" },
            { id: 3, name: "+10", emoji: "🔟", category: "Positive" },
            { id: 4, name: "-7", emoji: "7️⃣", category: "Negative" },
            { id: 5, name: "+2", emoji: "2️⃣", category: "Positive" },
            { id: 6, name: "-1", emoji: "1️⃣", category: "Negative" },
          ]
        },
        {
          instruction: "Sort by divisibility! 🔢",
          category1: { name: "Divisible by 3", emoji: "3️⃣", color: "#8b5cf6" },
          category2: { name: "Divisible by 5", emoji: "5️⃣", color: "#3b82f6" },
          items: [
            { id: 1, name: "Nine", emoji: "9️⃣", category: "Divisible by 3" },
            { id: 2, name: "Ten", emoji: "🔟", category: "Divisible by 5" },
            { id: 3, name: "Twelve", emoji: "🔢", category: "Divisible by 3" },
            { id: 4, name: "Twenty", emoji: "🔢", category: "Divisible by 5" },
            { id: 5, name: "Six", emoji: "6️⃣", category: "Divisible by 3" },
            { id: 6, name: "Fifteen", emoji: "🔢", category: "Divisible by 5" },
          ]
        },
        {
          instruction: "Sort fractions by size! ½ ¼",
          category1: { name: "Greater than ½", emoji: "⬆️", color: "#22c55e" },
          category2: { name: "Less than ½", emoji: "⬇️", color: "#ef4444" },
          items: [
            { id: 1, name: "¾", emoji: "🔢", category: "Greater than ½" },
            { id: 2, name: "¼", emoji: "🔢", category: "Less than ½" },
            { id: 3, name: "⅔", emoji: "🔢", category: "Greater than ½" },
            { id: 4, name: "⅓", emoji: "🔢", category: "Less than ½" },
            { id: 5, name: "⅘", emoji: "🔢", category: "Greater than ½" },
            { id: 6, name: "⅕", emoji: "🔢", category: "Less than ½" },
          ]
        }
      ],
      science: [
        {
          instruction: "Sort into Renewable and Non-Renewable Energy! ⚡",
          category1: { name: "Renewable", emoji: "☀️", color: "#22c55e" },
          category2: { name: "Non-Renewable", emoji: "⛽", color: "#6b7280" },
          items: [
            { id: 1, name: "Solar", emoji: "☀️", category: "Renewable" },
            { id: 2, name: "Coal", emoji: "🪨", category: "Non-Renewable" },
            { id: 3, name: "Wind", emoji: "💨", category: "Renewable" },
            { id: 4, name: "Oil", emoji: "🛢️", category: "Non-Renewable" },
            { id: 5, name: "Water", emoji: "💧", category: "Renewable" },
            { id: 6, name: "Gas", emoji: "⛽", category: "Non-Renewable" },
          ]
        },
        {
          instruction: "Sort elements by state at room temperature! 🧪",
          category1: { name: "Solid", emoji: "🧊", color: "#6366f1" },
          category2: { name: "Gas", emoji: "💨", color: "#22c55e" },
          items: [
            { id: 1, name: "Iron", emoji: "🔩", category: "Solid" },
            { id: 2, name: "Oxygen", emoji: "💨", category: "Gas" },
            { id: 3, name: "Gold", emoji: "🥇", category: "Solid" },
            { id: 4, name: "Nitrogen", emoji: "💨", category: "Gas" },
            { id: 5, name: "Copper", emoji: "🪙", category: "Solid" },
            { id: 6, name: "Helium", emoji: "🎈", category: "Gas" },
          ]
        },
        {
          instruction: "Sort by type of force! 🧲⬇️",
          category1: { name: "Push Force", emoji: "👐", color: "#ef4444" },
          category2: { name: "Pull Force", emoji: "🧲", color: "#3b82f6" },
          items: [
            { id: 1, name: "Kicking Ball", emoji: "⚽", category: "Push Force" },
            { id: 2, name: "Magnet", emoji: "🧲", category: "Pull Force" },
            { id: 3, name: "Throwing", emoji: "🤾", category: "Push Force" },
            { id: 4, name: "Gravity", emoji: "⬇️", category: "Pull Force" },
            { id: 5, name: "Punching", emoji: "👊", category: "Push Force" },
            { id: 6, name: "Tug of War", emoji: "🪢", category: "Pull Force" },
          ]
        }
      ],
      geography: [
        {
          instruction: "Sort countries by Hemisphere! 🌍",
          category1: { name: "Northern", emoji: "🌍", color: "#3b82f6" },
          category2: { name: "Southern", emoji: "🌏", color: "#22c55e" },
          items: [
            { id: 1, name: "USA", emoji: "🇺🇸", category: "Northern" },
            { id: 2, name: "Australia", emoji: "🇦🇺", category: "Southern" },
            { id: 3, name: "Canada", emoji: "🇨🇦", category: "Northern" },
            { id: 4, name: "Brazil", emoji: "🇧🇷", category: "Southern" },
            { id: 5, name: "Japan", emoji: "🇯🇵", category: "Northern" },
            { id: 6, name: "Argentina", emoji: "🇦🇷", category: "Southern" },
          ]
        },
        {
          instruction: "Sort by climate zone! 🌡️",
          category1: { name: "Tropical", emoji: "🌴", color: "#22c55e" },
          category2: { name: "Polar", emoji: "🧊", color: "#3b82f6" },
          items: [
            { id: 1, name: "Amazon", emoji: "🌳", category: "Tropical" },
            { id: 2, name: "Antarctica", emoji: "🐧", category: "Polar" },
            { id: 3, name: "Hawaii", emoji: "🏝️", category: "Tropical" },
            { id: 4, name: "Arctic", emoji: "🐻‍❄️", category: "Polar" },
            { id: 5, name: "Caribbean", emoji: "🏖️", category: "Tropical" },
            { id: 6, name: "Greenland", emoji: "🧊", category: "Polar" },
          ]
        },
        {
          instruction: "Sort capitals and countries! 🏛️🌍",
          category1: { name: "European", emoji: "🇪🇺", color: "#3b82f6" },
          category2: { name: "Asian", emoji: "🌏", color: "#ef4444" },
          items: [
            { id: 1, name: "Paris", emoji: "🇫🇷", category: "European" },
            { id: 2, name: "Tokyo", emoji: "🇯🇵", category: "Asian" },
            { id: 3, name: "Berlin", emoji: "🇩🇪", category: "European" },
            { id: 4, name: "Beijing", emoji: "🇨🇳", category: "Asian" },
            { id: 5, name: "Rome", emoji: "🇮🇹", category: "European" },
            { id: 6, name: "Seoul", emoji: "🇰🇷", category: "Asian" },
          ]
        }
      ],
      history: [
        {
          instruction: "Sort into BC and AD events! 📜",
          category1: { name: "BC (Before)", emoji: "🏛️", color: "#f59e0b" },
          category2: { name: "AD (After)", emoji: "⛪", color: "#8b5cf6" },
          items: [
            { id: 1, name: "Pyramids Built", emoji: "🔺", category: "BC (Before)" },
            { id: 2, name: "Internet", emoji: "🌐", category: "AD (After)" },
            { id: 3, name: "Roman Empire", emoji: "🏛️", category: "BC (Before)" },
            { id: 4, name: "Moon Landing", emoji: "🌙", category: "AD (After)" },
            { id: 5, name: "Greek Olympics", emoji: "🏅", category: "BC (Before)" },
            { id: 6, name: "World Wars", emoji: "⚔️", category: "AD (After)" },
          ]
        },
        {
          instruction: "Sort civilizations by location! 🌍",
          category1: { name: "Eastern", emoji: "🌏", color: "#ef4444" },
          category2: { name: "Western", emoji: "🌍", color: "#3b82f6" },
          items: [
            { id: 1, name: "China", emoji: "🇨🇳", category: "Eastern" },
            { id: 2, name: "Rome", emoji: "🇮🇹", category: "Western" },
            { id: 3, name: "Japan", emoji: "🇯🇵", category: "Eastern" },
            { id: 4, name: "Greece", emoji: "🇬🇷", category: "Western" },
            { id: 5, name: "India", emoji: "🇮🇳", category: "Eastern" },
            { id: 6, name: "Egypt", emoji: "🇪🇬", category: "Western" },
          ]
        },
        {
          instruction: "Sort by type of government! 👑🗳️",
          category1: { name: "Monarchy", emoji: "👑", color: "#f59e0b" },
          category2: { name: "Democracy", emoji: "🗳️", color: "#22c55e" },
          items: [
            { id: 1, name: "King Louis", emoji: "👑", category: "Monarchy" },
            { id: 2, name: "Athens", emoji: "🏛️", category: "Democracy" },
            { id: 3, name: "Pharaohs", emoji: "🔺", category: "Monarchy" },
            { id: 4, name: "USA Today", emoji: "🇺🇸", category: "Democracy" },
            { id: 5, name: "Queen Victoria", emoji: "👑", category: "Monarchy" },
            { id: 6, name: "Modern France", emoji: "🇫🇷", category: "Democracy" },
          ]
        }
      ],
      language: [
        {
          instruction: "Sort words into Synonyms and Antonyms of 'Happy'! 📝",
          category1: { name: "Synonyms", emoji: "😊", color: "#22c55e" },
          category2: { name: "Antonyms", emoji: "😢", color: "#ef4444" },
          items: [
            { id: 1, name: "Joyful", emoji: "🎉", category: "Synonyms" },
            { id: 2, name: "Sad", emoji: "😢", category: "Antonyms" },
            { id: 3, name: "Cheerful", emoji: "😄", category: "Synonyms" },
            { id: 4, name: "Miserable", emoji: "😞", category: "Antonyms" },
            { id: 5, name: "Delighted", emoji: "🥳", category: "Synonyms" },
            { id: 6, name: "Gloomy", emoji: "😔", category: "Antonyms" },
          ]
        },
        {
          instruction: "Sort into Synonyms and Antonyms of 'Big'! 📏",
          category1: { name: "Synonyms", emoji: "🦣", color: "#22c55e" },
          category2: { name: "Antonyms", emoji: "🐜", color: "#ef4444" },
          items: [
            { id: 1, name: "Huge", emoji: "🏔️", category: "Synonyms" },
            { id: 2, name: "Tiny", emoji: "🐜", category: "Antonyms" },
            { id: 3, name: "Enormous", emoji: "🦣", category: "Synonyms" },
            { id: 4, name: "Small", emoji: "🐁", category: "Antonyms" },
            { id: 5, name: "Giant", emoji: "🗿", category: "Synonyms" },
            { id: 6, name: "Little", emoji: "🔬", category: "Antonyms" },
          ]
        },
        {
          instruction: "Sort by parts of speech! 📚",
          category1: { name: "Adverbs", emoji: "🏃", color: "#8b5cf6" },
          category2: { name: "Prepositions", emoji: "📍", color: "#f59e0b" },
          items: [
            { id: 1, name: "Quickly", emoji: "⚡", category: "Adverbs" },
            { id: 2, name: "Under", emoji: "⬇️", category: "Prepositions" },
            { id: 3, name: "Slowly", emoji: "🐢", category: "Adverbs" },
            { id: 4, name: "Above", emoji: "⬆️", category: "Prepositions" },
            { id: 5, name: "Happily", emoji: "😊", category: "Adverbs" },
            { id: 6, name: "Between", emoji: "↔️", category: "Prepositions" },
          ]
        }
      ],
      financial: [
        {
          instruction: "Sort into Needs and Wants! 💰",
          category1: { name: "Needs", emoji: "🏠", color: "#3b82f6" },
          category2: { name: "Wants", emoji: "🎮", color: "#f59e0b" },
          items: [
            { id: 1, name: "Food", emoji: "🍞", category: "Needs" },
            { id: 2, name: "Video Games", emoji: "🎮", category: "Wants" },
            { id: 3, name: "Water", emoji: "💧", category: "Needs" },
            { id: 4, name: "Toys", emoji: "🧸", category: "Wants" },
            { id: 5, name: "Shelter", emoji: "🏠", category: "Needs" },
            { id: 6, name: "Candy", emoji: "🍬", category: "Wants" },
          ]
        },
        {
          instruction: "Sort into Income and Expenses! 💵",
          category1: { name: "Income", emoji: "💵", color: "#22c55e" },
          category2: { name: "Expenses", emoji: "🛒", color: "#ef4444" },
          items: [
            { id: 1, name: "Allowance", emoji: "💵", category: "Income" },
            { id: 2, name: "Buying Food", emoji: "🛒", category: "Expenses" },
            { id: 3, name: "Birthday Money", emoji: "🎂", category: "Income" },
            { id: 4, name: "Rent", emoji: "🏠", category: "Expenses" },
            { id: 5, name: "Job Payment", emoji: "💼", category: "Income" },
            { id: 6, name: "Electric Bill", emoji: "💡", category: "Expenses" },
          ]
        },
        {
          instruction: "Sort into Saving and Spending! 🏦",
          category1: { name: "Good Saving", emoji: "🏦", color: "#22c55e" },
          category2: { name: "Impulse Spending", emoji: "🛍️", color: "#ef4444" },
          items: [
            { id: 1, name: "Piggy Bank", emoji: "🐷", category: "Good Saving" },
            { id: 2, name: "Buying on Sale", emoji: "🏷️", category: "Impulse Spending" },
            { id: 3, name: "Emergency Fund", emoji: "🏦", category: "Good Saving" },
            { id: 4, name: "Random Toys", emoji: "🧸", category: "Impulse Spending" },
            { id: 5, name: "College Fund", emoji: "🎓", category: "Good Saving" },
            { id: 6, name: "Junk Food", emoji: "🍟", category: "Impulse Spending" },
          ]
        }
      ],
      sel: [
        {
          instruction: "Sort into Positive and Negative Emotions! 😊",
          category1: { name: "Positive", emoji: "😊", color: "#22c55e" },
          category2: { name: "Negative", emoji: "😠", color: "#ef4444" },
          items: [
            { id: 1, name: "Happy", emoji: "😊", category: "Positive" },
            { id: 2, name: "Angry", emoji: "😠", category: "Negative" },
            { id: 3, name: "Excited", emoji: "🤩", category: "Positive" },
            { id: 4, name: "Jealous", emoji: "😒", category: "Negative" },
            { id: 5, name: "Grateful", emoji: "🙏", category: "Positive" },
            { id: 6, name: "Frustrated", emoji: "😤", category: "Negative" },
          ]
        },
        {
          instruction: "Sort into Good and Bad Responses! 🤔",
          category1: { name: "Good Response", emoji: "👍", color: "#22c55e" },
          category2: { name: "Bad Response", emoji: "👎", color: "#ef4444" },
          items: [
            { id: 1, name: "Take Deep Breaths", emoji: "🌬️", category: "Good Response" },
            { id: 2, name: "Yell at Others", emoji: "😤", category: "Bad Response" },
            { id: 3, name: "Talk About It", emoji: "💬", category: "Good Response" },
            { id: 4, name: "Hit Things", emoji: "👊", category: "Bad Response" },
            { id: 5, name: "Ask for Help", emoji: "🙋", category: "Good Response" },
            { id: 6, name: "Give Up", emoji: "😞", category: "Bad Response" },
          ]
        },
        {
          instruction: "Sort social skills! 🤝",
          category1: { name: "Good Skills", emoji: "🤝", color: "#22c55e" },
          category2: { name: "Needs Work", emoji: "⚠️", color: "#f59e0b" },
          items: [
            { id: 1, name: "Listening", emoji: "👂", category: "Good Skills" },
            { id: 2, name: "Interrupting", emoji: "🗣️", category: "Needs Work" },
            { id: 3, name: "Sharing", emoji: "🤲", category: "Good Skills" },
            { id: 4, name: "Being Bossy", emoji: "👆", category: "Needs Work" },
            { id: 5, name: "Being Kind", emoji: "💗", category: "Good Skills" },
            { id: 6, name: "Ignoring", emoji: "🙈", category: "Needs Work" },
          ]
        }
      ],
      critical: [
        {
          instruction: "Sort into Facts and Opinions! 🧠",
          category1: { name: "Facts", emoji: "📊", color: "#3b82f6" },
          category2: { name: "Opinions", emoji: "💭", color: "#8b5cf6" },
          items: [
            { id: 1, name: "Earth is round", emoji: "🌍", category: "Facts" },
            { id: 2, name: "Pizza is the best", emoji: "🍕", category: "Opinions" },
            { id: 3, name: "Water boils at 100°C", emoji: "💧", category: "Facts" },
            { id: 4, name: "Blue is prettiest", emoji: "🔵", category: "Opinions" },
            { id: 5, name: "Humans need oxygen", emoji: "🫁", category: "Facts" },
            { id: 6, name: "Dogs are cuter", emoji: "🐕", category: "Opinions" },
          ]
        },
        {
          instruction: "Sort into Cause and Effect! 🔗",
          category1: { name: "Cause", emoji: "💥", color: "#ef4444" },
          category2: { name: "Effect", emoji: "➡️", color: "#22c55e" },
          items: [
            { id: 1, name: "Rain", emoji: "🌧️", category: "Cause" },
            { id: 2, name: "Wet Ground", emoji: "💧", category: "Effect" },
            { id: 3, name: "Study Hard", emoji: "📚", category: "Cause" },
            { id: 4, name: "Good Grades", emoji: "📝", category: "Effect" },
            { id: 5, name: "Exercise", emoji: "🏃", category: "Cause" },
            { id: 6, name: "Stronger Body", emoji: "💪", category: "Effect" },
          ]
        },
        {
          instruction: "Sort by reliability of source! 📰",
          category1: { name: "Reliable", emoji: "✅", color: "#22c55e" },
          category2: { name: "Unreliable", emoji: "⚠️", color: "#f59e0b" },
          items: [
            { id: 1, name: "Encyclopedia", emoji: "📚", category: "Reliable" },
            { id: 2, name: "Random Website", emoji: "🌐", category: "Unreliable" },
            { id: 3, name: "Science Journal", emoji: "🔬", category: "Reliable" },
            { id: 4, name: "Rumors", emoji: "👂", category: "Unreliable" },
            { id: 5, name: "Textbook", emoji: "📖", category: "Reliable" },
            { id: 6, name: "Social Media", emoji: "📱", category: "Unreliable" },
          ]
        }
      ]
    }
  };

  return sortingData[ageGroup]?.[mappedSubject] || sortingData[ageGroup]?.math || sortingData.preschool.food;
};

export const getStoryData = (ageGroup, subject) => {
  // Map the topic ID to the internal subject type
  const mappedSubject = topicToSubjectMap[subject] || subject;
  const stories = {
    preschool: {
      math: {
        title: 'The Counting Adventure',
        scenes: [
          {
            text: 'Bunny wants to pick apples. He sees 2 red apples and 1 green apple on the tree.',
            question: 'How many apples does Bunny see in total?',
            choices: ['2 apples', '3 apples', '4 apples', '1 apple'],
            correctChoice: 1,
            explanation: 'Great! 2 red apples + 1 green apple = 3 apples total!'
          },
          {
            text: 'Bunny picks 3 apples and puts them in his basket. Then he eats 1 apple.',
            question: 'How many apples are left in the basket?',
            choices: ['1 apple', '2 apples', '3 apples', '4 apples'],
            correctChoice: 1,
            explanation: 'Correct! He had 3 apples and ate 1, so 2 apples are left!'
          },
          {
            text: 'Bunny shares his 2 apples with his friend. He gives his friend 1 apple.',
            question: 'How many apples does Bunny have now?',
            choices: ['0 apples', '1 apple', '2 apples', '3 apples'],
            correctChoice: 1,
            explanation: 'Perfect! Sharing is caring! Bunny has 1 apple left.'
          }
        ]
      },
      language: {
        title: 'Letter Land Adventure',
        scenes: [
          {
            text: 'Little Bear is learning letters. He sees the letter "B" on a sign.',
            question: 'What letter is Bear learning about?',
            choices: ['A', 'B', 'C', 'D'],
            correctChoice: 1,
            explanation: 'Yes! B is for Bear!'
          },
          {
            text: 'Bear finds things that start with B: a ball, a book, and a bee.',
            question: 'Which word does NOT start with B?',
            choices: ['Ball', 'Book', 'Cat', 'Bee'],
            correctChoice: 2,
            explanation: 'Right! Cat starts with C, not B!'
          },
          {
            text: 'Bear is happy! He learned about the letter B today.',
            question: 'What sound does B make?',
            choices: ['Mmm', 'Buh', 'Sss', 'Fff'],
            correctChoice: 1,
            explanation: 'Perfect! B makes the "buh" sound!'
          }
        ]
      },
      science: {
        title: 'Nature Explorer',
        scenes: [
          {
            text: 'Lily finds a seed in the garden. She wants to plant it.',
            question: 'What does the seed need to grow?',
            choices: ['Toys', 'Water and sunlight', 'Books', 'Candy'],
            correctChoice: 1,
            explanation: 'Excellent! Seeds need water and sunlight to grow into plants!'
          },
          {
            text: 'Lily waters the seed every day. After some time, a small plant appears!',
            question: 'What part grows first from the seed?',
            choices: ['Flower', 'Root', 'Leaf', 'Fruit'],
            correctChoice: 1,
            explanation: 'Good job! The root grows first to get water from the soil!'
          },
          {
            text: 'The plant grows bigger and gets green leaves. Lily is so happy!',
            question: 'Why are the leaves green?',
            choices: ['They are painted', 'Because of chlorophyll', 'They are sick', 'Magic'],
            correctChoice: 1,
            explanation: 'Amazing! Chlorophyll makes leaves green and helps plants make food!'
          }
        ]
      },
      colors: {
        title: 'Rainbow Magic',
        scenes: [
          {
            text: 'Chloe the cat finds a beautiful rainbow in the sky after the rain!',
            question: 'What color comes first at the top of a rainbow?',
            choices: ['Blue', 'Green', 'Red', 'Yellow'],
            correctChoice: 2,
            explanation: 'Great! Red is always at the top of a rainbow!'
          },
          {
            text: 'Chloe wants to paint. She mixes red paint and yellow paint together.',
            question: 'What color does Chloe make?',
            choices: ['Purple', 'Green', 'Orange', 'Blue'],
            correctChoice: 2,
            explanation: 'Perfect! Red + Yellow = Orange!'
          },
          {
            text: 'Now Chloe mixes blue paint and yellow paint to make something new!',
            question: 'What color does blue and yellow make?',
            choices: ['Red', 'Purple', 'Green', 'Orange'],
            correctChoice: 2,
            explanation: 'Wonderful! Blue + Yellow = Green!'
          }
        ]
      },
      animals: {
        title: 'Animal Friends',
        scenes: [
          {
            text: 'Danny Dog visits the farm! He sees an animal that says "Moo" and gives us milk.',
            question: 'What animal did Danny see?',
            choices: ['Pig', 'Cow', 'Chicken', 'Horse'],
            correctChoice: 1,
            explanation: 'Yes! Cows say "Moo" and give us milk!'
          },
          {
            text: 'Next, Danny sees a fluffy animal that gives us wool for sweaters.',
            question: 'What animal has fluffy wool?',
            choices: ['Duck', 'Goat', 'Sheep', 'Cat'],
            correctChoice: 2,
            explanation: 'Correct! Sheep have fluffy wool that keeps us warm!'
          },
          {
            text: 'Danny hears "Cock-a-doodle-doo!" in the morning. An animal wakes everyone up!',
            question: 'Which animal makes this sound?',
            choices: ['Rooster', 'Dog', 'Cat', 'Pig'],
            correctChoice: 0,
            explanation: 'Right! Roosters crow "Cock-a-doodle-doo" every morning!'
          }
        ]
      },
      safety: {
        title: 'Safety Star',
        scenes: [
          {
            text: 'Sammy wants to cross the street. He sees a traffic light with three colors.',
            question: 'What color means STOP?',
            choices: ['Green', 'Yellow', 'Red', 'Blue'],
            correctChoice: 2,
            explanation: 'Excellent! Red means STOP! Always wait for the green light!'
          },
          {
            text: 'Sammy is riding his bike in the park with his friends.',
            question: 'What should Sammy wear to protect his head?',
            choices: ['Hat', 'Helmet', 'Cap', 'Scarf'],
            correctChoice: 1,
            explanation: 'Great! Always wear a helmet when riding a bike to stay safe!'
          },
          {
            text: 'Sammy gets lost at the store. He needs help finding his mom.',
            question: 'Who should Sammy ask for help?',
            choices: ['A stranger outside', 'A store worker', 'Nobody', 'Go alone'],
            correctChoice: 1,
            explanation: 'Perfect! Ask a store worker or police officer for help if you get lost!'
          }
        ]
      },
      transportation: {
        title: 'Travel Adventure',
        scenes: [
          {
            text: 'Tommy wants to visit his grandma across the ocean. He needs to go very far!',
            question: 'What should Tommy travel in to cross the ocean quickly?',
            choices: ['Car', 'Bicycle', 'Airplane', 'Skateboard'],
            correctChoice: 2,
            explanation: 'Right! Airplanes fly high in the sky and cross oceans!'
          },
          {
            text: 'Tommy sees a vehicle with many wheels that runs on tracks. "Choo choo!"',
            question: 'What vehicle did Tommy see?',
            choices: ['Bus', 'Train', 'Truck', 'Boat'],
            correctChoice: 1,
            explanation: 'Correct! Trains run on tracks and say "Choo choo!"'
          },
          {
            text: 'Tommy sees a vehicle on the water with a sail that catches the wind.',
            question: 'What is this vehicle called?',
            choices: ['Submarine', 'Sailboat', 'Helicopter', 'Motorcycle'],
            correctChoice: 1,
            explanation: 'Yes! Sailboats use wind to move across the water!'
          }
        ]
      },
      daily: {
        title: 'My Daily Routine',
        scenes: [
          {
            text: 'It\'s morning! Daisy wakes up and wants to start her day right.',
            question: 'What should Daisy do first in the morning?',
            choices: ['Watch TV', 'Brush her teeth', 'Eat candy', 'Go outside'],
            correctChoice: 1,
            explanation: 'Good job! Brushing teeth keeps them clean and healthy!'
          },
          {
            text: 'After playing outside, Daisy\'s hands are dirty from the sandbox.',
            question: 'What should Daisy do before eating lunch?',
            choices: ['Wipe on clothes', 'Wash hands with soap', 'Just eat', 'Lick them'],
            correctChoice: 1,
            explanation: 'Perfect! Always wash your hands with soap before eating!'
          },
          {
            text: 'It\'s bedtime! Daisy is tired after a fun day of playing.',
            question: 'What helps Daisy sleep well?',
            choices: ['Eating candy', 'Watching scary movies', 'Reading a bedtime story', 'Running around'],
            correctChoice: 2,
            explanation: 'That\'s right! A calm bedtime story helps you relax and sleep well!'
          }
        ]
      },
      food: {
        title: 'Yummy Food Adventure',
        scenes: [
          {
            text: 'Freddy Fox is hungry! He wants to eat something healthy for strong bones.',
            question: 'What food helps make bones strong?',
            choices: ['Candy', 'Milk', 'Chips', 'Soda'],
            correctChoice: 1,
            explanation: 'Yes! Milk has calcium that makes our bones strong!'
          },
          {
            text: 'Freddy sees orange vegetables in the garden. They help us see better!',
            question: 'What vegetable is orange and good for eyes?',
            choices: ['Broccoli', 'Carrot', 'Potato', 'Onion'],
            correctChoice: 1,
            explanation: 'Correct! Carrots are orange and help our eyes stay healthy!'
          },
          {
            text: 'Freddy wants a sweet treat. His mom gives him something from a tree.',
            question: 'What healthy sweet snack grows on trees?',
            choices: ['Cookies', 'Apples', 'Ice cream', 'Cake'],
            correctChoice: 1,
            explanation: 'Great! Apples are sweet, healthy, and grow on trees!'
          }
        ]
      },
      nature: {
        title: 'Nature Explorer',
        scenes: [
          {
            text: 'Lily finds a seed in the garden. She wants to plant it.',
            question: 'What does the seed need to grow?',
            choices: ['Toys', 'Water and sunlight', 'Books', 'Candy'],
            correctChoice: 1,
            explanation: 'Excellent! Seeds need water and sunlight to grow into plants!'
          },
          {
            text: 'Lily waters the seed every day. After some time, a small plant appears!',
            question: 'What part grows first from the seed?',
            choices: ['Flower', 'Root', 'Leaf', 'Fruit'],
            correctChoice: 1,
            explanation: 'Good job! The root grows first to get water from the soil!'
          },
          {
            text: 'The plant grows bigger and gets green leaves. Lily is so happy!',
            question: 'Why are the leaves green?',
            choices: ['They are painted', 'Because of chlorophyll', 'They are sick', 'Magic'],
            correctChoice: 1,
            explanation: 'Amazing! Chlorophyll makes leaves green and helps plants make food!'
          }
        ]
      }
    },
    elementary: {
      math: {
        title: 'The Treasure Hunt',
        scenes: [
          {
            text: 'You find a treasure map! It says: "Take 10 steps forward, then 4 steps back."',
            question: 'How many steps forward are you from the start?',
            choices: ['4 steps', '6 steps', '10 steps', '14 steps'],
            correctChoice: 1,
            explanation: 'Correct! 10 - 4 = 6 steps forward from the start!'
          },
          {
            text: 'You find 3 chests. Each chest has 5 gold coins.',
            question: 'How many gold coins do you have in total?',
            choices: ['8 coins', '10 coins', '15 coins', '20 coins'],
            correctChoice: 2,
            explanation: 'Great! 3 chests × 5 coins = 15 gold coins!'
          },
          {
            text: 'You share your 15 coins equally with 2 friends. Everyone gets the same amount.',
            question: 'How many coins does each person get?',
            choices: ['3 coins', '5 coins', '6 coins', '7 coins'],
            correctChoice: 1,
            explanation: 'Perfect! 15 coins ÷ 3 people = 5 coins each!'
          }
        ]
      },
      language: {
        title: 'The Mystery Message',
        scenes: [
          {
            text: 'You receive a coded message: "The opposite of hot is ____"',
            question: 'What word completes the message?',
            choices: ['Warm', 'Cold', 'Cool', 'Fire'],
            correctChoice: 1,
            explanation: 'Correct! Cold is the opposite (antonym) of hot!'
          },
          {
            text: 'The next clue says: "I describe actions. I am a ____"',
            question: 'What part of speech is being described?',
            choices: ['Noun', 'Verb', 'Adjective', 'Number'],
            correctChoice: 1,
            explanation: 'Yes! Verbs are action words like run, jump, and think!'
          },
          {
            text: 'Final clue: "The word happy means the same as ____"',
            question: 'What is a synonym for happy?',
            choices: ['Sad', 'Joyful', 'Angry', 'Tired'],
            correctChoice: 1,
            explanation: 'Excellent! Joyful is a synonym (similar word) for happy!'
          }
        ]
      },
      science: {
        title: 'Space Mission',
        scenes: [
          {
            text: 'You are an astronaut! Mission Control asks: "Which planet are you standing on?"',
            question: 'What planet do humans live on?',
            choices: ['Mars', 'Earth', 'Jupiter', 'Venus'],
            correctChoice: 1,
            explanation: 'Correct! We live on planet Earth, the third planet from the Sun!'
          },
          {
            text: 'You look up and see the Moon. It is Earth\'s natural satellite.',
            question: 'Why does the Moon shine at night?',
            choices: ['It makes its own light', 'It reflects sunlight', 'It is on fire', 'Magic'],
            correctChoice: 1,
            explanation: 'Great! The Moon reflects light from the Sun, that\'s why we can see it!'
          },
          {
            text: 'Your spacecraft needs fuel. You learn that plants can make oxygen.',
            question: 'What process do plants use to make oxygen?',
            choices: ['Respiration', 'Photosynthesis', 'Digestion', 'Evaporation'],
            correctChoice: 1,
            explanation: 'Perfect! Photosynthesis is how plants make oxygen using sunlight!'
          }
        ]
      },
      geography: {
        title: 'Around the World Adventure',
        scenes: [
          {
            text: 'You are a young explorer! Your journey begins at the largest ocean on Earth, home to thousands of islands.',
            question: 'Which ocean are you exploring?',
            choices: ['Atlantic Ocean', 'Indian Ocean', 'Pacific Ocean', 'Arctic Ocean'],
            correctChoice: 2,
            explanation: 'Correct! The Pacific Ocean is the largest and deepest ocean on Earth!'
          },
          {
            text: 'Next, you fly to a continent with penguins, ice, and no permanent human residents.',
            question: 'Which continent did you visit?',
            choices: ['Arctic', 'Antarctica', 'Greenland', 'Iceland'],
            correctChoice: 1,
            explanation: 'Great! Antarctica is the coldest continent where penguins live!'
          },
          {
            text: 'Your final stop is a country shaped like a boot, famous for pizza and pasta!',
            question: 'What country are you in?',
            choices: ['France', 'Spain', 'Italy', 'Greece'],
            correctChoice: 2,
            explanation: 'Perfect! Italy is shaped like a boot and is famous for delicious food!'
          }
        ]
      },
      history: {
        title: 'Time Travel Tales',
        scenes: [
          {
            text: 'Your time machine takes you to ancient Egypt! You see workers building a huge triangular structure for the Pharaoh.',
            question: 'What are they building?',
            choices: ['A castle', 'A pyramid', 'A temple', 'A palace'],
            correctChoice: 1,
            explanation: 'Correct! The ancient Egyptians built pyramids as tombs for their Pharaohs!'
          },
          {
            text: 'Next stop: 1620! You see a ship called the Mayflower arriving at a new land.',
            question: 'Where did the Mayflower land?',
            choices: ['England', 'America', 'Australia', 'Africa'],
            correctChoice: 1,
            explanation: 'Great! The Pilgrims on the Mayflower landed in America to start a new life!'
          },
          {
            text: 'Final journey: You meet a man with a kite during a thunderstorm, discovering electricity!',
            question: 'Who is this famous inventor?',
            choices: ['Thomas Edison', 'Benjamin Franklin', 'Albert Einstein', 'Isaac Newton'],
            correctChoice: 1,
            explanation: 'Perfect! Benjamin Franklin discovered that lightning is electricity with his famous kite experiment!'
          }
        ]
      },
      art: {
        title: 'The Art Studio Mystery',
        scenes: [
          {
            text: 'You visit a famous art studio! The artist shows you a painting with only red, blue, and yellow paint.',
            question: 'What are these three colors called?',
            choices: ['Secondary colors', 'Primary colors', 'Pastel colors', 'Dark colors'],
            correctChoice: 1,
            explanation: 'Correct! Red, blue, and yellow are primary colors - you can mix them to make all other colors!'
          },
          {
            text: 'The artist mixes blue and yellow paint together on the canvas.',
            question: 'What color will they create?',
            choices: ['Orange', 'Purple', 'Green', 'Brown'],
            correctChoice: 2,
            explanation: 'Great! Blue + Yellow = Green! Green is a secondary color.'
          },
          {
            text: 'The artist shows you a famous painting of a starry night with swirling stars.',
            question: 'Who painted "The Starry Night"?',
            choices: ['Pablo Picasso', 'Vincent van Gogh', 'Leonardo da Vinci', 'Claude Monet'],
            correctChoice: 1,
            explanation: 'Perfect! Vincent van Gogh painted "The Starry Night" - one of the most famous paintings ever!'
          }
        ]
      },
      health: {
        title: 'The Wellness Journey',
        scenes: [
          {
            text: 'Coach Sam asks: "How much water should kids drink every day to stay healthy?"',
            question: 'About how many glasses of water should you drink daily?',
            choices: ['1-2 glasses', '3-4 glasses', '6-8 glasses', '12 glasses'],
            correctChoice: 2,
            explanation: 'Correct! Drinking 6-8 glasses of water helps keep your body hydrated and healthy!'
          },
          {
            text: 'Its time for exercise! Coach Sam says exercise helps your body in many ways.',
            question: 'How long should kids exercise every day?',
            choices: ['10 minutes', '30 minutes', '60 minutes', '3 hours'],
            correctChoice: 2,
            explanation: 'Great! Kids should be active for about 60 minutes (1 hour) every day!'
          },
          {
            text: 'Time for bed! Coach Sam reminds you that sleep is important for growing.',
            question: 'How many hours of sleep do kids ages 6-8 need?',
            choices: ['5-6 hours', '7-8 hours', '9-11 hours', '14 hours'],
            correctChoice: 2,
            explanation: 'Perfect! Kids need 9-11 hours of sleep to grow, learn, and stay healthy!'
          }
        ]
      },
      truefalse: {
        title: 'The Fact Finder',
        scenes: [
          {
            text: 'Welcome to the Fact Finder game! Detective Max has a statement: "The Earth is flat."',
            question: 'Is this statement TRUE or FALSE?',
            choices: ['True', 'False'],
            correctChoice: 1,
            explanation: 'Correct! This is FALSE - The Earth is actually round like a ball (sphere)!'
          },
          {
            text: 'Detective Max shows another fact: "Dolphins are mammals, not fish."',
            question: 'Is this statement TRUE or FALSE?',
            choices: ['True', 'False'],
            correctChoice: 0,
            explanation: 'Great! This is TRUE - Dolphins are mammals! They breathe air and feed milk to their babies.'
          },
          {
            text: 'Final challenge! "The Great Wall of China can be seen from space with the naked eye."',
            question: 'Is this statement TRUE or FALSE?',
            choices: ['True', 'False'],
            correctChoice: 1,
            explanation: 'Correct! This is FALSE - The Great Wall is too thin to see from space without special cameras!'
          }
        ]
      }
    },
    advanced: {
      math: {
        title: 'The Math Challenge',
        scenes: [
          {
            text: 'A wizard gives you a riddle: "I am thinking of a number. When I multiply it by 5, I get 35."',
            question: 'What is the number?',
            choices: ['5', '6', '7', '8'],
            correctChoice: 2,
            explanation: 'Excellent! 7 × 5 = 35. You solved the equation x × 5 = 35!'
          },
          {
            text: 'The wizard is impressed! Next challenge: "What is 20% of 150?"',
            question: 'What is the answer?',
            choices: ['20', '25', '30', '35'],
            correctChoice: 2,
            explanation: 'Perfect! 20% = 1/5, and 150 ÷ 5 = 30!'
          },
          {
            text: 'Final test: "A square garden has a perimeter of 36 meters."',
            question: 'What is the length of one side?',
            choices: ['6 meters', '9 meters', '12 meters', '18 meters'],
            correctChoice: 1,
            explanation: 'Brilliant! Perimeter of square = 4 × side, so 36 ÷ 4 = 9 meters!'
          }
        ]
      },
      language: {
        title: 'The Literary Quest',
        scenes: [
          {
            text: 'You enter a library where books come alive! A book asks: "What am I? The wind whispered through the trees."',
            question: 'What literary device is being used?',
            choices: ['Simile', 'Metaphor', 'Personification', 'Alliteration'],
            correctChoice: 2,
            explanation: 'Correct! Personification gives human qualities (whispered) to non-human things (wind)!'
          },
          {
            text: 'Another book challenges you: "Transform me! Swim → Swimming → ____"',
            question: 'What is the past participle of swim?',
            choices: ['Swam', 'Swimming', 'Swum', 'Swimmed'],
            correctChoice: 2,
            explanation: 'Excellent! The past participle of swim is swum (have swum)!'
          },
          {
            text: 'The final book asks: "She ran QUICKLY home. What type of word is QUICKLY?"',
            question: 'What part of speech is "quickly"?',
            choices: ['Noun', 'Verb', 'Adjective', 'Adverb'],
            correctChoice: 3,
            explanation: 'Perfect! Quickly is an adverb - it describes HOW she ran!'
          }
        ]
      },
      science: {
        title: 'The Science Laboratory',
        scenes: [
          {
            text: 'Professor asks: "What happens to water at 100°C at sea level?"',
            question: 'What state change occurs?',
            choices: ['Freezing', 'Boiling', 'Melting', 'Condensing'],
            correctChoice: 1,
            explanation: 'Correct! Water boils at 100°C (212°F) and becomes water vapor!'
          },
          {
            text: 'Next experiment: "Inside every cell, there is a control center."',
            question: 'What is this control center called?',
            choices: ['Membrane', 'Nucleus', 'Cytoplasm', 'Mitochondria'],
            correctChoice: 1,
            explanation: 'Great! The nucleus controls the cell and contains DNA!'
          },
          {
            text: 'Final question: "What force keeps us on the ground and makes things fall?"',
            question: 'What is this force?',
            choices: ['Magnetism', 'Electricity', 'Gravity', 'Friction'],
            correctChoice: 2,
            explanation: 'Excellent! Gravity is the force that attracts objects toward Earth!'
          }
        ]
      },
      geography: {
        title: 'World Explorer Adventure',
        scenes: [
          {
            text: 'You are a world explorer! Your first stop is the largest continent on Earth, home to the Great Wall.',
            question: 'Which continent are you visiting?',
            choices: ['Africa', 'Europe', 'Asia', 'North America'],
            correctChoice: 2,
            explanation: 'Correct! Asia is the largest continent, and China\'s Great Wall is there!'
          },
          {
            text: 'Next, you sail to a continent surrounded entirely by water, famous for kangaroos and koalas.',
            question: 'Where are you now?',
            choices: ['South America', 'Africa', 'Australia', 'Antarctica'],
            correctChoice: 2,
            explanation: 'Great! Australia is the only country that is also a continent!'
          },
          {
            text: 'Your final destination is the river that flows through 11 countries in Africa, the longest river in the world!',
            question: 'What river is this?',
            choices: ['Amazon', 'Mississippi', 'Yangtze', 'Nile'],
            correctChoice: 3,
            explanation: 'Perfect! The Nile River is about 6,650 km long!'
          }
        ]
      },
      history: {
        title: 'Time Traveler\'s Journey',
        scenes: [
          {
            text: 'You travel back to Ancient Egypt, 2560 BC. Workers are building a massive triangular structure for the Pharaoh.',
            question: 'What are they building?',
            choices: ['Temple', 'Palace', 'Pyramid', 'Sphinx'],
            correctChoice: 2,
            explanation: 'Correct! The Great Pyramid of Giza was built as a tomb for Pharaoh Khufu!'
          },
          {
            text: 'Next stop: 1969! You watch as astronauts step onto a gray, dusty surface for the first time in human history.',
            question: 'Where did they land?',
            choices: ['Mars', 'The Moon', 'Venus', 'Space Station'],
            correctChoice: 1,
            explanation: 'Amazing! Neil Armstrong and Buzz Aldrin were the first humans on the Moon!'
          },
          {
            text: 'Final destination: 1776 in Philadelphia. Leaders are signing an important document declaring freedom from Britain.',
            question: 'What document is being signed?',
            choices: ['Constitution', 'Bill of Rights', 'Declaration of Independence', 'Magna Carta'],
            correctChoice: 2,
            explanation: 'Excellent! The Declaration of Independence was signed on July 4, 1776!'
          }
        ]
      }
    }
  };

  const mixed = (age) => {
    return stories[age]?.math || stories.preschool.math;
  };

  if (mappedSubject === 'mixed') {
    return mixed(ageGroup);
  }

  // Map preschool topics to appropriate story sets
  const storyMapping = {
    abc: 'language',
    counting: 'math',
    colors: 'colors',
    animals: 'animals',
    safety: 'safety',
    transportation: 'transportation',
    reading: 'language',
    nature: 'nature',
    daily: 'daily',
    food: 'food'
  };
  
  const storySubject = storyMapping[mappedSubject] || mappedSubject;
  return stories[ageGroup]?.[storySubject] || stories[ageGroup]?.math || stories.preschool.math;
};
